import {Base64}from'js-base64';import*as accounting from'accounting';import {format,fromUnixTime,formatDistanceToNow}from'date-fns';import axios from'axios';const tokenDecode = e => {
  if (!e) return !1;
  const s = (e.split(".")[1] || "").replace("-", "+").replace("_", "/"),
    o = Base64.decode(s) || "{}",
    r = JSON.parse(o);
  if (r.sub) {
    const e = JSON.parse(r.sub);
    r.sub = e;
  }
  return r;
};const permissionLevels = [[], ["delete"], ["write"], ["write", "delete"], ["read"], ["read", "delete"], ["read", "write"], ["read", "write", "delete"]];
function getPermissionLevel(e) {
  if (!Array.isArray(e)) throw new Error("The input must be a list");
  const s = e.concat().sort();
  let r = null;
  if (Object.entries(permissionLevels).forEach(([e, t]) => {
    if (s.length === t.length) {
      let i = !0;
      const o = t.concat().sort();
      for (let e = 0; e < s.length; e += 1) {
        if ("string" != typeof s[e]) throw new Error("The list items must be strings");
        s[e] !== o[e] && (i = !1);
      }
      i && (r = Number(e));
    }
  }), r) return r;
  throw new Error(`Invalid permissions "${e}"`);
}
const permissionResources = ["account", "users", "user-roles", "addresses", "tickets", "invoices", "payments", "credits", "orders", "creditcards", "affiliate-settings", "services", "dns", "billing", "technical", "abuse", "affiliate", "public"];
function humanReadablePerms(e = {}) {
  const s = {};
  return permissionResources.forEach(r => {
    const t = e[r.toUpperCase()];
    s[r] = Object.values(permissionLevels)[t] || [];
  }), s;
}
function hasPermission(e, s, r) {
  return !!(e && e.verified && s && r && e.permissions[r.toLowerCase()]) && e.permissions[r.toLowerCase()].includes(s);
}const isBetaTester = (e, t) => !!e.beta_tester || !1 === t?.beta?.feature;var index$6 = {
  tokenDecode: tokenDecode,
  hasPermission: hasPermission,
  isBetaTester: isBetaTester
};const moneyFormat = (e, o = {}) => {
  const t = Number.isInteger(o.precision) ? o.precision : 2,
    r = "string" == typeof e ? e.replace(",", "") : e;
  let n = parseFloat(r);
  Number.isNaN(n) && (n = 0);
  let c = accounting.formatMoney(n, {
    precision: t
  }).replace(/(.*\.\d{2}.*?)(0*)$/, "$1");
  const s = c.split(".");
  switch (o.portion) {
    case "dollars":
      [c] = s;
      break;
    case "cents":
      c = s[1] || "";
  }
  return c;
};var money=/*#__PURE__*/Object.freeze({__proto__:null,moneyFormat:moneyFormat});const ARRAY = "array",
  BIT = "bit",
  BITS = "bits",
  BYTE = "byte",
  BYTES = "bytes",
  EMPTY = "",
  EXPONENT = "exponent",
  FUNCTION = "function",
  IEC = "iec",
  INVALID_NUMBER = "Invalid number",
  INVALID_ROUND = "Invalid rounding method",
  JEDEC = "jedec",
  OBJECT = "object",
  PERIOD = ".",
  ROUND = "round",
  S = "s",
  SI = "si",
  SI_KBIT = "kbit",
  SI_KBYTE = "kB",
  SPACE = " ",
  STRING = "string",
  ZERO = "0",
  STRINGS = {
    symbol: {
      iec: {
        bits: ["bit", "Kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"],
        bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      },
      jedec: {
        bits: ["bit", "Kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"],
        bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }
    },
    fullform: {
      iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
      jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"]
    }
  };
function filesize(i, {
  bits: t = !1,
  pad: e = !1,
  base: o = -1,
  round: n = 2,
  locale: r = EMPTY,
  localeOptions: a = {},
  separator: l = EMPTY,
  spacer: s = SPACE,
  symbols: b = {},
  standard: E = EMPTY,
  output: T = STRING,
  fullform: I = !1,
  fullforms: p = [],
  exponent: B = -1,
  roundingMethod: u = ROUND,
  precision: N = 0
} = {}) {
  let c = B,
    f = Number(i),
    d = [],
    M = 0,
    P = EMPTY;
  E === SI ? (o = 10, E = JEDEC) : E === IEC || E === JEDEC ? o = 2 : 2 === o ? E = IEC : (o = 10, E = JEDEC);
  const R = 10 === o ? 1e3 : 1024,
    Y = !0 === I,
    m = f < 0,
    g = Math[u];
  if ("bigint" != typeof i && isNaN(i)) throw new TypeError(INVALID_NUMBER);
  if (typeof g !== FUNCTION) throw new TypeError(INVALID_ROUND);
  if (m && (f = -f), (-1 === c || isNaN(c)) && (c = Math.floor(Math.log(f) / Math.log(R)), c < 0 && (c = 0)), c > 8 && (N > 0 && (N += 8 - c), c = 8), T === EXPONENT) return c;
  if (0 === f) d[0] = 0, P = d[1] = STRINGS.symbol[E][t ? BITS : BYTES][c];else {
    M = f / (2 === o ? Math.pow(2, 10 * c) : Math.pow(1e3, c)), t && (M *= 8, M >= R && c < 8 && (M /= R, c++));
    const i = Math.pow(10, c > 0 ? n : 0);
    d[0] = g(M * i) / i, d[0] === R && c < 8 && -1 === B && (d[0] = 1, c++), P = d[1] = 10 === o && 1 === c ? t ? SI_KBIT : SI_KBYTE : STRINGS.symbol[E][t ? BITS : BYTES][c];
  }
  if (m && (d[0] = -d[0]), N > 0 && (d[0] = d[0].toPrecision(N)), d[1] = b[d[1]] || d[1], !0 === r ? d[0] = d[0].toLocaleString() : r.length > 0 ? d[0] = d[0].toLocaleString(r, a) : l.length > 0 && (d[0] = d[0].toString().replace(PERIOD, l)), e && !1 === Number.isInteger(d[0]) && n > 0) {
    const i = l || PERIOD,
      t = d[0].toString().split(i),
      e = t[1] || EMPTY,
      o = e.length,
      r = n - o;
    d[0] = `${t[0]}${i}${e.padEnd(o + r, ZERO)}`;
  }
  return Y && (d[1] = p[c] ? p[c] : STRINGS.fullform[E][c] + (t ? BIT : BYTE) + (1 === d[0] ? EMPTY : S)), T === ARRAY ? d : T === OBJECT ? {
    value: d[0],
    symbol: d[1],
    exponent: c,
    unit: P
  } : d.join(s);
}const toBytes = (e, t = "GB") => e * {
    kb: 1024,
    mb: 1048576,
    gb: 1024 ** 3,
    tb: 1024 ** 4
  }[t.toLowerCase()],
  sizeFormat = (e, t = {
    round: 0
  }) => {
    let o = parseFloat(e);
    return Number.isNaN(o) && (o = 0), filesize(o, {
      ...t,
      standard: "jedec"
    });
  },
  fromGBFormat = (e, t = 0) => sizeFormat(toBytes(e, "GB"), {
    round: t
  });var size=/*#__PURE__*/Object.freeze({__proto__:null,fromGBFormat:fromGBFormat,sizeFormat:sizeFormat,toBytes:toBytes});const capitalize = t => "string" != typeof t ? t : t.charAt(0).toUpperCase() + t.slice(1);
const tinyText = (t, e = 15, c = "...") => {
  const n = Math.floor(e / 2);
  return t?.length > e ? `${t.slice(0, n)}${c}${t.slice(t.length - (n + e % 2))}` : t;
};
const truncate = (t, e) => t?.length > e ? `${t.slice(0, e)}...` : t;var text=/*#__PURE__*/Object.freeze({__proto__:null,capitalize:capitalize,tinyText:tinyText,truncate:truncate});const dateFormat = (t, e) => {
    if (!t) return "";
    let r = e;
    return "string" != typeof e && (r = e ? "MMM d, yyyy h:mm a" : "MMM d, yyyy"), format(fromUnixTime(t), r);
  },
  dateFromUnixTime = t => fromUnixTime(t),
  timeSince = (t, e) => {
    const r = fromUnixTime(t);
    return formatDistanceToNow(r, {
      includeSeconds: !!e
    });
  },
  minutesFormat = t => {
    const e = t => {
      let e = `${t}`;
      for (; e.length < 2;) e = `0${e}`;
      return e;
    };
    return `${e(Math.floor(t / 60))}:${e(t % 60)}`;
  };var time=/*#__PURE__*/Object.freeze({__proto__:null,dateFormat:dateFormat,dateFromUnixTime:dateFromUnixTime,minutesFormat:minutesFormat,timeSince:timeSince});var index$5 = {
  money: money,
  size: size,
  text: text,
  time: time
};const DNS_ZONES = () => ({
  name: "dns-zones",
  route: "dns-zones",
  icon: {
    default: {
      icon: "fa-regular fa-globe"
    },
    hover: {
      icon: "fa-solid fa-globe"
    }
  },
  keywords: ["dns", "record", "zone"]
});
const RDNS_RECORDS = () => ({
  name: "rdns-records",
  route: "rdns-records",
  icon: {
    default: {
      icon: "fa-regular fa-cabinet-filing"
    },
    hover: {
      icon: "fa-solid fa-cabinet-filing"
    }
  },
  keywords: ["reverse", "ptr", "pointer", "dns", "record", "zone"]
});const mainLinks$1 = (s = {}) => hasPermission(s, "read", "dns") ? [DNS_ZONES()] : [],
  getNexcessDNSLinks = (s = {}, n = {}) => {
    const i = mainLinks$1(s);
    return hasPermission(s, "read", "dns") && n.hasRdns && i.push(RDNS_RECORDS()), i;
  },
  getThermoDNSLinks = s => mainLinks$1(s);var dns$2=/*#__PURE__*/Object.freeze({__proto__:null,getNexcessDNSLinks:getNexcessDNSLinks,getThermoDNSLinks:getThermoDNSLinks});const CREDITS$1 = () => ({
  name: "credits",
  route: "credits",
  icon: {
    default: {
      icon: "fa-regular fa-sparkles"
    },
    hover: {
      icon: "fa-solid fa-sparkles"
    }
  },
  keywords: ["credit", "credits", "refund", "promo", "redeem", "code"]
});
const INVOICES = () => ({
  name: "invoices",
  route: "invoices",
  icon: {
    default: {
      icon: "fa-regular fa-file-invoice-dollar"
    },
    hover: {
      icon: "fa-solid fa-file-invoice-dollar"
    }
  },
  keywords: ["invoice", "invoices", "pay", "payment", "payments"]
});
const ORDERS = () => ({
  name: "orders",
  route: "orders",
  icon: {
    default: {
      icon: "fa-regular fa-cart-shopping"
    },
    hover: {
      icon: "fa-solid fa-cart-shopping"
    }
  },
  keywords: ["order", "orders"]
});
const PAYMENT_INFO = () => ({
  name: "payment-info",
  route: "payment-info",
  icon: {
    default: {
      icon: "fa-regular fa-credit-card"
    },
    hover: {
      icon: "fa-solid fa-credit-card"
    }
  },
  keywords: ["address", "credit", "card", "tax", "exempt", "exemption"]
});
const PAYMENTS$1 = () => ({
  name: "payments",
  route: "payments",
  icon: {
    default: {
      icon: "fa-regular fa-receipt"
    },
    hover: {
      icon: "fa-solid fa-receipt"
    }
  },
  keywords: ["payment", "payments", "pay"]
});const mainLinks = (s = {}) => {
    const i = [];
    return hasPermission(s, "read", "invoices") && i.push(INVOICES()), hasPermission(s, "read", "credits") && i.push(CREDITS$1()), hasPermission(s, "read", "payments") && i.push(PAYMENTS$1()), (hasPermission(s, "read", "addresses") || hasPermission(s, "read", "creditcards") || hasPermission(s, "read", "account")) && i.push(PAYMENT_INFO()), i;
  },
  getNexcessBillingLinks = s => {
    const i = mainLinks(s);
    return hasPermission(s, "read", "orders") && i.push(ORDERS()), i;
  },
  getThermoBillingLinks = s => mainLinks(s);var billing=/*#__PURE__*/Object.freeze({__proto__:null,getNexcessBillingLinks:getNexcessBillingLinks,getThermoBillingLinks:getThermoBillingLinks});class LinksBuilder {
  constructor(_i) {
    this.addLink = i => {
      i.name && void 0 !== this.links[i.name] && (this.links[i.name] = i);
    };
    this.getLinks = () => Object.values(this.links).filter(i => i);
    this.links = {
      ..._i
    };
  }
}const ANALYTICS$2 = () => ({
  name: "analytics",
  route: "plan-site-dev-analytics",
  icon: {
    default: {
      icon: "fa-regular fa-chart-line"
    },
    hover: {
      icon: "fa-solid fa-chart-line"
    }
  },
  keywords: ["analytics", "disk", "space", "cdn", "content", "delivery", "usage", "php-fpm", "php", "statistics", "bandwidth"],
  advanced: !0
});
const BACKUP$1 = () => ({
  name: "backup",
  route: "plan-site-dev-backups",
  icon: {
    default: {
      icon: "fa-regular fa-hard-drive"
    },
    hover: {
      icon: "fa-solid fa-hard-drive"
    }
  },
  keywords: ["backup", "backups", "daily", "archive", "recover", "recovery", "restore"]
});
const CONTAINERS$2 = () => ({
  name: "containers",
  route: "plan-site-dev-containers",
  icon: {
    default: {
      icon: "fa-regular fa-box"
    },
    hover: {
      icon: "fa-solid fa-box"
    }
  },
  keywords: ["container", "containers", "elasticsearch", "elastic", "rabbitmq", "rabbit", "mq", "solr"],
  advanced: !0
});
const CONTROL_PANEL$2 = ({
  admin: e = !1
}) => {
  const a = {
    name: "control-panel",
    route: "plan-site-dev-control-panel",
    icon: {
      default: {
        icon: "fa-regular fa-square-sliders-vertical"
      },
      hover: {
        icon: "fa-solid fa-square-sliders-vertical"
      }
    },
    keywords: ["siteworx", "worx", "control", "panel", "cpanel"],
    advanced: !0
  };
  return e && (a.admin = !0), a;
};
const CREDENTIALS$2 = () => ({
  name: "credentials",
  route: "plan-site-dev-credentials",
  icon: {
    default: {
      icon: "fa-regular fa-id-badge"
    },
    hover: {
      icon: "fa-solid fa-id-badge"
    }
  },
  keywords: ["ssh", "sftp", "login", "credentials", "access", "ftp", "redis", "cache", "username", "user", "ip", "address"]
});
const DATABASES$2 = () => ({
  name: "databases",
  route: "plan-site-dev-databases",
  icon: {
    default: {
      icon: "fa-regular fa-database"
    },
    hover: {
      icon: "fa-solid fa-database"
    }
  },
  keywords: ["user", "username", "pass", "password", "mysql", "sql", "database", "db", "phpMyAdmin", "myadmin"],
  advanced: !0
});
const DOMAINS$2 = () => ({
  name: "domain-options",
  route: "plan-site-dev-domains",
  icon: {
    default: {
      icon: "fa-regular fa-code"
    },
    hover: {
      icon: "fa-solid fa-code"
    }
  },
  keywords: ["site", "domain", "domains"],
  advanced: !0
});
const EMAIL$2 = () => ({
  name: "email",
  route: "plan-site-dev-email",
  icon: {
    default: {
      icon: "fa-regular fa-envelope"
    },
    hover: {
      icon: "fa-solid fa-envelope"
    }
  },
  keywords: ["mail", "mailbox", "e-mail", "email", "box", "boxes", "webmail", "local", "delivery"]
});
const LOGS$1 = () => ({
  name: "logs",
  route: "plan-site-dev-logs",
  icon: {
    default: {
      icon: "fa-regular fa-table-list"
    },
    hover: {
      icon: "fa-solid fa-table-list"
    }
  },
  keywords: ["log", "logs", "report"],
  advanced: !0
});
const MANAGEMENT$2 = () => ({
  name: "management",
  route: "plan-site-dev-management",
  icon: {
    default: {
      icon: "fa-regular fa-gear"
    },
    hover: {
      icon: "fa-solid fa-gear"
    }
  },
  keywords: ["core", "plugin", "updates", "update", "php", "version", "password", "protection", "protect", "secure", "upgrade", "upgrades", "wordpress", "plugins"],
  advanced: !0
});
const CONTENT_DELIVERY$1 = () => ({
  name: "content-delivery",
  route: "plan-site-dev-content-delivery",
  icon: {
    default: {
      icon: "fa-regular fa-chart-network"
    },
    hover: {
      icon: "fa-solid fa-chart-network"
    }
  },
  keywords: ["cdn", "content", "delivery", "purge", "cache", "cloudflare"]
});
const SCHEDULED_TASKS$2 = () => ({
  name: "scheduled-tasks",
  route: "plan-site-dev-scheduled-tasks",
  icon: {
    default: {
      icon: "fa-regular fa-square-check"
    },
    hover: {
      icon: "fa-solid fa-square-check"
    }
  },
  keywords: ["schedule", "scheduled", "cron", "cronjob", "task", "daily", "weekly", "monthly"],
  advanced: !0
});
const SSL$2 = () => ({
  name: "ssl",
  route: "plan-site-dev-ssl",
  icon: {
    default: {
      icon: "fa-regular fa-lock"
    },
    hover: {
      icon: "fa-solid fa-lock"
    }
  },
  keywords: ["ssl", "encrypt", "lets", "let's", "encryption", "secure", "security", "https"],
  advanced: !0
});const orderedLinks$1 = {
    credentials: null,
    "content-delivery": null,
    backup: null,
    email: null,
    "visual-comparison": null,
    analytics: null,
    "domain-options": null,
    management: null,
    databases: null,
    ssl: null,
    logs: null,
    "scheduled-tasks": null,
    containers: null,
    "control-panel": null
  },
  addMainLinks$1 = (i, n) => {
    hasPermission(n, "write", "services") && i.addLink(CREDENTIALS$2()), i.addLink(BACKUP$1()), i.addLink(ANALYTICS$2()), i.addLink(EMAIL$2()), i.addLink(DOMAINS$2()), i.addLink(MANAGEMENT$2()), i.addLink(DATABASES$2()), hasPermission(n, "write", "services") && (i.addLink(SSL$2()), i.addLink(CONTENT_DELIVERY$1())), i.addLink(LOGS$1()), i.addLink(SCHEDULED_TASKS$2()), i.addLink(CONTAINERS$2());
  },
  getTShirtDevSiteLinks = (i, n, e) => {
    const d = new LinksBuilder(orderedLinks$1);
    return addMainLinks$1(d, i), hasPermission(i, "write", "services") && d.addLink(CONTROL_PANEL$2({
      admin: !1
    })), d.getLinks();
  },
  getLiquidwebDevSiteLinks = (i, n, e) => {
    const d = new LinksBuilder(orderedLinks$1);
    return addMainLinks$1(d, i), e && d.addLink(CONTROL_PANEL$2({
      admin: !0
    })), d.getLinks();
  };var devSite=/*#__PURE__*/Object.freeze({__proto__:null,getLiquidwebDevSiteLinks:getLiquidwebDevSiteLinks,getTShirtDevSiteLinks:getTShirtDevSiteLinks});const BILLING = () => ({
  name: "billing",
  route: "billing",
  icon: {
    default: {
      icon: "fa-regular fa-circle-dollar"
    },
    hover: {
      icon: "fa-solid fa-circle-dollar"
    }
  },
  keywords: ["billing", "invoice", "pay", "credit", "card", "payment", "address", "tax", "exemption", "order"]
});
const CLOUD_SERVERS = ({
  count: e
}) => ({
  name: e > 0 ? "cloud-servers" : "cloud-servers-empty",
  meta: {
    count: e
  },
  route: "cloud-servers",
  icon: {
    default: {
      icon: "fa-regular fa-cloud"
    },
    hover: {
      icon: "fa-solid fa-cloud"
    }
  },
  keywords: ["cloud", "server", "servers", "nxcloud", "hosting"]
});
const COLOCATIONS = ({
  count: e
}) => ({
  name: "colocations",
  meta: {
    count: e
  },
  route: "colocations",
  icon: {
    default: {
      icon: "fa-regular fa-crosshairs"
    },
    hover: {
      icon: "fa-solid fa-crosshairs"
    }
  },
  keywords: ["colo", "co-lo", "location", "locate", "server", "rack"]
});
const DEDICATED_SERVERS = ({
  count: e
}) => ({
  name: "dedicated-servers",
  meta: {
    count: e
  },
  route: "dedicated-servers",
  icon: {
    default: {
      icon: "fa-regular fa-server"
    },
    hover: {
      icon: "fa-solid fa-server"
    }
  },
  keywords: ["dedicated", "server", "servers", "bare", "metal", "hosting"]
});
const DNS$1 = () => ({
  name: "dns",
  route: "dns",
  icon: {
    default: {
      icon: "fa-regular fa-globe"
    },
    hover: {
      icon: "fa-solid fa-globe"
    }
  },
  keywords: ["dns", "domain", "zone"],
  advanced: !0
});
const DOMAINS$1 = ({
  count: e
}) => ({
  name: "domains",
  meta: {
    count: e
  },
  route: "domains",
  icon: {
    default: {
      icon: "fa-regular fa-code"
    },
    hover: {
      icon: "fa-solid fa-code"
    }
  },
  keywords: ["site", "domain", "domains"]
});
const ENTERPRISE_CLOUD = ({
  count: e
}) => ({
  name: e > 0 ? "enterprise-cloud" : "enterprise-cloud-empty",
  meta: {
    count: e
  },
  route: "enterprise-cloud",
  icon: {
    default: {
      icon: "fa-regular fa-buildings"
    },
    hover: {
      icon: "fa-solid fa-buildings"
    }
  },
  keywords: ["cloud", "cluster", "enterprise", "hosting", "server", "virtual"]
});
const HOME = () => ({
  name: "home",
  route: "dashboard-home",
  icon: {
    default: {
      icon: "fa-regular fa-house"
    },
    hover: {
      icon: "fa-solid fa-house"
    }
  },
  keywords: ["support", "ticket", "help", "problem", "invoice", "credit", "status", "blog"]
});
const OTHER = ({
  count: e
}) => ({
  name: "other",
  meta: {
    count: e
  },
  route: "other",
  icon: {
    default: {
      icon: "fa-regular fa-square-ellipsis"
    },
    hover: {
      icon: "fa-solid fa-square-ellipsis"
    }
  },
  keywords: ["colo", "co-lo", "location", "po", "purchase", "order", "cdn", "network", "content", "delivery", "legal", "agreement"]
});
const PARTNER = () => ({
  name: "partner",
  route: "partner",
  icon: {
    default: {
      icon: "fa-regular fa-handshake"
    },
    hover: {
      icon: "fa-solid fa-handshake"
    }
  },
  keywords: ["partner"]
});
const PLANS = ({
  count: e
}) => ({
  name: e > 0 ? "plans" : "plans-empty",
  meta: {
    count: e
  },
  route: "plans",
  icon: {
    default: {
      icon: "fa-regular fa-square-list"
    },
    hover: {
      icon: "fa-solid fa-square-list"
    }
  },
  keywords: ["plan", "purchase", "buy", "new", "site", "domain", "environment"]
});
const SITES = (e = {}) => ({
  name: e.count > 0 ? "sites-count" : "sites",
  meta: {
    count: e.count
  },
  route: "all-sites",
  icon: {
    default: {
      icon: "fa-regular fa-window"
    },
    hover: {
      icon: "fa-solid fa-window"
    }
  },
  keywords: ["plan", "purchase", "buy", "new", "site", "domain", "environment"]
});
const RESELLER_HOSTING = ({
  count: e
}) => ({
  name: "reseller-hosting",
  meta: {
    count: e
  },
  route: "reseller-hosting",
  icon: {
    default: {
      icon: "fa-regular fa-shop"
    },
    hover: {
      icon: "fa-solid fa-shop"
    }
  },
  keywords: ["reseller", "hosting", "resold"]
});
const SHARED_HOSTING = ({
  count: e
}) => ({
  name: "shared-hosting",
  meta: {
    count: e
  },
  route: "shared-hosting",
  icon: {
    default: {
      icon: "fa-regular fa-share"
    },
    hover: {
      icon: "fa-solid fa-share"
    }
  },
  keywords: ["shared", "multi", "tenant", "multitenant", "multi-tenant", "bare", "metal", "hosting"]
});
const SSL$1 = () => ({
  name: "ssl",
  route: "ssl",
  icon: {
    default: {
      icon: "fa-regular fa-lock"
    },
    hover: {
      icon: "fa-solid fa-lock"
    }
  },
  keywords: ["ssl", "encrypt", "encryption", "secure", "security", "https", "lets", "cert"],
  advanced: !0
});
const SUPPORT = () => ({
  name: "support",
  route: "support",
  icon: {
    default: {
      icon: "fa-regular fa-user-headset"
    },
    hover: {
      icon: "fa-solid fa-user-headset"
    }
  },
  keywords: ["support", "ticket", "help", "problem", "migrate", "migration", "migrations", "down", "offline", "can't", "won't", "not"]
});const getTopLinks = () => [HOME()],
  getBottomLinks = s => {
    const e = [];
    return (hasPermission(s, "read", "invoices") || hasPermission(s, "read", "credits") || hasPermission(s, "read", "addresses") || hasPermission(s, "read", "creditcards") || hasPermission(s, "read", "account") || hasPermission(s, "read", "payments") || hasPermission(s, "read", "orders")) && e.push(BILLING()), hasPermission(s, "read", "tickets") && e.push(SUPPORT()), hasPermission(s, "read", "services") && e.push(SSL$1()), hasPermission(s, "read", "dns") && e.push(DNS$1()), e;
  },
  getNexcessMainLinks = (s, e) => {
    const n = [],
      o = getBottomLinks(e);
    (s.cloudServerCount > 0 || "fh-" === s.externalKey?.substring(0, 3)) && n.push(CLOUD_SERVERS({
      count: s.cloudServerCount
    })), s.enterpriseCloudCount > 0 && n.push(ENTERPRISE_CLOUD({
      count: s.enterpriseCloudCount
    })), s.sharedHostingCount && n.push(SHARED_HOSTING({
      count: s.sharedHostingCount
    })), s.dedicatedServerCount && n.push(DEDICATED_SERVERS({
      count: s.dedicatedServerCount
    })), s.colocationCount && n.push(COLOCATIONS({
      count: s.colocationCount
    })), s.resellerHostingCount && n.push(RESELLER_HOSTING({
      count: s.resellerHostingCount
    })), s.domainCount && n.push(DOMAINS$1({
      count: s.domainCount
    })), s.otherCount && n.push(OTHER({
      count: s.otherCount
    })), s.isPartner && o.push(PARTNER());
    const t = [];
    return hasPermission(e, "read", "services") && (t.push(PLANS({
      count: s.planCount
    })), s.planCount && n.push(SITES())), [...getTopLinks(), ...t, ...n, ...o];
  },
  getThermoMainLinks = (s, e) => {
    const n = getBottomLinks(e);
    s.isPartner && n.push(PARTNER());
    const o = [];
    return hasPermission(e, "read", "services") && o.push(CLOUD_SERVERS({
      count: s.cloudServerCount
    })), [...getTopLinks(), ...o, ...n];
  };var main=/*#__PURE__*/Object.freeze({__proto__:null,getNexcessMainLinks:getNexcessMainLinks,getThermoMainLinks:getThermoMainLinks});const CREDITS = () => ({
  name: "credits",
  route: "partner-credits",
  icon: {
    default: {
      icon: "fa-regular fa-sparkles"
    },
    hover: {
      icon: "fa-solid fa-sparkles"
    }
  }
});
const LINKS = () => ({
  name: "links",
  route: "partner-links",
  icon: {
    default: {
      icon: "fa-regular fa-link"
    },
    hover: {
      icon: "fa-solid fa-link"
    }
  }
});
const PAYMENTS = () => ({
  name: "payments",
  route: "partner-payments",
  icon: {
    default: {
      icon: "fa-regular fa-credit-card"
    },
    hover: {
      icon: "fa-solid fa-credit-card"
    }
  }
});
const REFERRALS = () => ({
  name: "referrals",
  route: "partner-referrals",
  icon: {
    default: {
      icon: "fa-regular fa-gift"
    },
    hover: {
      icon: "fa-solid fa-gift"
    }
  }
});const getPartnerLinks$2 = (r = {}) => {
  const t = [];
  return r?.isPartner && t.push(LINKS(), REFERRALS(), CREDITS(), PAYMENTS()), [...t];
};var partner$1=/*#__PURE__*/Object.freeze({__proto__:null,getPartnerLinks:getPartnerLinks$2});const ANALYTICS$1 = () => ({
  name: "analytics",
  route: "plan-analytics",
  icon: {
    default: {
      icon: "fa-regular fa-chart-line"
    },
    hover: {
      icon: "fa-solid fa-chart-line"
    }
  },
  keywords: ["analytics", "disk", "space", "cdn", "content", "delivery", "usage", "php-fpm", "php", "fpm", "statistics", "bandwidth"]
});
const CONTAINERS$1 = () => ({
  name: "containers",
  route: "plan-containers",
  icon: {
    default: {
      icon: "fa-regular fa-box"
    },
    hover: {
      icon: "fa-solid fa-box"
    }
  },
  keywords: ["container", "containers", "elasticsearch", "elastic", "rabbitmq", "rabbit", "mq", "solr"],
  advanced: !0
});
const CONTROL_PANEL$1 = () => ({
  name: "control-panel",
  route: "plan-control-panel",
  icon: {
    default: {
      icon: "fa-regular fa-square-sliders-vertical"
    },
    hover: {
      icon: "fa-solid fa-square-sliders-vertical"
    }
  },
  keywords: ["siteworx", "worx", "control", "panel", "cpanel"],
  advanced: !0
});
const CREDENTIALS$1 = () => ({
  name: "credentials",
  route: "plan-credentials",
  icon: {
    default: {
      icon: "fa-regular fa-id-badge"
    },
    hover: {
      icon: "fa-solid fa-id-badge"
    }
  },
  keywords: ["ssh", "sftp", "login", "credentials", "access", "ftp", "redis", "cache", "username", "user", "ip", "address"]
});
const DATABASES$1 = () => ({
  name: "databases",
  route: "plan-databases",
  icon: {
    default: {
      icon: "fa-regular fa-database"
    },
    hover: {
      icon: "fa-solid fa-database"
    }
  },
  keywords: ["user", "username", "pass", "password", "mysql", "sql", "database", "db", "php", "phpMyAdmin", "myadmin"],
  advanced: !0
});
const EMAIL$1 = () => ({
  name: "email",
  route: "plan-email",
  icon: {
    default: {
      icon: "fa-regular fa-envelope"
    },
    hover: {
      icon: "fa-solid fa-envelope"
    }
  },
  keywords: ["mail", "mailbox", "e-mail", "email", "box", "boxes", "webmail", "local", "delivery", "alias", "roundcube", "round", "cube"]
});
const INTEGRATIONS$1 = () => ({
  name: "integrations",
  route: "plan-integrations",
  icon: {
    default: {
      icon: "fa-regular fa-puzzle-piece"
    },
    hover: {
      icon: "fa-solid fa-puzzle-piece"
    }
  },
  keywords: ["integration", "integrations", "relic"],
  advanced: !0
});
const MANAGEMENT$1 = () => ({
  name: "management",
  route: "plan-management",
  icon: {
    default: {
      icon: "fa-regular fa-gear"
    },
    hover: {
      icon: "fa-solid fa-gear"
    }
  },
  keywords: ["cloud", "accelerator", "nginx", "core", "plugin", "updates", "update", "auto", "scaling", "autoscaling", "autoscale", "php", "version", "upgrade", "upgrades", "wordpress", "plugins"],
  advanced: !0
});
const SAFE_HARBOR$1 = () => ({
  name: "safe-harbor",
  route: "plan-safe-harbor",
  icon: {
    default: {
      icon: "fa-regular fa-person-shelter"
    },
    hover: {
      icon: "fa-solid fa-person-shelter"
    }
  },
  keywords: ["m1", "magento", "safe", "harbor", "patch", "update", "security", "updates", "fix", "exploit", "malware", "scan"]
});
const SAFE_HARBOR_MAGENTO_PATCHES$1 = () => ({
  name: "magento-patches",
  route: "plan-safe-harbor-magento-patches",
  icon: {
    default: {
      icon: "fa-regular fa-screwdriver-wrench"
    },
    hover: {
      icon: "fa-solid fa-screwdriver-wrench"
    }
  },
  keywords: ["patch", "patches", "update", "updates"]
});
const SAFE_HARBOR_MALWARE_SCANS$1 = () => ({
  name: "malware-scans",
  route: "plan-safe-harbor-malware-scans",
  icon: {
    default: {
      icon: "fa-regular fa-radar"
    },
    hover: {
      icon: "fa-solid fa-radar"
    }
  },
  keywords: ["scan", "locate", "exploit", "malware", "identify", "report"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_ANALYTICS = () => ({
  name: "analytics",
  route: "plan-safe-harbor-staging-environment-analytics",
  icon: {
    default: {
      icon: "fa-regular fa-chart-line"
    },
    hover: {
      icon: "fa-solid fa-chart-line"
    }
  },
  keywords: ["analytics", "usage", "php-fpm", "php", "fpm", "statistics", "bandwidth"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_BACKUP$1 = () => ({
  name: "backup",
  route: "plan-safe-harbor-staging-environment-backups",
  icon: {
    default: {
      icon: "fa-regular fa-hard-drive"
    },
    hover: {
      icon: "fa-solid fa-hard-drive"
    }
  },
  keywords: ["backup", "backups", "daily", "archive", "recover", "recovery", "restore"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_CONTAINERS$1 = () => ({
  name: "containers",
  route: "plan-safe-harbor-staging-environment-containers",
  icon: {
    default: {
      icon: "fa-regular fa-box"
    },
    hover: {
      icon: "fa-solid fa-box"
    }
  },
  keywords: ["container", "containers", "elasticsearch", "elastic", "rabbitmq", "rabbit", "mq", "solr"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_CONTROL_PANEL$1 = () => ({
  name: "control-panel",
  route: "plan-safe-harbor-staging-environment-control-panel",
  icon: {
    default: {
      icon: "fa-regular fa-square-sliders-vertical"
    },
    hover: {
      icon: "fa-solid fa-square-sliders-vertical"
    }
  },
  keywords: ["siteworx", "worx", "control", "panel", "cpanel"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_CREDENTIALS = () => ({
  name: "credentials",
  route: "plan-safe-harbor-staging-environment-credentials",
  icon: {
    default: {
      icon: "fa-regular fa-id-badge"
    },
    hover: {
      icon: "fa-solid fa-id-badge"
    }
  },
  keywords: ["ssh", "sftp", "login", "credentials", "access", "ftp", "redis", "cache", "username", "user"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_DATABASES$1 = () => ({
  name: "databases",
  route: "plan-safe-harbor-staging-environment-databases",
  icon: {
    default: {
      icon: "fa-regular fa-database"
    },
    hover: {
      icon: "fa-solid fa-database"
    }
  },
  keywords: ["user", "username", "pass", "password", "mysql", "sql", "database", "db", "php", "phpMyAdmin", "myadmin"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_DOMAINS$1 = () => ({
  name: "domain-options",
  route: "plan-safe-harbor-staging-environment-domains",
  icon: {
    default: {
      icon: "fa-regular fa-code"
    },
    hover: {
      icon: "fa-solid fa-code"
    }
  },
  keywords: ["site", "domain", "domains"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_EMAIL$1 = () => ({
  name: "email",
  route: "plan-safe-harbor-staging-environment-email",
  icon: {
    default: {
      icon: "fa-regular fa-envelope"
    },
    hover: {
      icon: "fa-solid fa-envelope"
    }
  },
  keywords: ["mail", "mailbox", "e-mail", "email", "box", "boxes", "webmail", "local", "delivery", "alias", "roundcube", "round", "cube"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_LOGS$1 = () => ({
  name: "logs",
  route: "plan-safe-harbor-staging-environment-logs",
  icon: {
    default: {
      icon: "fa-regular fa-table-list"
    },
    hover: {
      icon: "fa-solid fa-table-list"
    }
  },
  keywords: ["log", "logs", "report", "error"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_MANAGEMENT = () => ({
  name: "management",
  route: "plan-safe-harbor-staging-environment-management",
  icon: {
    default: {
      icon: "fa-regular fa-gear"
    },
    hover: {
      icon: "fa-solid fa-gear"
    }
  },
  keywords: ["core", "plugin", "updates", "update", "php", "version", "password", "protection", "protect", "secure", "upgrade", "upgrades", "wordpress", "plugins"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_SSL$1 = () => ({
  name: "ssl",
  route: "plan-safe-harbor-staging-environment-ssl",
  icon: {
    default: {
      icon: "fa-regular fa-lock"
    },
    hover: {
      icon: "fa-solid fa-lock"
    }
  },
  keywords: ["ssl", "encrypt", "lets", "let's", "encryption", "secure", "security", "https"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_SCHEDULED_TASKS$1 = () => ({
  name: "scheduled-tasks",
  route: "plan-safe-harbor-staging-environment-scheduled-tasks",
  icon: {
    default: {
      icon: "fa-regular fa-square-check"
    },
    hover: {
      icon: "fa-solid fa-square-check"
    }
  },
  keywords: ["schedule", "scheduled", "cron", "cronjob", "task", "daily", "weekly", "monthly"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENTS$1 = () => ({
  name: "staging-environments",
  route: "plan-safe-harbor-staging-environments",
  icon: {
    default: {
      icon: "fa-regular fa-display-code"
    },
    hover: {
      icon: "fa-solid fa-display-code"
    }
  },
  keywords: ["stage", "staging"]
});
const SAFE_HARBOR_THREAT_PROTECTION$1 = () => ({
  name: "threat-protection",
  route: "plan-safe-harbor-threat-protection",
  icon: {
    default: {
      icon: "fa-regular fa-shield-check"
    },
    hover: {
      icon: "fa-solid fa-shield-check"
    }
  },
  keywords: ["threat", "security", "malware", "exploit", "protect", "protection"]
});
const SCHEDULED_TASKS$1 = () => ({
  name: "scheduled-tasks",
  route: "plan-scheduled-tasks",
  icon: {
    default: {
      icon: "fa-regular fa-square-check"
    },
    hover: {
      icon: "fa-solid fa-square-check"
    }
  },
  keywords: ["schedule", "scheduled", "cron", "cronjob", "task", "daily", "weekly", "monthly"],
  advanced: !0
});
const LW_SITES = () => ({
  name: "sites",
  route: "plan-sites",
  icon: {
    default: {
      icon: "fa-regular fa-window"
    },
    hover: {
      icon: "fa-solid fa-window"
    }
  },
  keywords: ["site", "sites", "domain", "domains", "website", "websites"]
});
const TSHIRT_SITES = () => ({
  name: "sites",
  route: "plan-sites",
  icon: {
    default: {
      icon: "fa-regular fa-window"
    },
    hover: {
      icon: "fa-solid fa-window"
    }
  },
  keywords: ["site", "sites", "domain", "domains", "website", "websites", "cdn"]
});
const STENCILS$1 = () => ({
  name: "stencils",
  route: "plan-stencils",
  icon: {
    default: {
      icon: "fa-regular fa-rectangles-mixed"
    },
    hover: {
      icon: "fa-solid fa-rectangles-mixed"
    }
  },
  keywords: ["stencil", "template", "templates"]
});const getLiquidwebPlanLinks = A => {
  const N = [LW_SITES()];
  return A.allowsStencils && N.push(STENCILS$1()), N;
};
const getPlanSafeHarborLinks = () => [SAFE_HARBOR_MALWARE_SCANS$1(), SAFE_HARBOR_THREAT_PROTECTION$1(), SAFE_HARBOR_STAGING_ENVIRONMENTS$1(), SAFE_HARBOR_MAGENTO_PATCHES$1()];
const getPlanSafeHarborStagingEnvironmentLinks = () => [SAFE_HARBOR_STAGING_ENVIRONMENT_CREDENTIALS(), SAFE_HARBOR_STAGING_ENVIRONMENT_BACKUP$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_ANALYTICS(), SAFE_HARBOR_STAGING_ENVIRONMENT_EMAIL$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_DOMAINS$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_MANAGEMENT(), SAFE_HARBOR_STAGING_ENVIRONMENT_DATABASES$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_SSL$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_LOGS$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_SCHEDULED_TASKS$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_CONTAINERS$1(), SAFE_HARBOR_STAGING_ENVIRONMENT_CONTROL_PANEL$1()];
const getTShirtPlanLinks = (A, N) => {
  const E = [];
  return E.push(TSHIRT_SITES(), CREDENTIALS$1(), ANALYTICS$1(), EMAIL$1()), N.hasSafeHarbor && E.push(SAFE_HARBOR$1()), hasPermission(A, "write", "services") && E.push(MANAGEMENT$1()), E.push(DATABASES$1()), E.push(SCHEDULED_TASKS$1(), CONTAINERS$1()), hasPermission(A, "write", "services") && E.push(INTEGRATIONS$1(), CONTROL_PANEL$1()), E;
};var plan=/*#__PURE__*/Object.freeze({__proto__:null,getLiquidwebPlanLinks:getLiquidwebPlanLinks,getPlanSafeHarborLinks:getPlanSafeHarborLinks,getPlanSafeHarborStagingEnvironmentLinks:getPlanSafeHarborStagingEnvironmentLinks,getTShirtPlanLinks:getTShirtPlanLinks});const OVERVIEW = () => ({
  name: "overview",
  route: "shared-host-overview",
  icon: {
    default: {
      icon: "fa-regular fa-share"
    },
    hover: {
      icon: "fa-solid fa-share"
    }
  }
});
const SAFE_HARBOR = () => ({
  name: "safe-harbor",
  route: "shared-host-safe-harbor",
  icon: {
    default: {
      icon: "fa-regular fa-person-shelter"
    },
    hover: {
      icon: "fa-solid fa-person-shelter"
    }
  },
  keywords: ["m1", "magento", "safe", "harbor", "patch", "update", "security", "updates", "fix", "exploit", "malware", "scan"]
});
const SAFE_HARBOR_MAGENTO_PATCHES = () => ({
  name: "magento-patches",
  route: "shared-host-safe-harbor-magento-patches",
  icon: {
    default: {
      icon: "fa-regular fa-screwdriver-wrench"
    },
    hover: {
      icon: "fa-solid fa-screwdriver-wrench"
    }
  },
  keywords: ["patch", "patches", "update", "updates"]
});
const SAFE_HARBOR_MALWARE_SCANS = () => ({
  name: "malware-scans",
  route: "shared-host-safe-harbor-malware-scans",
  icon: {
    default: {
      icon: "fa-regular fa-radar"
    },
    hover: {
      icon: "fa-solid fa-radar"
    }
  },
  keywords: ["scan", "locate", "exploit", "malware", "identify", "report"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_BACKUP = () => ({
  name: "backup",
  route: "shared-host-safe-harbor-staging-environment-backups",
  icon: {
    default: {
      icon: "fa-regular fa-hard-drive"
    },
    hover: {
      icon: "fa-solid fa-hard-drive"
    }
  },
  keywords: ["backup", "backups", "daily", "archive", "recover", "recovery", "restore"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_CONTAINERS = () => ({
  name: "containers",
  route: "shared-host-safe-harbor-staging-environment-containers",
  icon: {
    default: {
      icon: "fa-regular fa-box"
    },
    hover: {
      icon: "fa-solid fa-box"
    }
  },
  keywords: ["container", "containers", "elasticsearch", "elastic", "rabbitmq", "rabbit", "mq", "solr"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_CONTROL_PANEL = () => ({
  name: "control-panel",
  route: "shared-host-safe-harbor-staging-environment-control-panel",
  icon: {
    default: {
      icon: "fa-regular fa-square-sliders-vertical"
    },
    hover: {
      icon: "fa-solid fa-square-sliders-vertical"
    }
  },
  keywords: ["siteworx", "worx", "control", "panel", "cpanel"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_DATABASES = () => ({
  name: "databases",
  route: "shared-host-safe-harbor-staging-environment-databases",
  icon: {
    default: {
      icon: "fa-regular fa-database"
    },
    hover: {
      icon: "fa-solid fa-database"
    }
  },
  keywords: ["user", "username", "pass", "password", "mysql", "sql", "database", "db", "phpMyAdmin", "myadmin"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_DOMAINS = () => ({
  name: "domains",
  route: "shared-host-safe-harbor-staging-environment-domains",
  icon: {
    default: {
      icon: "fa-regular fa-code"
    },
    hover: {
      icon: "fa-solid fa-code"
    }
  },
  keywords: ["site", "domain", "domains"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_EMAIL = () => ({
  name: "email",
  route: "shared-host-safe-harbor-staging-environment-email",
  icon: {
    default: {
      icon: "fa-regular fa-envelope"
    },
    hover: {
      icon: "fa-solid fa-envelope"
    }
  },
  keywords: ["mail", "mailbox", "e-mail", "email", "box", "boxes", "webmail", "local", "delivery", "alias", "roundcube", "round", "cube"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_ENVIRONMENT = () => ({
  name: "environment",
  route: "shared-host-safe-harbor-staging-environment-environment",
  icon: {
    default: {
      icon: "fa-regular fa-computer"
    },
    hover: {
      icon: "fa-solid fa-computer"
    }
  },
  keywords: ["username", "user", "php", "version", "redis", "ip", "address", "core", "plugin", "plugins", "upgrade", "upgrades", "update", "updates", "admin"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_LOGS = () => ({
  name: "logs",
  route: "shared-host-safe-harbor-staging-environment-logs",
  icon: {
    default: {
      icon: "fa-regular fa-table-list"
    },
    hover: {
      icon: "fa-solid fa-table-list"
    }
  },
  keywords: ["log", "logs", "report"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_PERFORMANCE = () => ({
  name: "performance",
  route: "shared-host-safe-harbor-staging-environment-performance",
  icon: {
    default: {
      icon: "fa-regular fa-gauge-high"
    },
    hover: {
      icon: "fa-solid fa-gauge-high"
    }
  },
  keywords: ["disk", "space", "storage", "quota", "performance", "monitoring", "relic", "cdn", "content", "delivery", "cloud", "accelerator", "nginx", "purge", "cache", "bandwidth", "limit", "scaling", "scale", "autoscale", "php", "php fpm", "fpm", "worker", "max children"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_SCHEDULED_TASKS = () => ({
  name: "scheduled-tasks",
  route: "shared-host-safe-harbor-staging-environment-scheduled-tasks",
  icon: {
    default: {
      icon: "fa-regular fa-square-check"
    },
    hover: {
      icon: "fa-solid fa-square-check"
    }
  },
  keywords: ["schedule", "scheduled", "cron", "cronjob", "task", "daily", "weekly", "monthly"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_SETTINGS = () => ({
  name: "settings",
  route: "shared-host-safe-harbor-staging-environment-settings",
  icon: {
    default: {
      icon: "fa-regular fa-gear"
    },
    hover: {
      icon: "fa-solid fa-gear"
    }
  },
  keywords: ["master", "domain", "site", "pointer", "domains"],
  advanced: !0
});
const SAFE_HARBOR_STAGING_ENVIRONMENT_SSL = () => ({
  name: "ssl",
  route: "shared-host-safe-harbor-staging-environment-ssl",
  icon: {
    default: {
      icon: "fa-regular fa-lock"
    },
    hover: {
      icon: "fa-solid fa-lock"
    }
  },
  keywords: ["ssl", "security", "https", "encryption", "encrypt"]
});
const SAFE_HARBOR_STAGING_ENVIRONMENTS = () => ({
  name: "staging-environments",
  route: "shared-host-safe-harbor-staging-environments",
  icon: {
    default: {
      icon: "fa-regular fa-display-code"
    },
    hover: {
      icon: "fa-solid fa-display-code"
    }
  },
  keywords: ["stage", "staging"]
});
const SAFE_HARBOR_THREAT_PROTECTION = () => ({
  name: "threat-protection",
  route: "shared-host-safe-harbor-threat-protection",
  icon: {
    default: {
      icon: "fa-regular fa-shield-check"
    },
    hover: {
      icon: "fa-solid fa-shield-check"
    }
  },
  keywords: ["threat", "security", "malware", "exploit", "protect", "protection"]
});const getSharedHostLinks = N => {
  const A = [OVERVIEW()];
  return N.hasSafeHarbor && A.push(SAFE_HARBOR()), A;
};
const getSharedHostSafeHarborLinks = () => [SAFE_HARBOR_MALWARE_SCANS(), SAFE_HARBOR_THREAT_PROTECTION(), SAFE_HARBOR_STAGING_ENVIRONMENTS(), SAFE_HARBOR_MAGENTO_PATCHES()];
const getSharedHostSafeHarborStagingEnvironmentLinks = () => [SAFE_HARBOR_STAGING_ENVIRONMENT_PERFORMANCE(), SAFE_HARBOR_STAGING_ENVIRONMENT_DOMAINS(), SAFE_HARBOR_STAGING_ENVIRONMENT_SETTINGS(), SAFE_HARBOR_STAGING_ENVIRONMENT_ENVIRONMENT(), SAFE_HARBOR_STAGING_ENVIRONMENT_SSL(), SAFE_HARBOR_STAGING_ENVIRONMENT_LOGS(), SAFE_HARBOR_STAGING_ENVIRONMENT_DATABASES(), SAFE_HARBOR_STAGING_ENVIRONMENT_SCHEDULED_TASKS(), SAFE_HARBOR_STAGING_ENVIRONMENT_EMAIL(), SAFE_HARBOR_STAGING_ENVIRONMENT_BACKUP(), SAFE_HARBOR_STAGING_ENVIRONMENT_CONTAINERS(), SAFE_HARBOR_STAGING_ENVIRONMENT_CONTROL_PANEL()];var sharedHost=/*#__PURE__*/Object.freeze({__proto__:null,getSharedHostLinks:getSharedHostLinks,getSharedHostSafeHarborLinks:getSharedHostSafeHarborLinks,getSharedHostSafeHarborStagingEnvironmentLinks:getSharedHostSafeHarborStagingEnvironmentLinks});const ANALYTICS = () => ({
  name: "analytics",
  route: "plan-site-analytics",
  icon: {
    default: {
      icon: "fa-regular fa-chart-line"
    },
    hover: {
      icon: "fa-solid fa-chart-line"
    }
  },
  keywords: ["analytics", "disk", "space", "cdn", "content", "delivery", "usage", "php-fpm", "php", "fpm", "statistics", "bandwidth"],
  advanced: !0
});
const BACKUP = () => ({
  name: "backup",
  route: "plan-site-backups",
  icon: {
    default: {
      icon: "fa-regular fa-hard-drive"
    },
    hover: {
      icon: "fa-solid fa-hard-drive"
    }
  },
  keywords: ["backup", "backups", "daily", "archive", "recover", "recovery", "restore"]
});
const CONTAINERS = () => ({
  name: "containers",
  route: "plan-site-containers",
  icon: {
    default: {
      icon: "fa-regular fa-box"
    },
    hover: {
      icon: "fa-solid fa-box"
    }
  },
  keywords: ["container", "containers", "elasticsearch", "elastic", "rabbitmq", "rabbit", "mq", "solr"],
  advanced: !0
});
const CONTENT_DELIVERY = () => ({
  name: "content-delivery",
  route: "plan-site-content-delivery",
  icon: {
    default: {
      icon: "fa-regular fa-chart-network"
    },
    hover: {
      icon: "fa-solid fa-chart-network"
    }
  },
  keywords: ["cdn", "content", "delivery", "purge", "cache", "cloudflare", "performance", "shield"]
});
const CONTROL_PANEL = () => ({
  name: "control-panel",
  route: "plan-site-control-panel",
  icon: {
    default: {
      icon: "fa-regular fa-square-sliders-vertical"
    },
    hover: {
      icon: "fa-solid fa-square-sliders-vertical"
    }
  },
  admin: !0,
  keywords: ["siteworx", "worx", "control", "panel", "cpanel"],
  advanced: !0
});
const CREDENTIALS = () => ({
  name: "credentials",
  route: "plan-site-credentials",
  icon: {
    default: {
      icon: "fa-regular fa-id-badge"
    },
    hover: {
      icon: "fa-solid fa-id-badge"
    }
  },
  keywords: ["ssh", "sftp", "login", "credentials", "access", "ftp", "redis", "cache", "username", "user", "ip", "address"]
});
const DATABASES = () => ({
  name: "databases",
  route: "plan-site-databases",
  icon: {
    default: {
      icon: "fa-regular fa-database"
    },
    hover: {
      icon: "fa-solid fa-database"
    }
  },
  keywords: ["user", "username", "pass", "password", "mysql", "sql", "database", "db", "phpMyAdmin", "myadmin"],
  advanced: !0
});
const DESIGN_SERVICES = () => ({
  name: "design-services",
  route: "plan-site-design-services",
  icon: {
    default: {
      icon: "fa-regular fa-pen-to-square"
    },
    hover: {
      icon: "fa-solid fa-pen-to-square"
    }
  },
  keywords: ["design", "services", "design services", "sitekeep", "keep"]
});
const DEV = () => ({
  name: "dev",
  route: "plan-site-dev",
  icon: {
    default: {
      icon: "fa-regular fa-computer"
    },
    hover: {
      icon: "fa-solid fa-computer"
    }
  },
  keywords: ["development", "dev", "environment"]
});
const DOMAINS = () => ({
  name: "domain-options",
  route: "plan-site-domains",
  icon: {
    default: {
      icon: "fa-regular fa-code"
    },
    hover: {
      icon: "fa-solid fa-code"
    }
  },
  keywords: ["master", "primary", "domain", "domains", "pointer", "site"],
  advanced: !0
});
const EMAIL = () => ({
  name: "email",
  route: "plan-site-email",
  icon: {
    default: {
      icon: "fa-regular fa-envelope"
    },
    hover: {
      icon: "fa-solid fa-envelope"
    }
  },
  keywords: ["mail", "mailbox", "e-mail", "email", "box", "boxes", "webmail", "local", "delivery", "alias", "roundcube", "round", "cube"]
});
const INTEGRATIONS = () => ({
  name: "integrations",
  route: "plan-site-integrations",
  icon: {
    default: {
      icon: "fa-regular fa-puzzle-piece"
    },
    hover: {
      icon: "fa-solid fa-puzzle-piece"
    }
  },
  keywords: ["integration", "integrations", "relic"],
  advanced: !0
});
const LOGS = () => ({
  name: "logs",
  route: "plan-site-logs",
  icon: {
    default: {
      icon: "fa-regular fa-table-list"
    },
    hover: {
      icon: "fa-solid fa-table-list"
    }
  },
  keywords: ["log", "logs", "error", "report"],
  advanced: !0
});
const MANAGEMENT = () => ({
  name: "management",
  route: "plan-site-management",
  icon: {
    default: {
      icon: "fa-regular fa-gear"
    },
    hover: {
      icon: "fa-solid fa-gear"
    }
  },
  keywords: ["cloud", "accelerator", "nginx", "core", "plugin", "updates", "update", "auto", "scaling", "autoscaling", "autoscale", "php", "version", "password", "protection", "protectsecure", "upgrade", "upgrades", "wordpress", "plugins"],
  advanced: !0
});
const SCHEDULED_TASKS = () => ({
  name: "scheduled-tasks",
  route: "plan-site-scheduled-tasks",
  icon: {
    default: {
      icon: "fa-regular fa-square-check"
    },
    hover: {
      icon: "fa-solid fa-square-check"
    }
  },
  keywords: ["schedule", "scheduled", "cron", "cronjob", "task", "daily", "weekly", "monthly"],
  advanced: !0
});
const SSL = () => ({
  name: "ssl",
  route: "plan-site-ssl",
  icon: {
    default: {
      icon: "fa-regular fa-lock"
    },
    hover: {
      icon: "fa-solid fa-lock"
    }
  },
  keywords: ["ssl", "encrypt", "lets", "let's", "encryption", "secure", "security", "https"],
  advanced: !0
});
const STAGING_AND_DEV = () => ({
  name: "staging-and-dev",
  route: "plan-site-staging-and-dev",
  icon: {
    default: {
      icon: "fa-regular fa-computer"
    },
    hover: {
      icon: "fa-solid fa-computer"
    }
  },
  keywords: ["development", "dev", "environment", "staging", "stage"]
});
const STENCILS = () => ({
  name: "stencils",
  route: "plan-site-stencils",
  icon: {
    default: {
      icon: "fa-regular fa-rectangles-mixed"
    },
    hover: {
      icon: "fa-solid fa-rectangles-mixed"
    }
  },
  keywords: ["stencil", "template", "templates"],
  advanced: !0
});
const VISUAL_COMPARISON = () => ({
  name: "visual-comparison",
  route: "plan-site-visual-comparison",
  icon: {
    default: {
      icon: "fa-regular fa-code-compare"
    },
    hover: {
      icon: "fa-solid fa-code-compare"
    }
  },
  keywords: ["visual", "compare", "comparison", "upgrade", "upgrades", "update", "updates", "plugin", "core", "plugins"]
});const orderedLinks = {
    credentials: null,
    "content-delivery": null,
    backup: null,
    "staging-and-dev": null,
    dev: null,
    email: null,
    "visual-comparison": null,
    "design-services": null,
    stencils: null,
    analytics: null,
    "domain-options": null,
    management: null,
    databases: null,
    ssl: null,
    logs: null,
    "scheduled-tasks": null,
    containers: null,
    integrations: null,
    "control-panel": null
  },
  addMainLinks = (n, i) => {
    hasPermission(i, "write", "services") && n.addLink(CREDENTIALS()), n.addLink(BACKUP()), n.addLink(LOGS()), hasPermission(i, "write", "services") && n.addLink(CONTENT_DELIVERY()), n.addLink(DOMAINS()), n.addLink(MANAGEMENT()), hasPermission(i, "write", "services") && n.addLink(SSL());
  };
const getTShirtSiteLinks = (n, i, e) => {
  if (i.planId !== e.id || "production" !== i.environmentType) return new LinksBuilder({}).getLinks();
  const s = new LinksBuilder(orderedLinks);
  return addMainLinks(s, n), i.app.allowsDevSites && s.addLink(DEV()), s.getLinks();
};
const getLiquidwebSiteLinks = (n, i, e, s, d) => {
  if (i.planId !== e.id || "production" !== i.environmentType) return new LinksBuilder({}).getLinks();
  const l = new LinksBuilder(orderedLinks);
  return addMainLinks(l, n), l.addLink(ANALYTICS()), i.app.wordpressBased && d?.visualComparison?.allowed && l.addLink(VISUAL_COMPARISON()), l.addLink(DESIGN_SERVICES()), i.app.allowsDevSites && l.addLink(STAGING_AND_DEV()), l.addLink(DATABASES()), l.addLink(EMAIL()), l.addLink(SCHEDULED_TASKS()), l.addLink(CONTAINERS()), l.addLink(INTEGRATIONS()), e.allowsStencils && "woocommerce" !== i.app.type && l.addLink(STENCILS()), s && l.addLink(CONTROL_PANEL()), l.getLinks();
};var site$2=/*#__PURE__*/Object.freeze({__proto__:null,getLiquidwebSiteLinks:getLiquidwebSiteLinks,getTShirtSiteLinks:getTShirtSiteLinks});const LEGAL = ({
  action: o
}) => ({
  name: "legal",
  action: o
});
const PROFILE = () => ({
  name: "profile",
  route: "profile"
});
const SIGN_OUT = () => ({
  name: "signout",
  route: "logout"
});
const TWO_FACTOR_AUTH = () => ({
  name: "2fa",
  route: "2fa"
});const getUserLinks = (s = !1, e = {}) => {
  const r = [];
  return s && r.push(TWO_FACTOR_AUTH()), [PROFILE(), ...r, LEGAL({
    action: e.legal
  }), SIGN_OUT()];
};var user$1=/*#__PURE__*/Object.freeze({__proto__:null,getUserLinks:getUserLinks});const ACCOUNT_SETTINGS = () => ({
  name: "account-settings",
  route: "account-settings",
  icon: {
    default: {
      icon: "fa-regular fa-gear"
    },
    hover: {
      icon: "fa-solid fa-gear"
    }
  }
});
const API_TOKENS = () => ({
  name: "api-tokens",
  route: "api-tokens",
  icon: {
    default: {
      icon: "fa-regular fa-coin-blank"
    },
    hover: {
      icon: "fa-solid fa-coin-blank"
    }
  }
});
const PERMISSIONS = () => ({
  name: "permissions",
  route: "permissions",
  icon: {
    default: {
      icon: "fa-regular fa-list-check"
    },
    hover: {
      icon: "fa-solid fa-list-check"
    }
  }
});
const REFER_A_FRIEND = () => ({
  name: "refer-a-friend",
  route: "refer-a-friend",
  icon: {
    default: {
      icon: "fa-regular fa-gift"
    },
    hover: {
      icon: "fa-solid fa-gift"
    }
  }
});
const SSH_KEYS = () => ({
  name: "ssh-keys",
  route: "ssh-keys",
  icon: {
    default: {
      icon: "fa-regular fa-key"
    },
    hover: {
      icon: "fa-solid fa-key"
    }
  }
});
const TEAM = () => ({
  name: "team",
  route: "team",
  icon: {
    default: {
      icon: "fa-regular fa-users"
    },
    hover: {
      icon: "fa-solid fa-users"
    }
  }
});function getSettingsLinks(s = {}) {
  const S = [];
  return hasPermission(s, "read", "users") && (S.push(TEAM()), S.push(PERMISSIONS())), [ACCOUNT_SETTINGS(), ...S, API_TOKENS(), SSH_KEYS(), REFER_A_FRIEND()];
}var settings$1=/*#__PURE__*/Object.freeze({__proto__:null,getSettingsLinks:getSettingsLinks});var index$4 = {
  dns: dns$2,
  billing: billing,
  user: user$1,
  sharedHost: sharedHost,
  settings: settings$1,
  main: main,
  partner: partner$1,
  plan: plan,
  site: site$2,
  devSite: devSite
};const defaultRequestBody$1 = r => r,
  defaultTransformParams = r => r,
  defaultTransformError = r => r;
class Definition {
  constructor(r, o, e = null, t = null, s = null, n = null, i = null) {
    this.path = void 0;
    this.method = void 0;
    this.responseBody = void 0;
    this.requestBody = void 0;
    this.transformParams = void 0;
    this.transformError = void 0;
    this.validation = void 0;
    this.headers = void 0;
    this.requiredFields = void 0;
    this.mocked = void 0;
    this.mockedResponse = void 0;
    if ("object" == typeof r) {
      if (Object.keys(r).forEach(r => {
        if (!Object.getOwnPropertyNames(this).includes(r)) throw new Error(`Invalid key: ${r}`);
      }), void 0 === r.path || "string" != typeof r.path) throw new Error("Definition path is required and must be a string");
      if (void 0 === r.path || "string" != typeof r.method) throw new Error("Definition method is required and must be a string");
      if (!["GET", "POST", "PUT", "PATCH", "DELETE"].includes(r.method)) throw new Error(`Invalid method: ${r.method}`);
      if (void 0 !== r.responseBody && "function" != typeof r.responseBody) throw new Error("Definition responseBody must be a function");
      if (void 0 !== r.requestBody && "function" != typeof r.requestBody) throw new Error("Definition requestBody must be a function");
      if (void 0 !== r.transformParams && "function" != typeof r.transformParams) throw new Error("Definition transformParams must be a function");
      if (void 0 !== r.transformError && "function" != typeof r.transformError) throw new Error("Definition transformError must be a function");
      if (void 0 !== r.headers && "object" != typeof r.headers) throw new Error("Definition headers must be a function");
      this.path = r.path, this.method = r.method, this.responseBody = r.responseBody, this.requestBody = r.requestBody || defaultRequestBody$1, this.transformParams = r.transformParams || defaultTransformParams, this.transformError = r.transformError || defaultTransformError, this.validation = r.validation, this.headers = r.headers, this.mocked = r.mocked, this.mockedResponse = r.mockedResponse;
    } else if ("string" == typeof r) {
      const t = r;
      this.path = t, this.method = o, this.responseBody = e, this.requestBody = s || defaultRequestBody$1, this.transformParams = i || defaultTransformParams, this.transformError = defaultTransformError, this.validation = n;
    }
  }
}var definition=/*#__PURE__*/Object.freeze({__proto__:null,default:Definition});class Addon {
  constructor(t = {}) {
    this.annualFee = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.monthlyFee = void 0;
    this.name = void 0;
    this.quantity = void 0;
    this.osIds = void 0;
    this.classType = void 0;
    this.pricing = void 0;
    this.annualFee = Number(t.term_fee?.[12] || t.term_fees?.[12]), this.id = t.id, this.identity = t.identity, this.name = t.name, this.monthlyFee = Number(t.term_fee?.[1] || t.term_fees?.[1]), this.quantity = t.qty, this.termPriceTotal = t.term_price_total, this.osIds = t.component?.system_ids, this.classType = t.class_type, this.pricing = t.term_fees, this.formattedTermPriceTotal = moneyFormat(t.term_price_total);
  }
}class App {
  constructor(e = {}) {
    this.allowsDevSites = void 0;
    this.id = void 0;
    this.minPhpVersion = void 0;
    this.name = void 0;
    this.type = void 0;
    this.wordpressBased = void 0;
    this.version = void 0;
    this.allowsDevSites = e.is_developerable && "generic" !== e.type, this.id = e.id, this.minPhpVersion = e.minimum_php_version, this.name = e.name, this.type = e.type, this.wordpressBased = e.is_wordpress_based, this.version = e.version;
  }
  static requiresElasticSearch(e) {
    return "magento" === e?.type;
  }
}const appsByBrand = {
  liquidweb: ["wordpress", "woocommerce"],
  nexcess: ["magento", "bigcommerce", "sylius", "craftcms", "drupal", "expressionengine", "orocrm", "generic"]
};
class Package {
  constructor(e = {}, t = {}) {
    this.allottedSites = void 0;
    this.bandwidth = void 0;
    this.childAccounts = void 0;
    this.cloudAccounts = void 0;
    this.devEnvironments = void 0;
    this.diskSpace = void 0;
    this.environmentType = void 0;
    this.id = void 0;
    this.isDedicated = void 0;
    this.isOrderable = void 0;
    this.isTShirt = void 0;
    this.label = void 0;
    this.name = void 0;
    this.appPricing = void 0;
    this.pricing = void 0;
    this.installableApps = void 0;
    this.safeHarbor = void 0;
    this.type = void 0;
    this.monthlyFee = void 0;
    this.annualFee = void 0;
    this.brand = void 0;
    this.cpus = void 0;
    this.ram = void 0;
    this.allottedSites = e.primary_accounts + e.child_accounts, this.childAccounts = e.child_accounts, this.cloudAccounts = e.primary_accounts, this.devEnvironments = e.dev_accounts, this.stagingEnvironments = e.staging_accounts, this.environmentType = e.environment_type, this.id = e.id, this.isDedicated = (t.virt_dedicated_guest || e.virt_dedicated_guest) > 0, this.isOrderable = e.is_orderable, this.isTShirt = !e.is_plan, this.label = e?.label || "", this.name = e.name || e?.identity, this.pricing = (Array.isArray(e.term_fees) ? {
      1: e.monthly_fee
    } : e.term_fees) || e?.term_fees, this.pricing && Object.entries(this.pricing).forEach(([e, t]) => {
      this.pricing[e] = Number(t);
    }), this.installableApps = e.installable_apps ? e.installable_apps.map(e => new App(e)) : [], this.type = e.type, this.diskSpace = e.disk, this.bandwidth = e.bandwidth, this.cpus = t.virt_cpu, this.ram = t.virt_ram;
    const i = e.term_fees || {};
    this.monthlyFee = Number(i[1]) || 0, this.annualFee = Number(i[12]) || 0, this.appPricing = {}, e.app_pricing && Object.entries(e.app_pricing).forEach(([e, t]) => {
      this.appPricing[e] = Number(t);
    }), this.addons = e.addons && Array.isArray(e.addons) ? e.addons.map(e => new Addon(e)) : [], this.brand = Package.isLegacyPackage(this.label) ? "nexcess" : "liquidweb", this.safeHarbor = e.safe_harbor ? {
      id: e.safe_harbor.id,
      termFee: e.safe_harbor.term_fee
    } : null, this.listed = !e.is_cluster && !/(\.3xlarge$|\.4xlarge$|\.5xlarge$|\.stellar$|^dedi.)/.test(e?.label);
  }
  static getById(e, t) {
    return e.find(e => e.id === t);
  }
  static getPrice(e, t, i, s) {
    if (!e) return 0;
    const a = Package.getAddonPrices(e, i, s);
    return "monthly" === i ? e.monthlyFee + e.appPricing[t] + a : e.annualFee + a;
  }
  static getFullAnnualPrice(e) {
    return 12 * e.monthlyFee;
  }
  static getAnnualDiscount(e) {
    return 12 * e.monthlyFee - e.annualFee;
  }
  static getAddons(e, t) {
    return e ? e.addons.filter(({
      id: e
    }) => t.includes(e)) : [];
  }
  static getAddonPrices(e, t, i) {
    if (!e) return 0;
    return e.addons.filter(({
      id: e
    }) => i.includes(e)).reduce((e, i) => e + Addon.getPrice(i, t), 0);
  }
  static isLegacyPackage(e) {
    return !(e.includes("mwp.") || e.includes("mwc."));
  }
  static isCompatibleWithApp(e, t) {
    const i = !!e.installableApps,
      s = e.installableApps || [];
    return i && s.map(({
      id: e
    }) => e).includes(t.id);
  }
  static canAdvertiseWithApp(e, t) {
    return appsByBrand[e.brand].includes(t.type);
  }
  static canAutoInstall(e, t, i) {
    return !!(e && t && i) && "nexcess" === e.brand && "generic" !== t.type && "aws" !== i?.type;
  }
}class Pagination {
  constructor(e = {}) {
    const t = Pagination.parseRange(e);
    this.index = t?.pageIndex || 0, this.size = t?.pageSize || 1, this.total = "number" == typeof t?.total ? t?.total : 1;
  }
  static parseRange(e = {}) {
    const t = {},
      a = e?.headers?.["content-range"]?.replace("items ", "").match(/([^/]+)\/(\d+)/);
    if (!a) return null;
    const n = a[1],
      s = a[2];
    if (t.total = parseInt(s, 10), "0" !== n) {
      const [e, a] = n.split("-").map(e => parseInt(e, 10));
      t.first = e, t.last = a, t.pageSize = a - (e - 1), t.pageIndex = Math.floor(a / t.pageSize);
    }
    return Object.keys(e.config.params).length > 1 && Object.entries(e.config.params).forEach(([e, a]) => {
      null != a && (t[e] = a, "pageIndex" === e && (t.pageIndex += 1));
    }), t.pageIndex -= 1, t;
  }
}var Pagination$1=/*#__PURE__*/Object.freeze({__proto__:null,default:Pagination});const getDomainAddons = new Definition({
  path: "/api/v1/package/domain/addon",
  method: "GET",
  responseBody: n => ({
    list: n.data.map(n => new Package(n)),
    pagination: new Pagination(n)
  })
});var getDomainAddons$1=/*#__PURE__*/Object.freeze({__proto__:null,getDomainAddons:getDomainAddons});class Address {
  constructor(s = {}) {
    this.id = void 0;
    this.type = void 0;
    this.address1 = void 0;
    this.address2 = void 0;
    this.city = void 0;
    this.company = void 0;
    this.country = void 0;
    this.email = void 0;
    this.firstName = void 0;
    this.lastName = void 0;
    this.phone = void 0;
    this.state = void 0;
    this.zip = void 0;
    this.id = s.id, this.type = s.type, this.address1 = s.address1, this.address2 = s.address2, this.city = s.city, this.company = s.company, this.country = s.country, this.email = s.email, this.firstName = s.first_name, this.lastName = s.last_name, this.phone = s.phone, this.state = s.state, this.zip = s.zip;
  }
}class HTTPError {
  constructor(s = {}) {
    this.status = void 0;
    this.messages = void 0;
    this.status = s.status, this.messages = s.messages;
  }
}var HTTPError$1=/*#__PURE__*/Object.freeze({__proto__:null,default:HTTPError});const parseRange = (t = {}) => {
  let e = {};
  const r = t?.headers?.["content-range"]?.match(/^items ([^/]+)\/(\d+)/);
  if (!r) return null;
  const [o, n] = r;
  if (e.total = parseInt(n, 10), "0" !== o) {
    const [t, r] = o.split("-").map(t => parseInt(t, 10));
    e.pageSize = r - (t - 1), e.pageIndex = Math.floor(r / e.pageSize);
  }
  return Object.keys(t.config.params).length > 1 && (e = {
    ...e,
    ...t.config.params
  }, e.pageIndex += 1), e;
};
const transformSortParamsToV1 = t => {
  const e = {
    ...t
  };
  return e?.sortProperty && (e.sortBy = e.sortProperty, delete e.sortProperty), e?.sortDirection && (e.sortOrder = e.sortDirection, delete e.sortDirection), e;
};const createAddress = new Definition({
    path: "/address",
    method: "POST",
    responseBody: e => new Address(e.data),
    requestBody: e => ({
      type: e.type,
      email: e.email,
      first_name: e.firstName,
      last_name: e.lastName,
      address1: e.address1,
      address2: e.address2,
      city: e.city,
      company: e.company,
      country: e.country,
      phone: e.phone.replace(/[()-+]/g, ""),
      state: e.state,
      zip: e.zip
    }),
    transformError: e => {
      const s = Object.values(e.response.data);
      return new HTTPError({
        status: e.request.status,
        messages: s
      });
    }
  }),
  getAddresses = new Definition("/api/v1/address", "GET", e => {
    const s = e.data.map(e => new Address(e));
    return s.pagination = parseRange(e), s;
  }),
  validatePhone = new Definition({
    path: "/api/v1/address/phone/+{phone}",
    method: "GET",
    responseBody: e => e.data
  });var addresses=/*#__PURE__*/Object.freeze({__proto__:null,createAddress:createAddress,getAddresses:getAddresses,validatePhone:validatePhone});class Allocation {
  constructor(t = {}) {
    this.hostname = void 0;
    this.id = void 0;
    this.isRebootable = void 0;
    this.linkStatus = void 0;
    this.mainIp = void 0;
    this.powerStatus = void 0;
    this.hostname = t.hostname, this.id = t.id, this.isRebootable = t.is_rebootable, this.linkStatus = t.link_status, this.mainIp = t.main_ip?.identity, this.powerStatus = t.power_status;
  }
}const getAllocation = new Definition("/allocation/{id}", "GET", o => new Allocation(o.data)),
  rebootAllocation = new Definition("/allocation/{id}", "POST", o => new Allocation(o.data), null, () => ({
    _action: "reboot",
    cycle_power: 1
  }));var allocations=/*#__PURE__*/Object.freeze({__proto__:null,getAllocation:getAllocation,rebootAllocation:rebootAllocation});class Announcement {
  constructor(t = {}) {
    this.body = void 0;
    this.id = void 0;
    this.post_date = void 0;
    this.title = void 0;
    this.body = t.body, this.id = t.id, this.post_date = t.post_date, this.title = t.title;
  }
}const getAnnouncement = new Definition("/announcement/{id}", "GET", n => new Announcement(n.data)),
  getAnnouncements = new Definition("/announcement", "GET", n => ({
    list: n.data.map(n => new Announcement(n)),
    pagination: new Pagination(n)
  }));var announcements=/*#__PURE__*/Object.freeze({__proto__:null,getAnnouncement:getAnnouncement,getAnnouncements:getAnnouncements});const getApps = new Definition("/api/v1/app", "GET", p => ({
    list: p.data.map(p => new App(p)),
    pagination: new Pagination(p)
  })),
  getApp = new Definition("/api/v1/app/{id}", "GET", p => new App(p.data));var apps=/*#__PURE__*/Object.freeze({__proto__:null,getApp:getApp,getApps:getApps});class DecodedCertData {
  constructor(e = {}) {
    this.approvers = void 0;
    this.approvers = e.approvers;
  }
}const frequencyMap = {
    1: "monthly",
    12: "yearly",
    24: "biennially",
    36: "triennially"
  },
  termMap = {
    1: "mo",
    12: "yr",
    24: "2 yrs",
    36: "3 yrs"
  };
class Billing {
  constructor(t = {}) {
    this.abbreviatedFrequency = void 0;
    this.amount = void 0;
    this.formattedNextBillDate = void 0;
    this.frequency = void 0;
    this.months = void 0;
    this.nextBillDate = void 0;
    this.price = void 0;
    this.term = void 0;
    this.abbreviatedFrequency = termMap[t.months || t.term], this.amount = t.amount, this.formattedNextBillDate = dateFormat(t.next_bill_date), this.frequency = frequencyMap[t.months || t.term] || t.type, this.isAnnualTerm = 12 === t.months, this.months = t.months || t.term, this.nextBillDate = t.next_bill_date, this.price = `${moneyFormat(t.amount)} / ${this.abbreviatedFrequency}`, this.term = t.term;
  }
}class Cancellation {
  constructor(e) {
    this.id = void 0;
    this.scheduledDate = void 0;
    this.id = e.id || e.cancellation?.id, this.scheduledDate = e.scheduled_date;
  }
}class OperatingSystem {
  constructor(i = {}) {
    this.arch = void 0;
    this.distribution = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.version = void 0;
    this.arch = i.arch, this.distribution = i.distribution, this.id = i.id, this.identity = i.identity, this.version = i.version;
  }
}class Paypal {
  constructor(t = {}) {
    this.hasSubscription = void 0;
    this.id = void 0;
    this.startDate = void 0;
    this.hasSubscription = t.hasSubscription, this.id = t.paypal_sub_id, this.startDate = t.start_date, this.formattedStartDate = dateFormat(t.start_date);
  }
}class Service {
  constructor(t) {
    this.autoRenew = void 0;
    this.billing = void 0;
    this.cancellation = void 0;
    this.cloudId = void 0;
    this.created = void 0;
    this.description = void 0;
    this.hasSafeHarbor = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.isStable = void 0;
    this.nickname = void 0;
    this.newrelic = void 0;
    this.package = void 0;
    this.powerStatus = void 0;
    this.state = void 0;
    this.status = void 0;
    this.term = void 0;
    this.type = void 0;
    this.autoRenew = t?.auto_renew, this.billing = new Billing({
      ...t.billing_term,
      last_bill_date: t.last_bill_date,
      next_bill_date: t.next_bill_date
    });
    const a = t.cancellation || t.cancellation_info;
    (a?.id || a?.cancellation?.id) && (this.cancellation = new Cancellation(a)), this.cloudId = t.cloud_id, this.created = t.start_date, this.description = t.description, this.hasSafeHarbor = !!t.has_safe_harbor, this.paypal = new Paypal({
      ...(t.paypal_subscription || {}),
      hasSubscription: t.has_paypal_subscription
    }), this.id = t.id, this.identity = t.identity, this.nickname = t.nickname || Service.getDefaultNickname(t), this.newrelic = t.newrelic, this.os = new OperatingSystem(t.os), this.package = new Package(t.package), this.powerStatus = t.power_status, this.state = t.state, this.status = t.status, this.isStable = "stable" === t.state, this.term = t.term, this.type = t.type, this.isCancellable = t.is_cancellable;
  }
  static getDefaultNickname(t) {
    const a = t?.cloud_account?.app?.name || "",
      e = t?.cloud_account?.app?.type,
      i = "wordpress" === e,
      s = `${t?.package?.primary_accounts} Site${t?.package?.primary_accounts > 1 ? "s" : ""}`,
      n = t?.package?.identity || "",
      l = `Managed ${a} ${i ? s : n}`,
      c = `${a} ${n}`;
    return `${t?.plan_type ? l : c} ${t?.identity?.split(" - ")[0] ? `(${t?.identity?.split(" - ")[0]})` : ""}`;
  }
}class Certificate {
  constructor(i = {}) {
    this.altNames = void 0;
    this.id = void 0;
    this.commonName = void 0;
    this.chainCerts = void 0;
    this.crt = void 0;
    this.formattedValidFrom = void 0;
    this.formattedValidTo = void 0;
    this.isExpired = void 0;
    this.isMultiDomain = void 0;
    this.isWildcard = void 0;
    this.key = void 0;
    this.service = void 0;
    this.serviceId = void 0;
    this.validFrom = void 0;
    this.validTo = void 0;
    this.altNames = i.alt_names, this.id = i.id, this.commonName = i.common_name, this.chainCerts = i.chain_crts, this.crt = i.crt, this.isExpired = i.is_expired, this.isMultiDomain = i.is_multi_domain, this.isWildcard = i.is_wildcard, this.key = i.key, i.service && (this.service = new Service(i.service), this.service.isCancellable = !i.service.cancellation), this.serviceId = i.service?.id, this.packageIdentity = i.service?.package?.identity, this.validFrom = i.valid_from_date, this.validTo = i.valid_to_date, this.formattedValidFrom = dateFormat(i.valid_from_date), this.formattedValidTo = dateFormat(i.valid_to_date);
  }
}const getSiteSslCerts = new Definition("/ssl-cert", "GET", e => ({
    list: e.data.map(e => new Certificate(e)),
    pagination: new Pagination(e)
  })),
  getSiteSslCert = new Definition("/ssl-cert/{id}", "GET", e => new Certificate(e.data)),
  decodeCsr = new Definition("/ssl-cert/decode-csr", "POST", e => new DecodedCertData(e.data)),
  addCert = new Definition("/ssl-cert", "POST", e => new Certificate(e.data)),
  getCsrDetails = new Definition("/ssl-cert/get-csr-details", "POST", e => e.data),
  getCsrDetailsWithCert = new Definition("/ssl-cert/{id}", "POST", e => e.data, null, e => ({
    _action: "get-csr-details",
    package_id: e.package_id
  })),
  getSslCert = new Definition("/ssl-cert/{id}?_fields%5B%5D=crt&_fields%5B%5D=key&_fields%5B%5D=chain_crts", "GET", e => new Certificate(e.data)),
  deleteSslCert = new Definition("/ssl-cert/{id}", "DELETE");var certificates=/*#__PURE__*/Object.freeze({__proto__:null,addCert:addCert,decodeCsr:decodeCsr,deleteSslCert:deleteSslCert,getCsrDetails:getCsrDetails,getCsrDetailsWithCert:getCsrDetailsWithCert,getSiteSslCert:getSiteSslCert,getSiteSslCerts:getSiteSslCerts,getSslCert:getSslCert});class ClientOptions {
  constructor(t = {}) {
    this.paymentTypes = void 0;
    this.paymentTypes = t.meta.options.payment_type;
  }
}const getClientOptions$1 = new Definition({
    path: "/client/self",
    method: "GET",
    responseBody: n => new ClientOptions(n.data),
    headers: {
      "Accept-Format": "nocworx/json-bundle"
    }
  }),
  updatePin$1 = new Definition("/client/{id}", "POST", n => n.data, null, n => ({
    pin: n.pin,
    _action: "edit-pin"
  })),
  updateDefaultPayment$1 = new Definition("/client/{id}", "POST", n => n.data, null, n => ({
    payment_type: n.paymentType,
    _action: "change-payment-type"
  }));var legacy$c=/*#__PURE__*/Object.freeze({__proto__:null,getClientOptions:getClientOptions$1,updateDefaultPayment:updateDefaultPayment$1,updatePin:updatePin$1});const req = t => Array.isArray(t) ? !!t.length : null != t && (!1 === t || (t instanceof Date ? !Number.isNaN(t.getTime()) : !!String(t).length));
const len = t => Array.isArray(t) ? t.length : "object" == typeof t ? Object.keys(t).length : String(t).length;
const regex = t => e => !req(e) || t.test(e);
function isFunction(t) {
  return "function" == typeof t;
}
function isTruthy(t) {
  return Boolean(isFunction(t) ? t() : t);
}const rules$1 = {
  AL: {
    regex: /^[a-zA-z0-9]{10}$/i,
    helper: "10 character identifier"
  },
  AU: {
    regex: /^\d{11}$/i,
    helper: "11 digit Australia Business Number (ABN)"
  },
  AT: {
    regex: /^\d{8}$/i,
    prefix: "AT",
    helper: "8 digit number"
  },
  BE: {
    regex: /^\d{10}$/i,
    prefix: "BE",
    helper: "10 digit number"
  },
  BG: {
    regex: /^\d{9,10}$/i,
    prefix: "BG",
    helper: "9 or 10 digit number"
  },
  CA: {
    regex: /^\d{9}([a-zA-Z]{2}\d{4})?$/i,
    helper: "9 digit business number or 15 character CRA program account number"
  },
  HR: {
    regex: /^\d{11}$/i,
    prefix: "HR",
    helper: "11 digit number"
  },
  CY: {
    regex: /^\d{9}$/i,
    prefix: "CY",
    helper: "9 digit number"
  },
  CZ: {
    regex: /^\d{8,10}$/i,
    prefix: "CZ",
    helper: "8-10 digit number"
  },
  DK: {
    regex: /^\d{8}$/i,
    prefix: "DK",
    helper: "8 digit number"
  },
  EE: {
    regex: /^\d{9}$/i,
    prefix: "EE",
    helper: "9 digit number"
  },
  EL: {
    regex: /^\d{9}$/i,
    prefix: "EL",
    helper: "9 digit number"
  },
  FI: {
    regex: /^\d{8}$/i,
    prefix: "FI",
    helper: "8 digit number"
  },
  FR: {
    regex: /^\d{11}$/i,
    prefix: "FR",
    helper: "11 digit number"
  },
  DE: {
    regex: /^\d{9}$/i,
    prefix: "DE",
    helper: "9 digit number"
  },
  GR: {
    regex: /^\d{9}$/i,
    prefix: "EL",
    helper: "9 digit number"
  },
  HU: {
    regex: /^\d{8}$/i,
    prefix: "HU",
    helper: "8 digit number"
  },
  IS: {
    regex: /^\d{6}$/i,
    prefix: "VSK",
    helper: "6 digit number"
  },
  IN: {
    regex: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/i,
    helper: "10 character Permanent Account Number (PAN)"
  },
  IE: {
    regex: /^\d{7}[a-zA-Z]{1,2}$/i,
    prefix: "IE",
    helper: "7 digits + either 1 or 2 letters"
  },
  IL: {
    regex: /^\d{9}$/i,
    helper: "9 digit number"
  },
  IT: {
    regex: /^\d{11}$/i,
    prefix: "IT",
    helper: "11 digit number"
  },
  JP: {
    regex: /^\d{12,13}$/i,
    helper: "12 digit Individual or 13 digit Corporate Number"
  },
  KR: {
    regex: /^(\d{10}|\d{13})$/i,
    helper: "13 digit Resident Registration Number or 10 digit Business Registration Number"
  },
  LV: {
    regex: /^\d{11}$/i,
    prefix: "LV",
    helper: "11 digit number"
  },
  LT: {
    regex: /^(\d{9}|\d{12})$/i,
    prefix: "LT",
    helper: "9 or 12 digit number"
  },
  LU: {
    regex: /^\d{8}$/i,
    prefix: "LU",
    helper: "8 digit number"
  },
  MT: {
    regex: /^\d{8}$/i,
    prefix: "MT",
    helper: "8 digit number"
  },
  NL: {
    regex: /^\d{9}B\d{2}$/i,
    prefix: "NL",
    helper: "9 digits + 'B' + 2 digit company index"
  },
  NZ: {
    regex: /^\d{13}$/i,
    prefix: "NZ",
    helper: "13 digit New Zealand Business Number"
  },
  NO: {
    regex: /^\d{9}$/i,
    prefix: "NO",
    helper: "9 digit number"
  },
  PL: {
    regex: /^[a-zA-Z0-9]{8,13}$/i,
    prefix: "PL",
    helper: "10 digit number"
  },
  PT: {
    regex: /^\d{9}$/i,
    prefix: "PT",
    helper: "9 digit number"
  },
  RO: {
    regex: /^\d{10}$/i,
    prefix: "RO",
    helper: "10 digit number"
  },
  RU: {
    regex: /^\d{10}$/i,
    prefix: "RU",
    helper: "10 digit number"
  },
  SK: {
    regex: /^\d{10}$/i,
    prefix: "SK",
    helper: "10 digit number"
  },
  SI: {
    regex: /^\d{8}$/i,
    prefix: "SI",
    helper: "8 digit number"
  },
  ZA: {
    regex: /^(0|1|2|3|9)\d{9}$/i,
    helper: "10 digit number"
  },
  ES: {
    regex: /^[a-zA-Z]?\d{8}[a-zA-Z]?$/i,
    prefix: "ES",
    helper: "9 digit number"
  },
  SE: {
    regex: /^\d{12}$/i,
    prefix: "SE",
    helper: "12 digit number"
  },
  CH: {
    regex: /^CHE\d{9}(MWST|TVA|IVA)$/i,
    helper: "'CHE' followed by 9 numbers, ending in 'MWST' or 'TVA' or 'IVA'"
  },
  GB: {
    regex: /^((\d{9})|(\d{12})|(GD[0-4][0-9]{2})|((HA[5-9][0-9]{2})))$/i,
    prefix: "GB",
    helper: "9 digits, or 12 digits, or 'GD' then 3 digits from 000 to 499, or 'HA' then 3 digits from 500 to 999"
  }
};
const validate$2 = (e, r) => !req(e) || r.test(e);
const taxExempt = (e, r) => {
  if (r) {
    const i = rules$1[r];
    if (i) {
      const r = new RegExp(i.regex, "gi");
      return validate$2(e, r);
    }
    return !0;
  }
  return (r, i) => {
    let d;
    if (i?.[e]?.value && rules$1[i[e].value] ? d = rules$1[i[e].value] : i?.countryCode?.value && rules$1[i.countryCode.value] && (d = rules$1[i.countryCode.value]), d) {
      const e = new RegExp(d.regex, "gi");
      return validate$2(r, e);
    }
    return !0;
  };
};
const TAX_EXEMPT_COUNTRIES = ["US", "AU", "GB", "AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PO", "PT", "RO", "SE", "SI", "SK", "NO"];
const isTaxExemptCountry = e => TAX_EXEMPT_COUNTRIES.includes(e);class Client {
  constructor(e = {}) {
    this.affiliateLevelID = void 0;
    this.allowTaxExemption = void 0;
    this.cloudServerCount = void 0;
    this.colocationCount = void 0;
    this.credits = void 0;
    this.creditCardNumber = void 0;
    this.dedicatedServerCount = void 0;
    this.domainCount = void 0;
    this.due = void 0;
    this.enterpriseCloudCount = void 0;
    this.externalKey = void 0;
    this.hasRdns = void 0;
    this.hasRdnsIps = void 0;
    this.hasRdnsRecords = void 0;
    this.id = void 0;
    this.name = void 0;
    this.otherCount = void 0;
    this.overdue = void 0;
    this.paymentType = void 0;
    this.pin = void 0;
    this.planCount = void 0;
    this.resellerHostingCount = void 0;
    this.sharedHostingCount = void 0;
    this.taxCountry = void 0;
    this.taxExemptNumber = void 0;
    this.isPartner = void 0;
    this.mrc = void 0;
    this.supportTierId = void 0;
    this.supportTierName = void 0;
    this.supportTierPhoneNumbers = void 0;
    this.supportTierChatSupport = void 0;
    this.id = e.id, this.name = e.name, this.pin = e.pin, this.externalKey = e.external_key, this.isPartner = e.affiliate_info?.is_affiliate || !1, this.affiliateLevelID = e.affiliate_info?.level?.id, this.startDate = 1e3 * e.start_date, this.mrc = e.mrc, this.supportTierId = e?.support_tier?.tier_id, this.supportTierName = e?.support_tier?.tier_name, this.supportTierPhoneNumbers = e?.support_tier?.meta?.phone_numbers, this.supportTierChatSupport = e?.support_tier?.meta?.chat_support, this.taxCountry = e.billing_address ? e.billing_address.country : e.billing?.address?.country, this.allowTaxExemption = isTaxExemptCountry(this.taxCountry), this.taxExemptNumber = e.tax_exempt?.number, this.isTaxExempt = !!this.taxExemptNumber, this.credits = e.billing?.credit_amount, this.due = e.billing?.amount_due, this.overdue = e.billing?.amount_overdue, this.paymentType = e.billing?.payment_type, this.requiresCreditCard = e.requires_creditcard, this.cloudServerCount = e.services?.counts?.["cloud-server"]?.production || 0, this.colocationCount = e.services?.counts?.colocation?.production || 0, this.dedicatedServerCount = e.services?.counts?.dedicated?.production || 0, this.domainCount = e.services?.counts?.domain?.production || 0, this.enterpriseCloudCount = e.services?.counts?.["virt-guest-enterprise"]?.production || 0, this.otherCount = e.services?.counts?.generic?.production || 0, this.planCount = e.services?.counts?.site?.production || 0, this.resellerHostingCount = e.services?.counts?.["shared-reseller"]?.production || 0, this.sharedHostingCount = e.services?.counts?.shared?.production || 0, this.hasRdns = e.services?.has_rdnsable_ips || e.services?.has_rdns_records, this.hasRdnsIps = e.services?.has_rdnsable_ips, this.hasRdnsRecords = e.services?.has_rdns_records;
  }
}const editClient$2 = new Definition({
    path: "/api/v1/client",
    method: "POST",
    responseBody: e => e.data
  }),
  getClient$1 = new Definition({
    path: "/api/v1/client/self",
    method: "GET",
    responseBody: e => new Client(e.data)
  });var v1$c=/*#__PURE__*/Object.freeze({__proto__:null,editClient:editClient$2,getClient:getClient$1});const {
  getClientOptions: getClientOptions,
  updateDefaultPayment: updateDefaultPayment,
  updatePin: updatePin
} = legacy$c;
const {
  editClient: editClient$1,
  getClient: getClient
} = v1$c;var client=/*#__PURE__*/Object.freeze({__proto__:null,editClient:editClient$1,getClient:getClient,getClientOptions:getClientOptions,updateDefaultPayment:updateDefaultPayment,updatePin:updatePin});class Location {
  constructor(t = {}) {
    this.country = void 0;
    this.code = void 0;
    this.id = void 0;
    this.name = void 0;
    this.type = void 0;
    this.country = t.country, this.code = t.location_code, this.id = t.id, this.name = t.location, this.type = t.type;
  }
}const getLocations = new Definition("/api/v1/cloud", "GET", o => o.data.map(o => new Location(o)));var clouds=/*#__PURE__*/Object.freeze({__proto__:null,getLocations:getLocations});const createCloudServer$1 = new Definition("/api/v1/cloud-server", "POST", s => s.data, null, s => {
  const d = {
    cloud_id: s.locationId,
    hostname: s.hostname,
    os_id: s.osId,
    package_id: s.packageId,
    use_password: s.usePassword
  };
  return s.sshKeyIds.length && (d.ssh_key_ids = s.sshKeyIds), s.addonIds.length && (d.addon_ids = s.addonIds), d;
});var v1$b=/*#__PURE__*/Object.freeze({__proto__:null,createCloudServer:createCloudServer$1});class BandwidthProfile {
  constructor(e = {}) {
    this.overageFee = void 0;
    this.previous = void 0;
    this.profileId = void 0;
    this.projected = void 0;
    this.type = void 0;
    this.used = void 0;
    this.value = void 0;
    this.overageFee = e.overageFee, this.profileId = e.profileId, this.type = e.bandwidth?.type, this.previous = e.bandwidth.previous, this.projected = e.bandwidth.projected, this.used = e.bandwidth.used, this.value = e.bandwidth.given;
  }
}class CloudServerPackage extends Package {
  constructor(e = {}, a = {}) {
    (super(e, a), this.diskSpace = void 0, this.bandwidth = void 0, this.ram = void 0, this.hourlyFee = void 0), this.diskSpace = e.disk / 1024, this.bandwidth = e.bandwidth / 1024, this.ram = a.virt_ram / 1024, this.hourlyFee = this.monthlyFee / 672;
  }
}class Datashare {
  constructor(e = {}) {
    this.expirationDate = void 0;
    this.expired = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.maxViews = void 0;
    this.owner = void 0;
    this.ownerId = void 0;
    this.ownerObject = void 0;
    this.sharedDate = void 0;
    this.type = void 0;
    this.uuid = void 0;
    this.views = void 0;
    this.expirationDate = e.expiration_date, this.expired = e.expired, this.id = e.id, this.identity = e.identity, this.maxViews = e.max_uses, this.owner = e.owner, this.ownerId = e.owner_id || e.owner?.id, this.ownerObject = e.owner_object, this.sharedDate = e.share_date, this.type = e.type, this.uuid = e.uuid, this.views = e.uses;
  }
}class CloudServer extends Service {
  constructor(e = {}) {
    (super(e), this.autoRenew = void 0, this.bandwidth = void 0, this.isCancellable = void 0, this.settings = void 0), this.autoRenew = e.auto_renew, this.bandwidth = new BandwidthProfile({
      bandwidth: e.bandwidth,
      overageFee: e.bandwidth_overage_fee,
      profileId: e.bandwidth_profile_id
    }), this.canChangeRootPassword = e.can_change_root_password, this.cloudStatus = e.cloud_status, this.datashare = new Datashare(e.datashare), this.diskSpace = e.disk_space, this.externalKey = e.external_key, this.hasConsole = e.has_console, this.host = e.host, this.isCancellable = e.is_cancellable, this.isRebootable = e.is_rebootable, this.location = new Location(e.location), this.mainIp = e.main_ip?.id, this.operatingSystem = new OperatingSystem(e.os), this.package = new CloudServerPackage(e.package), this.settings = e.settings, this.formattedDiskSpace = sizeFormat(toBytes(e.disk_space, "gb"), {
      round: 0
    });
  }
}const getCloudServer$1 = new Definition("/service/{id}", "GET", e => new CloudServer(e.data)),
  getCloudServers$1 = new Definition("/service?type=virt-guest", "GET", e => ({
    list: e.data.map(e => new CloudServer(e)),
    pagination: new Pagination(e)
  })),
  deleteCloudServer$1 = new Definition("/service/{id}", "DELETE"),
  resizeCloudServer$1 = new Definition("/service/{id}", "POST", e => new CloudServer(e.data), null, e => ({
    _action: "resize",
    package_id: e.packageId
  }));var legacy$b=/*#__PURE__*/Object.freeze({__proto__:null,deleteCloudServer:deleteCloudServer$1,getCloudServer:getCloudServer$1,getCloudServers:getCloudServers$1,resizeCloudServer:resizeCloudServer$1});const {
  deleteCloudServer: deleteCloudServer,
  getCloudServer: getCloudServer,
  getCloudServers: getCloudServers,
  resizeCloudServer: resizeCloudServer
} = legacy$b;
const {
  createCloudServer: createCloudServer
} = v1$b;var cloudServers=/*#__PURE__*/Object.freeze({__proto__:null,createCloudServer:createCloudServer,deleteCloudServer:deleteCloudServer,getCloudServer:getCloudServer,getCloudServers:getCloudServers,resizeCloudServer:resizeCloudServer});class EdgecastAccount {
  constructor(a = {}) {
    this.apacEnabled = void 0;
    this.id = void 0;
    this.sharedSslEnabled = void 0;
    this.apacEnabled = a.apac_enabled, this.id = a.id, this.sharedSslEnabled = a.shared_ssl_enabled;
  }
}class Colocation extends Service {
  constructor(e = {}) {
    (super(e), this.autoRenew = void 0, this.bandwidth = void 0, this.isCancellable = void 0, this.isRebootable = void 0, this.mainIp = void 0, this.settings = void 0), this.addons = (e.addons || []).map(e => new Addon(e)), this.allocations = (e.allocations || []).map(e => new Allocation(e)), this.autoRenew = e.auto_renew, this.bandwidth = new BandwidthProfile({
      bandwidth: e.bandwidth,
      overageFee: e.bandwidth_overage_fee,
      profileId: e.bandwidth_profile_id
    }), this.edgecast = new EdgecastAccount(e.edgecast), this.isCancellable = e.is_cancellable, this.isRebootable = e.is_rebootable, this.mainIp = e.main_ip?.id, this.settings = e.settings;
  }
}const getColocation = new Definition("/service/{id}", "GET", o => new Colocation(o.data)),
  getColocations = new Definition("/service?type=colocation", "GET", o => ({
    list: o.data.map(o => new Colocation(o)),
    pagination: new Pagination(o)
  }));var colocations=/*#__PURE__*/Object.freeze({__proto__:null,getColocation:getColocation,getColocations:getColocations});class CreditCard {
  constructor(i = {}) {
    this.expiration = void 0;
    this.expired = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.name = void 0;
    this.number = void 0;
    this.paymentType = void 0;
    this.primary = void 0;
    this.type = void 0;
    this.expiration = i.expiration, this.id = i.id, this.number = i.number, this.type = i.type, this.primary = i.is_primary, this.name = i.name, this.identity = i.identity, this.expired = i.is_expired, this.paymentType = "cc";
  }
}const getCreditCard = new Definition("/creditcard/{id}", "GET", i => new CreditCard(i.data)),
  getCreditCards = new Definition("/creditcard", "GET", i => ({
    list: i.data.map(i => new CreditCard(i)),
    pagination: new Pagination(i)
  })),
  createCreditCard = new Definition("/creditcard", "POST", i => new CreditCard(i.data), null, i => ({
    name: i.name,
    expiration: i.expiration,
    number: i.number,
    cvv: i.cvv,
    make_primary: i.primary
  })),
  updateCreditCard = new Definition("/creditcard/{id}", "PATCH", i => new CreditCard(i.data)),
  deleteCreditCard = new Definition("/creditcard/{id}", "DELETE", i => i.data),
  setPrimary = new Definition("/creditcard/{id}", "POST", i => i.data, null, () => ({
    _action: "make-primary"
  }));var creditCards=/*#__PURE__*/Object.freeze({__proto__:null,createCreditCard:createCreditCard,deleteCreditCard:deleteCreditCard,getCreditCard:getCreditCard,getCreditCards:getCreditCards,setPrimary:setPrimary,updateCreditCard:updateCreditCard});class Credit {
  constructor(t = {}) {
    this.amount = void 0;
    this.date = void 0;
    this.description = void 0;
    this.id = void 0;
    this.remainingAmount = void 0;
    this.amount = t.amount, this.date = t.credit_date, this.description = t.description, this.formattedDate = dateFormat(t.credit_date), this.formattedDescription = (t.description || "").split(/\n(.+)/)[0], this.formattedStatus = `${t.status?.charAt(0)?.toUpperCase()}${t.status?.slice(1)}`, this.id = t.id, this.remainingAmount = t.remaining_amount, this.status = t.status;
  }
}const getCredit = new Definition("/credit/{id}", "GET", e => new Credit(e.data)),
  getCredits = new Definition("/credit", "GET", e => ({
    list: e.data.map(e => new Credit(e)),
    pagination: new Pagination(e)
  })),
  redeemCredit = new Definition("/credit", "POST", e => new Credit(e.data), null, e => ({
    code: e.name,
    _action: "redeem"
  })),
  releaseCredit = new Definition("/credit/{id}", "POST", e => e.data, null, () => ({
    _action: "release-credit"
  }));var credits=/*#__PURE__*/Object.freeze({__proto__:null,getCredit:getCredit,getCredits:getCredits,redeemCredit:redeemCredit,releaseCredit:releaseCredit});class Database {
  constructor(t = {}) {
    this.fqd = void 0;
    this.host = void 0;
    this.name = void 0;
    this.storage = void 0;
    this.fqdn = t.fqdn, this.host = t.host, this.name = t.name, this.storage = t.storage;
  }
}class Password {
  constructor(i = {}) {
    this.id = void 0;
    this.identity = void 0;
    this.expirationDate = void 0;
    this.maxViews = void 0;
    this.ownerId = void 0;
    this.sharedDate = void 0;
    this.type = void 0;
    this.unlimited = void 0;
    this.uuid = void 0;
    this.views = void 0;
    this.id = i.id, this.identity = i.identity, this.unlimited = -1 === i.expiration_date && -1 === i.max_uses, this.expirationDate = i.expiration_date, this.maxViews = i.max_uses, this.ownerId = i.owner?.id, this.sharedDate = i.share_date, this.type = i.type, this.uuid = i.uuid, this.views = i.uses;
  }
}class DatabaseUserPassword extends Password {
  constructor(s = {}) {
    (super(s), this.siteId = void 0, this.canViewPassword = void 0), this.siteId = s.owner_id || this.ownerId, this.canViewPassword = this.views < this.maxViews;
  }
}class DatabaseUser {
  constructor(a = {}) {
    this.fqun = void 0;
    this.databases = void 0;
    this.name = void 0;
    this.fqun = a.fqun, this.databases = a.databases, this.name = a.name, this.password = new DatabaseUserPassword(a.datashare);
  }
}const getSiteDbs = new Definition("/cloud-account/{siteId}/mysql/db", "GET", e => ({
    list: e.data.map(e => new Database(e)),
    pagination: new Pagination(e)
  })),
  quickAddSiteDbWithUser = new Definition("/cloud-account/{siteId}/mysql", "POST", e => e.data, null, e => {
    const t = {
        db_name: e.dbName,
        username: e.username,
        _action: "add-db-and-user"
      },
      {
        readOnly: a
      } = e;
    return !0 === a && (t.readonly = "on"), t;
  }),
  createSiteDb = new Definition("/cloud-account/{siteId}/mysql/db", "POST", e => e.data, null, e => ({
    name: e.dbName
  })),
  deleteSiteDb = new Definition("/cloud-account/{siteId}/mysql/db/{dbName}", "DELETE", e => e.data),
  getSiteDbUsers = new Definition("/cloud-account/{siteId}/mysql/user", "GET", e => ({
    list: e.data.map(e => new DatabaseUser(e)),
    pagination: new Pagination(e)
  })),
  createSiteDbUser = new Definition("/cloud-account/{siteId}/mysql/user", "POST", e => e.data),
  regenPasswordSiteDbUser = new Definition("/cloud-account/{siteId}/mysql/user", "POST", e => e.data, null, e => ({
    name: e.name,
    _action: "regenerate-password"
  })),
  deleteSiteDbUser = new Definition("/cloud-account/{siteId}/mysql/user/{name}", "DELETE", e => e.data);var databases=/*#__PURE__*/Object.freeze({__proto__:null,createSiteDb:createSiteDb,createSiteDbUser:createSiteDbUser,deleteSiteDb:deleteSiteDb,deleteSiteDbUser:deleteSiteDbUser,getSiteDbUsers:getSiteDbUsers,getSiteDbs:getSiteDbs,quickAddSiteDbWithUser:quickAddSiteDbWithUser,regenPasswordSiteDbUser:regenPasswordSiteDbUser});const getDataShare = new Definition({
  path: "/api/v1/datashare/{uuid}",
  method: "GET",
  responseBody: a => new Datashare(a.data)
});var datashares=/*#__PURE__*/Object.freeze({__proto__:null,getDataShare:getDataShare});class DedicatedServer extends Service {
  constructor(e = {}) {
    (super(e), this.allocation = void 0, this.autoRenew = void 0, this.bandwidth = void 0, this.isCancellable = void 0, this.isRebootable = void 0, this.settings = void 0), this.addons = (e.addons || []).map(e => new Addon(e)), this.allocation = new Allocation(e.allocation), this.allocations = (e.allocations || []).map(e => new Allocation(e)), this.autoRenew = e.auto_renew, this.bandwidth = new BandwidthProfile({
      bandwidth: e.bandwidth,
      overageFee: e.bandwidth_overage_fee,
      profileId: e.bandwidth_profile_id
    }), this.edgecast = new EdgecastAccount(e.edgecast), this.isCancellable = e.is_cancellable, this.isRebootable = e.is_rebootable, this.settings = e.settings;
  }
}const getDedicatedServer = new Definition("/service/{id}", "GET", e => new DedicatedServer(e.data)),
  getDedicatedServers = new Definition("/service?type=dedicated", "GET", e => ({
    list: e.data.map(e => new DedicatedServer(e)),
    pagination: new Pagination(e)
  }));var dedicatedServers=/*#__PURE__*/Object.freeze({__proto__:null,getDedicatedServer:getDedicatedServer,getDedicatedServers:getDedicatedServers});class Domain extends Service {
  constructor(e = {}) {
    (super(e), this.domain = void 0, this.formattedCreated = void 0, this.isCancellable = void 0), this.domain = e?.domain?.identity, this.formattedCreated = dateFormat(e.start_date), this.isCancellable = this.isCancellable || e.is_cancellable;
  }
}const getDomain$1 = new Definition("/service/{id}", "GET", i => new Domain(i.data));
const getDomains$1 = new Definition("/service?type=domain", "GET", i => ({
  list: i.data.map(i => new Domain(i)),
  pagination: new Pagination(i)
}));var legacy$a=/*#__PURE__*/Object.freeze({__proto__:null,getDomain:getDomain$1,getDomains:getDomains$1});class DomainAddon {
  constructor(e = {}) {
    this.id = void 0;
    this.identity = void 0;
    this.monthlyFee = void 0;
    this.annualFee = void 0;
    this.name = void 0;
    this.type = void 0;
    this.pricing = void 0;
    this.id = e.id, this.identity = e.identity, this.name = e.name, this.monthlyFee = parseFloat(e.term_fees?.[1]), this.annualFee = parseFloat(e.term_fees?.[12]), this.type = e.type, this.pricing = e.term_fees;
  }
  static getPrice(e, t) {
    return e ? "monthly" === t ? e.monthlyFee : e.annualFee : 0;
  }
}class DomainPackage {
  constructor(e = {}) {
    this.id = void 0;
    this.label = void 0;
    this.identity = void 0;
    this.name = void 0;
    this.type = void 0;
    this.environmentType = void 0;
    this.isWildcard = void 0;
    this.autoRenew = void 0;
    this.bandwidth = void 0;
    this.billingType = void 0;
    this.monthlyFee = void 0;
    this.annualFee = void 0;
    this.addons = void 0;
    this.tld = void 0;
    this.pricing = void 0;
    this.id = e.id, this.label = e.label, this.identity = e.identity, this.name = e.name, this.type = e.type, this.environmentType = e.environment_type, this.isWildcard = e.is_wildcard, this.autoRenew = e.auto_renew, this.bandwidth = e.bandwidth, this.billingType = e.billing_type, this.monthlyFee = parseFloat(e.term_fees[1]), this.annualFee = parseFloat(e.term_fees[12]), this.addons = e.addons.map(e => new DomainAddon(e)), this.tld = e.tld, this.pricing = e.term_fees;
  }
  static getFullAnnualPrice(e) {
    return 12 * e.monthlyFee;
  }
  static getAnnualDiscount(e) {
    return 12 * e.monthlyFee - e.annualFee;
  }
  static getAddons(e, t) {
    return e ? e.addons.filter(({
      id: e
    }) => t.includes(e)) : [];
  }
  static getAddonPrices(e, t, i) {
    if (!e) return 0;
    return e.addons.filter(({
      id: e
    }) => i.includes(e)).reduce((e, i) => e + DomainAddon.getPrice(i, t), 0);
  }
}const registerDomain$1 = new Definition({
  path: "/api/v1/domain",
  method: "POST",
  requestBody: a => {
    const t = {
        discount_code: a.discountCode,
        package_id: a.packageId,
        term: a.term,
        type: "domain",
        tld_id: a.tldId,
        domain_name: a.domainName
      },
      n = {};
    return a.contact.addressId ? n.address_id = a.contact.addressId : a.contact.delegateContact ? n.delegate_contact = !0 : (n.first_name = a.contact.firstName, n.last_name = a.contact.lastName, n.company = a.contact.company, n.address1 = a.contact.address1, n.address2 = a.contact.address2, n.city = a.contact.city, n.state = a.contact.state, n.zip = a.contact.zip, n.country = a.contact.country, n.phone = a.contact.phone, n.email = a.contact.email), t.contact = {
      owner: n,
      admin: n,
      billing: n,
      technical: n
    }, a.addonIds && a.addonIds.length && (t.addon_ids = a.addonIds), a.UIFlowUUID && (t._ui_flow_uuid = a.UIFlowUUID), t;
  }
});
const getDomainTlds$1 = new Definition({
  path: "/api/v1/domain/tld",
  method: "GET",
  responseBody: a => a.data
});
const searchDomains$1 = new Definition({
  path: "/api/v1/domain/lookup/{domain}",
  method: "GET",
  requestBody: a => ({
    domain: a.domain
  }),
  responseBody: ({
    data: a
  }) => ({
    alternatives: a.alternatives.map(a => ({
      ...a,
      package: a.package ? new DomainPackage(a.package) : null
    })),
    domain: {
      ...a.domain,
      package: a?.domain?.package ? new DomainPackage(a?.domain?.package) : null
    }
  })
});var v1$a=/*#__PURE__*/Object.freeze({__proto__:null,getDomainTlds:getDomainTlds$1,registerDomain:registerDomain$1,searchDomains:searchDomains$1});const {
  registerDomain: registerDomain,
  getDomainTlds: getDomainTlds,
  searchDomains: searchDomains
} = v1$a;
const {
  getDomain: getDomain,
  getDomains: getDomains
} = legacy$a;var domains$1=/*#__PURE__*/Object.freeze({__proto__:null,getDomain:getDomain,getDomainTlds:getDomainTlds,getDomains:getDomains,registerDomain:registerDomain,searchDomains:searchDomains});class DnsZone {
  constructor(t = {}) {
    this.id = void 0;
    this.contact = void 0;
    this.domain = void 0;
    this.expire = void 0;
    this.identity = void 0;
    this.records = void 0;
    this.type = void 0;
    this.id = t.id, this.contact = t.contact, this.domain = t.domain, this.expire = t.expire, this.identity = t.identity, this.records = t.record_count, this.ttl = t.ttl, this.type = t.type;
  }
}class RdnsRecord {
  constructor(t = {}) {
    this.id = void 0;
    this.host = void 0;
    this.identity = void 0;
    this.target = void 0;
    this.ttl = void 0;
    this.type = void 0;
    this.updateDate = void 0;
    this.id = t.id, this.host = t.host, this.identity = t.identity, this.target = t.target, this.ttl = t.ttl, this.type = t.type, this.updateDate = t.update_date;
  }
}class DnsZoneRecord {
  constructor(t = {}) {
    this.host = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.target = void 0;
    this.ttl = void 0;
    this.type = void 0;
    this.restrictions = void 0;
    this.host = t.host, this.identity = t.identity, this.id = t.id, this.target = t.target, this.ttl = t.ttl, this.type = t.type, this.restrictions = t.restrictions;
  }
}const addDnsZoneARecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.ipAddress,
    ttl: e.ttl,
    type: "A",
    zone_id: e.dnsZoneId
  })
});
const updateDnsZoneARecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.ipAddress,
    ttl: e.ttl,
    type: "A",
    _force: e.force
  })
});const addDnsZoneAliasRecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    target: e.hostname,
    ttl: e.ttl,
    type: "ALIAS",
    zone_id: e.dnsZoneId
  })
});
const updateDnsZoneAliasRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    target: e.hostname,
    ttl: e.ttl,
    type: "ALIAS",
    _force: e.force
  })
});const addDnsZoneAAAARecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.ipAddress,
    ttl: e.ttl,
    type: "AAAA",
    zone_id: e.dnsZoneId
  })
});
const updateDnsZoneAAAARecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.ipAddress,
    ttl: e.ttl,
    type: "AAAA",
    _force: e.force
  })
});const addDnsZoneCaaRecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    host: t.hostname,
    target: `${t.flag} ${t.tag.trim()} ${t.value.trim()}`,
    ttl: t.ttl,
    type: "CAA",
    zone_id: t.dnsZoneId
  })
});
const updateDnsZoneCaaRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    host: t.hostname,
    target: `${t.flag} ${t.tag.trim()} ${t.value.trim()}`,
    ttl: t.ttl,
    type: "CAA",
    _force: t.force
  })
});const addDnsZoneCnameRecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.aliasTo,
    ttl: e.ttl,
    type: "CNAME",
    zone_id: e.dnsZoneId
  })
});
const updateDnsZoneCnameRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.aliasTo,
    ttl: e.ttl,
    type: "CNAME",
    _force: e.force
  })
});const addDnsZoneMxRecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.subdomain,
    target: `${e.preference} ${e.mailServer}`,
    ttl: e.ttl,
    type: "MX",
    zone_id: e.dnsZoneId
  })
});
const updateDnsZoneMxRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.subdomain,
    target: `${e.preference} ${e.mailServer}`,
    ttl: e.ttl,
    type: "MX",
    _force: e.force
  })
});const addDnsZoneNsRecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.subdomain,
    target: e.nameServer,
    ttl: e.ttl,
    type: "NS",
    zone_id: e.dnsZoneId
  })
});
const updateDnsZoneNsRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.subdomain,
    target: e.nameServer,
    ttl: e.ttl,
    type: "NS",
    _force: e.force
  })
});const addDnsZoneSrvRecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    host: `_${t.service.trim()}._${t.protocol.trim()}.${t.dnsZoneDomain}`,
    target: `${t.priority} ${t.weight} ${t.port} ${t.target.trim()}`,
    ttl: t.ttl,
    type: "SRV",
    zone_id: t.dnsZoneId
  })
});
const updateDnsZoneSrvRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    host: `_${t.service.trim()}._${t.protocol.trim()}.${t.dnsZoneDomain}`,
    target: `${t.priority} ${t.weight} ${t.port} ${t.target.trim()}`,
    ttl: t.ttl,
    type: "SRV",
    _force: t.force
  })
});const addDnsZoneTxtRecord$2 = new Definition({
  path: "/api/v1/dns/record",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.value,
    ttl: e.ttl,
    type: "TXT",
    zone_id: e.dnsZoneId
  })
});
const updateDnsZoneTxtRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    host: e.hostname,
    target: e.value,
    ttl: e.ttl,
    type: "TXT",
    _force: e.force
  })
});const getDnsZoneRecords$1 = new Definition({
  path: "/api/v1/dns/zone/{id}/record",
  method: "GET",
  transformParams: o => transformSortParamsToV1(o),
  responseBody: o => ({
    dnsZoneId: Number(o.config.url.match(/\/api\/v1\/dns\/zone\/(.*)\/record/)[1]),
    list: o.data.map(o => new DnsZoneRecord(o)),
    pagination: new Pagination(o)
  })
});
const deleteDnsZoneRecord$1 = new Definition({
  path: "/api/v1/dns/record/{id}",
  method: "DELETE",
  responseBody: o => o.data,
  requestBody: o => ({
    _force: o.force
  })
});const getDnsZone$1 = new Definition("/api/v1/dns/zone/{id}", "GET", n => new DnsZone(n.data));
const getDnsZones$1 = new Definition("/api/v1/dns/zone", "GET", n => ({
  list: n.data.map(n => new DnsZone(n)),
  pagination: new Pagination(n)
}), null, null, null, n => transformSortParamsToV1(n));
const getRdnsRecords$1 = new Definition("/api/v1/dns/reverse", "GET", n => n.data.map(n => new RdnsRecord(n)));
const getRdnsRecord$1 = new Definition("/api/v1/dns/reverse/{id}", "GET", n => new RdnsRecord(n.data));
const getNameServers$2 = new Definition("/api/v1/dns/nameservers", "GET", n => n.data);var v1$9=/*#__PURE__*/Object.freeze({__proto__:null,addDnsZoneAAAARecord:addDnsZoneAAAARecord$2,addDnsZoneARecord:addDnsZoneARecord$2,addDnsZoneAliasRecord:addDnsZoneAliasRecord$2,addDnsZoneCaaRecord:addDnsZoneCaaRecord$2,addDnsZoneCnameRecord:addDnsZoneCnameRecord$2,addDnsZoneMxRecord:addDnsZoneMxRecord$2,addDnsZoneNsRecord:addDnsZoneNsRecord$2,addDnsZoneSrvRecord:addDnsZoneSrvRecord$2,addDnsZoneTxtRecord:addDnsZoneTxtRecord$2,deleteDnsZoneRecord:deleteDnsZoneRecord$1,getDnsZone:getDnsZone$1,getDnsZoneRecords:getDnsZoneRecords$1,getDnsZones:getDnsZones$1,getNameServers:getNameServers$2,getRdnsRecord:getRdnsRecord$1,getRdnsRecords:getRdnsRecords$1,updateDnsZoneAAAARecord:updateDnsZoneAAAARecord$1,updateDnsZoneARecord:updateDnsZoneARecord$1,updateDnsZoneAliasRecord:updateDnsZoneAliasRecord$1,updateDnsZoneCaaRecord:updateDnsZoneCaaRecord$1,updateDnsZoneCnameRecord:updateDnsZoneCnameRecord$1,updateDnsZoneMxRecord:updateDnsZoneMxRecord$1,updateDnsZoneNsRecord:updateDnsZoneNsRecord$1,updateDnsZoneSrvRecord:updateDnsZoneSrvRecord$1,updateDnsZoneTxtRecord:updateDnsZoneTxtRecord$1});const addDnsZoneGoogleMailRecords$2 = new Definition("/dns-zone/{id}", "POST", () => null, null, () => ({
  type: "google",
  _action: "shortcut"
}));var googleMailRecord=/*#__PURE__*/Object.freeze({__proto__:null,addDnsZoneGoogleMailRecords:addDnsZoneGoogleMailRecords$2});const addDnsZone$3 = new Definition({
  path: "/dns-zone",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    domain: e.domain
  }),
  transformError: e => {
    const n = Object.entries(e.response.data).map(([e, n]) => `${e}: ${n}`);
    return new HTTPError({
      status: e.request.status,
      messages: n
    });
  }
});
const deleteDnsZone$2 = new Definition("/dns-zone/{id}", "DELETE", () => null);
const getDnsZoneAuthoritative$2 = new Definition("/dns-zone/authoritative", "GET", e => e.data);var zone=/*#__PURE__*/Object.freeze({__proto__:null,addDnsZone:addDnsZone$3,deleteDnsZone:deleteDnsZone$2,getDnsZoneAuthoritative:getDnsZoneAuthoritative$2});const {
  addDnsZoneGoogleMailRecords: addDnsZoneGoogleMailRecords$1
} = googleMailRecord;
const {
  addDnsZone: addDnsZone$2,
  deleteDnsZone: deleteDnsZone$1,
  getDnsZoneAuthoritative: getDnsZoneAuthoritative$1
} = zone;var legacy$9=/*#__PURE__*/Object.freeze({__proto__:null,addDnsZone:addDnsZone$2,addDnsZoneGoogleMailRecords:addDnsZoneGoogleMailRecords$1,deleteDnsZone:deleteDnsZone$1,getDnsZoneAuthoritative:getDnsZoneAuthoritative$1});const {
  addDnsZone: addDnsZone$1,
  addDnsZoneGoogleMailRecords: addDnsZoneGoogleMailRecords,
  deleteDnsZone: deleteDnsZone,
  getDnsZoneAuthoritative: getDnsZoneAuthoritative
} = legacy$9;
const {
  addDnsZoneARecord: addDnsZoneARecord$1,
  addDnsZoneAliasRecord: addDnsZoneAliasRecord$1,
  addDnsZoneAAAARecord: addDnsZoneAAAARecord$1,
  addDnsZoneCaaRecord: addDnsZoneCaaRecord$1,
  addDnsZoneCnameRecord: addDnsZoneCnameRecord$1,
  addDnsZoneMxRecord: addDnsZoneMxRecord$1,
  addDnsZoneNsRecord: addDnsZoneNsRecord$1,
  addDnsZoneSrvRecord: addDnsZoneSrvRecord$1,
  addDnsZoneTxtRecord: addDnsZoneTxtRecord$1,
  deleteDnsZoneRecord: deleteDnsZoneRecord,
  getDnsZone: getDnsZone,
  getDnsZoneRecords: getDnsZoneRecords,
  getDnsZones: getDnsZones,
  getNameServers: getNameServers$1,
  getRdnsRecords: getRdnsRecords,
  getRdnsRecord: getRdnsRecord,
  updateDnsZoneARecord: updateDnsZoneARecord,
  updateDnsZoneAliasRecord: updateDnsZoneAliasRecord,
  updateDnsZoneAAAARecord: updateDnsZoneAAAARecord,
  updateDnsZoneCaaRecord: updateDnsZoneCaaRecord,
  updateDnsZoneCnameRecord: updateDnsZoneCnameRecord,
  updateDnsZoneMxRecord: updateDnsZoneMxRecord,
  updateDnsZoneNsRecord: updateDnsZoneNsRecord,
  updateDnsZoneSrvRecord: updateDnsZoneSrvRecord,
  updateDnsZoneTxtRecord: updateDnsZoneTxtRecord
} = v1$9;var dns$1=/*#__PURE__*/Object.freeze({__proto__:null,addDnsZone:addDnsZone$1,addDnsZoneAAAARecord:addDnsZoneAAAARecord$1,addDnsZoneARecord:addDnsZoneARecord$1,addDnsZoneAliasRecord:addDnsZoneAliasRecord$1,addDnsZoneCaaRecord:addDnsZoneCaaRecord$1,addDnsZoneCnameRecord:addDnsZoneCnameRecord$1,addDnsZoneGoogleMailRecords:addDnsZoneGoogleMailRecords,addDnsZoneMxRecord:addDnsZoneMxRecord$1,addDnsZoneNsRecord:addDnsZoneNsRecord$1,addDnsZoneSrvRecord:addDnsZoneSrvRecord$1,addDnsZoneTxtRecord:addDnsZoneTxtRecord$1,deleteDnsZone:deleteDnsZone,deleteDnsZoneRecord:deleteDnsZoneRecord,getDnsZone:getDnsZone,getDnsZoneAuthoritative:getDnsZoneAuthoritative,getDnsZoneRecords:getDnsZoneRecords,getDnsZones:getDnsZones,getNameServers:getNameServers$1,getRdnsRecord:getRdnsRecord,getRdnsRecords:getRdnsRecords,updateDnsZoneAAAARecord:updateDnsZoneAAAARecord,updateDnsZoneARecord:updateDnsZoneARecord,updateDnsZoneAliasRecord:updateDnsZoneAliasRecord,updateDnsZoneCaaRecord:updateDnsZoneCaaRecord,updateDnsZoneCnameRecord:updateDnsZoneCnameRecord,updateDnsZoneMxRecord:updateDnsZoneMxRecord,updateDnsZoneNsRecord:updateDnsZoneNsRecord,updateDnsZoneSrvRecord:updateDnsZoneSrvRecord,updateDnsZoneTxtRecord:updateDnsZoneTxtRecord});class ClusterNode {
  constructor(t = {}) {
    this.host = void 0;
    this.id = void 0;
    this.ip = void 0;
    this.id = t.id, this.host = t.hostname, this.ip = t.main_ip;
  }
}class EnterpriseCloud extends Service {
  constructor(i = {}) {
    (super(i), this.addons = void 0, this.autoRenew = void 0, this.billing = void 0, this.clusterNodes = void 0, this.host = void 0, this.ip = void 0), this.addons = i.addons?.map(({
      addon: i,
      billing_info: e,
      quantity: t
    }) => ({
      addon: {
        id: i.id,
        identity: i.identity
      },
      price: e.term_price_total,
      quantity: t
    })), this.autoRenew = i.billing_info.auto_renew, this.host = i.main_node?.hostname, this.ip = i.main_node?.main_ip, this.billing = new Billing(i.billing_info), this.clusterNodes = i.nodes?.map(i => new ClusterNode(i)) || [];
  }
}const getEnterpriseCloudList = new Definition({
  path: "/api/v1/enterprise-cloud",
  method: "GET",
  responseBody: e => ({
    list: e.data.map(e => new EnterpriseCloud(e)),
    pagination: new Pagination(e)
  })
});
const getEnterpriseCloud = new Definition({
  path: "/api/v1/enterprise-cloud/{id}",
  method: "GET",
  responseBody: e => new EnterpriseCloud(e.data)
});var enterpriseCloud=/*#__PURE__*/Object.freeze({__proto__:null,getEnterpriseCloud:getEnterpriseCloud,getEnterpriseCloudList:getEnterpriseCloudList});class HUD {
  constructor(t = {}) {
    this.type = void 0;
    this.type = HUD.getType(t);
  }
  static getType(t) {
    return "cloud-account:status" === t.notification ? HUD.SITE : HUD.FRAUD;
  }
  static get SITE() {
    return "site";
  }
  static get FRAUD() {
    return "fraud";
  }
}class HUDFraud extends HUD {
  constructor(t = {}) {
    (super(t), this.id = void 0, this.invoice = void 0, this.orderDate = void 0, this.status = void 0), this.id = t.order_id, this.invoice = {
      description: t.invoice_description
    }, this.orderDate = t.order_date, this.status = t.status;
  }
}class HUDSite extends HUD {
  constructor(e = {}) {
    (super(e), this.app = void 0, this.domain = void 0, this.environment = void 0, this.id = void 0, this.name = void 0, this.package = void 0, this.plan = void 0, this.state = void 0), this.domain = e.client_domain || e.domain, this.id = e.cloudaccount_id, this.name = e.nickname, this.state = e.state, this.estimatedTimeToProvision = e.estimated_time_to_provision, this.app = {
      name: e.app_name,
      wordpressBased: e.app_is_wordpress_based
    }, this.environment = {
      access: {
        url: e.environment_access_url,
        username: e.environment_access_username
      }
    }, this.package = {
      isTShirt: !e.package_is_plan,
      label: e.package_label,
      name: e.package_name || e.package_identity
    }, this.plan = {
      id: e.plan_id,
      name: e.plan_nickname
    };
  }
}const getHud = new Definition({
  path: "/api/v1/client/hud",
  method: "GET",
  responseBody: e => e.data.map(e => HUD.getType(e) === HUD.SITE ? new HUDSite(e) : new HUDFraud(e))
});var hud=/*#__PURE__*/Object.freeze({__proto__:null,getHud:getHud});class Invoice {
  constructor(t = {}) {
    this.description = void 0;
    this.due = void 0;
    this.dueDate = void 0;
    this.formattedDueDate = void 0;
    this.formattedStatus = void 0;
    this.fullId = void 0;
    this.hasPayments = void 0;
    this.id = void 0;
    this.invoiceDate = void 0;
    this.isPayable = void 0;
    this.paidDate = void 0;
    this.status = void 0;
    this.tax = void 0;
    this.total = void 0;
    this.description = t.description || t.identity, this.due = t.due, this.dueDate = t.due_date, this.fullId = t.full_id, this.hasPayments = t.has_payments, this.id = t.id, this.invoiceDate = t.invoice_date, this.isPayable = t.is_payable, this.paidDate = t.paid_date, this.status = t.status, this.tax = t.tax, this.total = t.total, this.formattedDueDate = dateFormat(t.due_date), this.formattedPaidDate = dateFormat(t.paid_date), this.formattedStatus = `${t.status?.charAt(0)?.toUpperCase()}${t.status?.slice(1)}`;
  }
}const getInvoices$1 = new Definition({
  path: "/api/v1/invoice?sortBy=invoice_date&sortOrder=desc",
  method: "GET",
  responseBody: o => ({
    list: o.data.map(o => new Invoice(o)),
    pagination: new Pagination(o)
  }),
  transformParams: o => transformSortParamsToV1(o)
});var v1$8=/*#__PURE__*/Object.freeze({__proto__:null,getInvoices:getInvoices$1});class InvoiceLineItem {
  constructor(t = {}) {
    this.description = void 0;
    this.id = void 0;
    this.price = void 0;
    this.quantity = void 0;
    this.total = void 0;
    this.description = t.description, this.id = t.id, this.price = t.price, this.quantity = t.quantity, this.total = t.total;
  }
}const getInvoice$1 = new Definition({
  path: "/invoice/{id}",
  method: "GET",
  responseBody: i => new Invoice(i.data)
});
const getLineItems$1 = new Definition({
  path: "/invoice/{id}",
  method: "GET",
  responseBody: i => ({
    list: i.data.line_items.map(i => new InvoiceLineItem(i)),
    pagination: new Pagination(i)
  })
});var legacy$8=/*#__PURE__*/Object.freeze({__proto__:null,getInvoice:getInvoice$1,getLineItems:getLineItems$1});const {
  getInvoice: getInvoice,
  getLineItems: getLineItems
} = legacy$8;
const {
  getInvoices: getInvoices
} = v1$8;var invoices=/*#__PURE__*/Object.freeze({__proto__:null,getInvoice:getInvoice,getInvoices:getInvoices,getLineItems:getLineItems});class AddressTypes {
  constructor(s = {}) {
    this.types = void 0;
    this.types = s.meta.options.type;
  }
}const deleteAddress = new Definition("/address/{id}", "DELETE", e => e.data),
  getAddressTypes = new Definition({
    path: "/address/new",
    method: "GET",
    responseBody: e => new AddressTypes(e.data),
    headers: {
      "Accept-Format": "nocworx/json-bundle"
    }
  }),
  updateAddress = new Definition({
    path: "/address/{id}",
    method: "PATCH",
    responseBody: e => new Address(e.data),
    requestBody: e => {
      const s = {
        email: e.email,
        first_name: e.firstName,
        last_name: e.lastName,
        address1: e.address1,
        address2: e.address2,
        city: e.city,
        company: e.company,
        country: e.country,
        state: e.state,
        zip: e.zip
      };
      return e.phone && (s.phone = e.phone.replace(/[()-+]/g, "")), "default" !== e.type && (s.type = e.type), s;
    }
  });var legacyAddresses=/*#__PURE__*/Object.freeze({__proto__:null,deleteAddress:deleteAddress,getAddressTypes:getAddressTypes,updateAddress:updateAddress});const getAutoscaleMetrics$2 = new Definition("/cloud-account/{id}/get-autoscale-metrics", "GET", ({
  data: e
}) => Array.isArray(e) ? {
  enabled: !1
} : {
  enabled: !0,
  isScaled: !!e.autoscale_state,
  concurrentUsers: e.autoscale_concurrency,
  totalConcurrentUsers: e.autoscale_concurrency_base,
  totalConcurrentUsersScaled: e.autoscale_concurrency_scaled
});
const updateSiteAutoScale$2 = new Definition("/cloud-account/{id}", "POST", e => e.data, null, e => ({
  autoscale: e.enabled,
  _action: "set-autoscale"
}));var autoScale$1=/*#__PURE__*/Object.freeze({__proto__:null,getAutoscaleMetrics:getAutoscaleMetrics$2,updateSiteAutoScale:updateSiteAutoScale$2});class Backup {
  constructor(t = {}) {
    this.domainOptions = t.domain_options, this.downloadUrl = t.download_url, this.filedate = t.filedate, this.filename = t.filename, this.filepath = t.filepath, this.filesize = t.filesize, this.filesizeBytes = t.filesize_bytes, this.state = t.complete ? "stable" : "creating", this.isStable = "stable" === this.state;
  }
}const createSiteBackup$2 = new Definition("/cloud-account/{siteId}/backup", "POST", e => new Backup(e.data));
const deleteSiteBackup$2 = new Definition("/cloud-account/{siteId}/backup/{filename}", "DELETE", e => e.data);
const restoreSiteBackup$2 = new Definition("/cloud-account/{siteId}/backup/{filename}", "POST", e => new Backup(e.data), null, () => ({
  _action: "restore"
}));
const getSiteBackupRestoreStatus$2 = new Definition("/cloud-account/{siteId}/backup", "POST", e => e.data.restoring, null, () => ({
  _action: "restore-in-progress"
}));var backups$1=/*#__PURE__*/Object.freeze({__proto__:null,createSiteBackup:createSiteBackup$2,deleteSiteBackup:deleteSiteBackup$2,getSiteBackupRestoreStatus:getSiteBackupRestoreStatus$2,restoreSiteBackup:restoreSiteBackup$2});class ContainerGroups {
  constructor(s = {}) {
    this.id = void 0;
    this.name = void 0;
    this.type = void 0;
    this.version = void 0;
    this.displayVersion = void 0;
    this.id = s.id, this.name = s.name, this.type = s.service, this.version = s.version, this.displayVersion = s.version, "7.16-latest" === s.version && (this.displayVersion = "7.16-latest / Opensearch 1.2");
  }
}class ContainerPassword extends Password {
  constructor(s = {}) {
    (super(s), this.containerId = void 0, this.username = void 0), this.containerId = s.owner_id || this.ownerId, this.username = s.link_to;
  }
}const addSiteContainer$2 = new Definition("/cloud-account/{id}", "POST", n => n.data, null, n => ({
  addon_id: n.addonId,
  type: n.type,
  version: n.version,
  _action: "add-container-group"
}));
const getSiteContainerGroups$2 = new Definition("/virt-guest-containergroup-type", "GET", n => n.data.map(n => new ContainerGroups(n)).sort((n, o) => n.version > o.version ? -1 : 1));
const resizeSiteContainer$1 = new Definition("/cloud-account/{id}", "POST", n => n.data, null, n => ({
  addon_id: n.addonId,
  group_id: n.groupId,
  _action: "resize-container-group"
}));
const removeSiteContainer$2 = new Definition("/cloud-account/{id}", "POST", n => n.data, null, n => ({
  group_id: n.groupId,
  _action: "remove-container-group"
}));
const getContainerPassword$1 = new Definition("/datashare?owner=virt-guest-containergroup&owner_id={containerId}", "GET", n => n.data.length ? new ContainerPassword(n.data[0]) : null);var container$1=/*#__PURE__*/Object.freeze({__proto__:null,addSiteContainer:addSiteContainer$2,getContainerPassword:getContainerPassword$1,getSiteContainerGroups:getSiteContainerGroups$2,removeSiteContainer:removeSiteContainer$2,resizeSiteContainer:resizeSiteContainer$1});class Cron {
  constructor(t = {}) {
    this.day = void 0;
    this.dayOfWeek = void 0;
    this.enabled = void 0;
    this.hour = void 0;
    this.id = void 0;
    this.minute = void 0;
    this.month = void 0;
    this.script = void 0;
    this.day = t.day, this.dayOfWeek = t.dayofweek, this.enabled = 1 === t.enabled, this.hour = t.hour, this.id = t.job, this.minute = t.minute, this.month = t.month, this.script = t.script;
  }
}class CronOptions {
  constructor(t = {}) {
    this.mailTo = void 0;
    this.path = void 0;
    this.site = void 0;
    this.mailTo = t.mailto, this.path = t.path, this.site = t.site;
  }
}const addSiteCron$3 = new Definition("/cloud-account/{id}/cron", "POST", n => n.data, null, n => ({
  command: n.script,
  frequency: n.frequency
}));
const deleteSiteCron$2 = new Definition("/cloud-account/{siteId}/cron/{cronId}", "DELETE", n => n.data);
const getSiteCronOptions$2 = new Definition("/cloud-account/{id}/cron/get-options", "GET", n => {
  const o = Number(n.config.url.match(/\/cloud-account\/(.*)\/cron\/get-options/)[1]);
  return new CronOptions({
    ...n.data,
    site: {
      id: o
    }
  });
});
const getSiteCronPresets$1 = new Definition("/cloud-account/{id}/cron/get-presets", "GET", n => {
  const o = Number(n.config.url.match(/\/cloud-account\/(.*)\/cron\/get-presets/)[1]);
  return {
    list: Object.entries(n.data).map(n => {
      const [o, t] = n;
      return {
        value: o,
        display: t
      };
    }),
    site: {
      id: o
    }
  };
});
const getSiteCronTasks$2 = new Definition("/cloud-account/{id}/cron", "GET", n => n.data.map(n => new Cron(n)));
const updateSiteCron$2 = new Definition("/cloud-account/{siteId}/cron/{cronId}", "POST", n => n.data, null, n => ({
  _action: n.enable ? "enable" : "disable"
}));
const updateSiteCronOptions$3 = new Definition("/cloud-account/{id}/cron", "POST", n => n.data, null, n => ({
  mailto: n.mailTo,
  path: n.path,
  shell: "/bin/bash",
  _action: "set-options"
}));var cron=/*#__PURE__*/Object.freeze({__proto__:null,addSiteCron:addSiteCron$3,deleteSiteCron:deleteSiteCron$2,getSiteCronOptions:getSiteCronOptions$2,getSiteCronPresets:getSiteCronPresets$1,getSiteCronTasks:getSiteCronTasks$2,updateSiteCron:updateSiteCron$2,updateSiteCronOptions:updateSiteCronOptions$3});class DNS {
  constructor(i = {}) {
    this.isLive = void 0;
    this.isLive = i.is_live;
  }
}const getSiteDns$2 = new Definition("/cloud-account/{id}/domain-dns-info", "GET", n => ({
  dns: new DNS(n.data),
  siteId: Number(n.config.url.match(/\/cloud-account\/(.*)\/domain-dns-info/)[1])
}));var dns=/*#__PURE__*/Object.freeze({__proto__:null,getSiteDns:getSiteDns$2});const updateSiteDomain$3 = new Definition("/cloud-account/{id}", "POST", i => i.data, null, i => ({
  domain: i.domain,
  _action: "rename"
}));
const validateDomain$1 = new Definition("/cloud-account", "POST", i => i.data, null, i => ({
  domain: i.domain,
  app_id: i.appId,
  package_id: i.packageId,
  cloud_id: i.locationId,
  _validate: !0,
  _validate_skip_creditcard: !0
}));var domain$1=/*#__PURE__*/Object.freeze({__proto__:null,updateSiteDomain:updateSiteDomain$3,validateDomain:validateDomain$1});class EmailAlias {
  constructor(e = {}) {
    this.email = void 0;
    this.username = void 0;
    this.members = void 0;
    this.email = e.email, this.username = e.username, this.members = e.list;
  }
}class EmailPassword extends Password {
  constructor(s = {}) {
    (super(s), this.siteId = void 0), this.siteId = s.owner_id || this.ownerId;
  }
}class EmailBox {
  constructor(s = {}) {
    this.email = void 0;
    this.username = void 0;
    this.usedBytes = void 0;
    this.usedMegabytes = void 0;
    this.totalBytes = void 0;
    this.totalMegabytes = void 0;
    this.password = void 0;
    this.email = s.email, this.username = s.username, this.usedBytes = s.quota_bytes * s.box_pct / 100, this.totalBytes = s.quota_bytes, s.quota_bytes && (this.usedMegabytes = (this.usedBytes / 1024 / 1024).toFixed(2), this.totalMegabytes = s.quota_bytes / 1024 / 1024), this.password = null, s.datashare && (this.password = new EmailPassword(s.datashare));
  }
}const createSiteEmailAlias$2 = new Definition("/cloud-account/{siteId}/email/alias", "POST", e => e.data);
const createSiteEmailBox$4 = new Definition("/cloud-account/{siteId}/email/box", "POST", e => e.data, null, e => ({
  username: e.username
}));
const deleteSiteEmailAlias$2 = new Definition("/cloud-account/{siteId}/email/alias", "POST", e => e.data, null, e => ({
  _action: "remove-email-alias",
  username: e.username
}));
const deleteSiteEmailBox$2 = new Definition("/cloud-account/{siteId}/email/box", "POST", e => e.data, null, e => ({
  _action: "remove-email-box",
  username: e.username
}));
const getSiteEmailAliases$2 = new Definition("/cloud-account/{siteId}/email/alias", "GET", e => ({
  list: e.data.map(e => new EmailAlias(e)),
  pagination: new Pagination(e)
}));
const getSiteEmailBoxes$2 = new Definition("/cloud-account/{siteId}/email/box", "GET", e => ({
  list: e.data.map(e => new EmailBox(e)),
  pagination: new Pagination(e)
}));
const getWebmailUrl$2 = new Definition("/cloud-account/{siteId}", "POST", e => e.data.webmail_url, null, () => ({
  _action: "webmail-url"
}));
const regenPasswordSiteEmailBox$2 = new Definition("/cloud-account/{siteId}/email/box", "POST", e => e.data, null, e => ({
  _action: "regenerate-password",
  username: e.username
}));
const updateSiteEmailAlias$2 = new Definition("/cloud-account/{siteId}/email/alias", "POST", e => e.data, null, e => ({
  username: e.username,
  members: e.members,
  _action: "update-alias"
}));var email$2=/*#__PURE__*/Object.freeze({__proto__:null,createSiteEmailAlias:createSiteEmailAlias$2,createSiteEmailBox:createSiteEmailBox$4,deleteSiteEmailAlias:deleteSiteEmailAlias$2,deleteSiteEmailBox:deleteSiteEmailBox$2,getSiteEmailAliases:getSiteEmailAliases$2,getSiteEmailBoxes:getSiteEmailBoxes$2,getWebmailUrl:getWebmailUrl$2,regenPasswordSiteEmailBox:regenPasswordSiteEmailBox$2,updateSiteEmailAlias:updateSiteEmailAlias$2});const defaultRequestBody = e => e;
class GroupDefinition {
  constructor(e, i = null) {
    this.definitions = void 0;
    this.responseBody = void 0;
    "object" != typeof e || Array.isArray(e) ? Array.isArray(e) && (this.definitions = e, this.responseBody = i) : (this.definitions = e.definitions, this.responseBody = e.responseBody || defaultRequestBody);
  }
}var groupDefinition=/*#__PURE__*/Object.freeze({__proto__:null,default:GroupDefinition});const createSiteFtpUser$2 = new Definition("/cloud-account/{id}/ftp", "POST", e => e.data, null, e => ({
  homedir: e.homeDir,
  password: e.password,
  username: e.username,
  _action: "add"
}));
const getSiteFtpHomeDirOptions$2 = new Definition("/cloud-account/{id}/ftp", "POST", e => {
  const t = Number(e.config.url.match(/\/cloud-account\/(.*)\/ftp/)[1]);
  return {
    options: e.data,
    siteId: t
  };
}, null, () => ({
  _action: "get-homedir-options"
}));
const removeSiteFtpUser$2 = new Definition("/cloud-account/{id}/ftp/{username}", "DELETE", e => e.data);
const updateSiteFtpUserPassword$2 = new Definition("/cloud-account/{id}/ftp", "POST", e => e.data, null, e => ({
  password: e.password,
  username: e.username,
  _action: "reset-password"
}));
const updateSiteFtpUserHomeDir$2 = new Definition("/cloud-account/{id}/ftp", "POST", e => e.data, null, e => ({
  homedir: e.homeDir,
  username: e.username,
  _action: "set-homedir"
}));
const updateSiteFtpUser$2 = new GroupDefinition([updateSiteFtpUserPassword$2, updateSiteFtpUserHomeDir$2], () => null);var ftp$1=/*#__PURE__*/Object.freeze({__proto__:null,createSiteFtpUser:createSiteFtpUser$2,getSiteFtpHomeDirOptions:getSiteFtpHomeDirOptions$2,removeSiteFtpUser:removeSiteFtpUser$2,updateSiteFtpUser:updateSiteFtpUser$2,updateSiteFtpUserHomeDir:updateSiteFtpUserHomeDir$2,updateSiteFtpUserPassword:updateSiteFtpUserPassword$2});class SitePassword extends Password {
  constructor(s = {}) {
    (super(s), this.siteId = void 0), this.siteId = this.ownerId;
  }
  static formatLegacy(s) {
    return new SitePassword({
      ...s,
      owner: {
        id: s.owner_id
      }
    });
  }
}const getSiteHttpPasswordInfo$2 = new Definition("/datashare?owner=virt-guest-cloudaccount&owner_id={id}&uuid={uuid}", "GET", t => {
  const o = t.config.url.split("/datashare?owner=virt-guest-cloudaccount&owner_id=")[1].split("&uuid=")[1],
    i = t.data.find(t => t.uuid === o);
  return SitePassword.formatLegacy(i);
});
const resetSiteHttpPassword$2 = new Definition("/cloud-account/{id}/update-http-user", "GET", () => null);var httpPassword=/*#__PURE__*/Object.freeze({__proto__:null,getSiteHttpPasswordInfo:getSiteHttpPasswordInfo$2,resetSiteHttpPassword:resetSiteHttpPassword$2});const updateSiteNginx$2 = new Definition("/cloud-account/{id}", "POST", e => e.data, null, e => ({
  enabled: e.enabled,
  _action: "set-acceleration"
}));var nginx=/*#__PURE__*/Object.freeze({__proto__:null,updateSiteNginx:updateSiteNginx$2});const getSitePhpVersions$2 = new Definition("/cloud-account/{id}/get-php-versions", "GET", i => {
  const t = Number(i.config.url.match(/\/cloud-account\/(.*)\/get-php-versions/)[1]);
  return {
    list: i.data,
    siteId: t
  };
});var php$1=/*#__PURE__*/Object.freeze({__proto__:null,getSitePhpVersions:getSitePhpVersions$2});const createSitePointerDomain$2 = new Definition("/cloud-account/{siteId}", "POST", i => i.data, null, i => ({
  domain: i.domain,
  type: i.type,
  _action: "add-pointer-domain"
}));
const deleteSitePointerDomain$2 = new Definition("/cloud-account/{siteId}", "POST", i => i.data, null, i => ({
  domain: i.domain,
  _action: "remove-pointer-domain"
}));var pointerDomain$1=/*#__PURE__*/Object.freeze({__proto__:null,createSitePointerDomain:createSitePointerDomain$2,deleteSitePointerDomain:deleteSitePointerDomain$2});class RemoteUser {
  constructor(s = {}) {
    this.password = void 0;
    this.siteId = void 0;
    this.username = void 0;
    this.password = s.password_share ? new SitePassword(s.password_share) : void 0, this.siteId = s.siteId, this.username = s.username;
  }
}const getSiteRemoteUserInfo$2 = new Definition("/cloud-account/{id}/get-remote-username", "GET", e => {
  const t = Number(e.config.url.match(/\/cloud-account\/(.*)\/get-remote-username/)[1]);
  return new RemoteUser({
    ...e.data,
    siteId: t
  });
});
const updateSiteRemotePassword$2 = new Definition("/cloud-account/{id}", "POST", e => e.data, null, () => ({
  _action: "set-remote-password"
}));var remoteUser=/*#__PURE__*/Object.freeze({__proto__:null,getSiteRemoteUserInfo:getSiteRemoteUserInfo$2,updateSiteRemotePassword:updateSiteRemotePassword$2});const createSecondarySite$2 = new Definition("/cloud-account/{id}", "POST", i => i.data, null, i => ({
  app_id: i.appId,
  install_app: i.installApp,
  nickname: i.name,
  _action: "add-child-account"
}));var secondarySite=/*#__PURE__*/Object.freeze({__proto__:null,createSecondarySite:createSecondarySite$2});class SiteEnvironmentAccess {
  constructor(e) {
    this.url = void 0;
    this.username = void 0;
    this.url = e?.url, this.username = e?.username;
  }
}class SiteEnvironmentOptions {
  constructor(n) {
    this.autoScaleEnabled = void 0;
    this.nginxEnabled = void 0;
    this.autoScaleEnabled = n?.autoscale_enabled, this.nginxEnabled = !n?.nxcache_nocache;
  }
}class SiteEnvironmentSoftware {
  constructor(e) {
    this.php = void 0;
    this.php = {
      version: e?.php?.version,
      cli: e?.php?.cli
    }, this.redis = {
      version: e?.redis?.version,
      socket: e?.redis?.socket,
      ip: e?.redis?.host,
      port: e?.redis?.port
    };
  }
}class SiteEnvironment {
  constructor(t = {}) {
    this.access = void 0;
    this.options = void 0;
    this.software = void 0;
    this.access = new SiteEnvironmentAccess(t.access), this.options = new SiteEnvironmentOptions(t.options), this.software = new SiteEnvironmentSoftware(t.software);
  }
}class SiteBundleOptions {
  constructor(a = {}) {
    this.autoscaleEnabled = void 0;
    this.complimentary_staging = void 0;
    this.stencilsEnabled = void 0;
    this.objectCachePro = void 0;
    this.support = void 0;
    this.complimentaryPerformanceShield = void 0;
    this.backup = void 0;
    this.visualCompare = void 0;
    this.autoscaleEnabled = a.autoscale_enabled, this.complimentaryStaging = a.complimentary_staging, this.stencilsEnabled = a.stencils_enabled, this.objectCachePro = a.object_cache_pro, this.support = {
      appSupportEnabled: a.support?.app_support_enabled,
      migrationSupportEnabled: a.support?.migration_support_enabled
    }, this.complimentaryPerformanceShield = a.complimentary_performance_shield, this.backup = {
      daysToDisplay: a.backup?.days_to_display
    }, this.visualCompare = {
      disabled: a.visual_compare?.disabled
    };
  }
}class Site {
  constructor(e = {}) {
    this.app = void 0;
    this.appAccessUrl = void 0;
    this.canChangeDomain = void 0;
    this.cloudHostDomain = void 0;
    this.devEnvironmentCount = void 0;
    this.created = void 0;
    this.domain = void 0;
    this.environment = void 0;
    this.environmentType = void 0;
    this.hasCloudflare = void 0;
    this.id = void 0;
    this.isDomainAgnostic = void 0;
    this.isStable = void 0;
    this.ip = void 0;
    this.name = void 0;
    this.originalDomain = void 0;
    this.package = void 0;
    this.parentAccount = void 0;
    this.plan = void 0;
    this.planId = void 0;
    this.tempDomain = void 0;
    this.referenceAccount = void 0;
    this.screenshotUrl = void 0;
    this.state = void 0;
    this.stagingEnvironmentCount = void 0;
    this.usesVanityDomain = void 0;
    this.vanityTempDomain = void 0;
    this.vanityDomain = void 0;
    if (this.app = new App(e.app), this.appAccessUrl = e?.environment?.access?.url, this.canChangeDomain = !!e.can_modify_domain, this.cloudHostDomain = e.cloudhost_hostname, e.cloudhost) {
      const [, n] = e.cloudhost.identity.split(" - ");
      this.cloudHostDomain = n;
    }
    this.created = e.deploy_date, this.devEnvironmentCount = e.dev_account_count, this.domain = e.client_domain || e.domain, this.name = e.nickname, this.originalDomain = e.is_domain_agnostic ? e.domain : e.temp_domain, this.environment = new SiteEnvironment(e.environment), this.environmentType = "production", e.is_staging_account ? this.environmentType = "staging" : e.is_dev_account && (this.environmentType = "development"), this.id = e.id, this.isDomainAgnostic = !!e.is_domain_agnostic, this.isStable = "stable" === e.state, this.ip = e.ip, this.package = new Package(e.package), e.parent_account && (this.parentAccount = new Site(e.parent_account)), this.planId = e.service?.id, this.planName = e.service?.identity, e.service && (this.plan = {
      id: e.service?.id,
      nickname: e.service?.identity,
      state: e.service?.state
    }), this.tempDomain = e.temp_domain, e.reference_account ? this.referenceAccount = new Site(e.reference_account) : e.reference_account_id && (this.referenceAccount = {
      id: e.reference_account_id
    }), this.screenshotUrl = e.screenshot_url, this.stagingEnvironmentCount = e.staging_account_count, this.state = e.state, this.unixUsername = e.unix_username, this.usesVanityDomain = e.uses_vanity, this.vanityTempDomain = e.vanity_temp_domain, this.vanityDomain = e.vanity_domain, this.hasCloudflare = e.has_cloudflare, this.addons = e.addons, this.bundleOptions = new SiteBundleOptions(e.bundle_options);
  }
  static formatLegacy(e) {
    return new Site({
      app: e.app,
      client_domain: e.client_domain,
      domain: e.domain,
      environment: e.environment,
      id: e.id,
      package: {
        child_accounts: e.service?.package?.child_accounts,
        id: e.service?.package?.id,
        name: e.service?.package?.identity,
        primary_accounts: e.service?.package?.primary_accounts,
        type: e.service?.package?.type
      },
      service: e.service,
      temp_domain: e.temp_domain,
      cloudhost_hostname: e.cloudhost_hostname,
      unix_username: e.unix_username,
      is_dev_account: e.is_dev_account,
      is_staging_account: e.is_staging_account,
      reference_account: e.reference_account,
      reference_account_id: e.reference_account_id
    });
  }
}const createSite$2 = new Definition("/cloud-account", "POST", e => e.data, null, e => ({
  install_app: e.installApp,
  service_id: e.planId,
  nickname: e.name
}));
const createSiteFromStencil$2 = new Definition("/cloud-account", "POST", e => e.data, null, e => ({
  stencil_id: e.stencilId,
  service_id: e.planId,
  nickname: e.name
}));
const deleteSite$2 = new Definition("/cloud-account/{id}", "DELETE", e => e.data);
const getSite$4 = new Definition("/cloud-account/{id}", "GET", e => new Site(e.data));
const getSiteSystemTime$2 = new Definition("/cloud-account/{id}/get-system-time", "GET", e => {
  const t = Number(e.config.url.match(/\/cloud-account\/(.*)\/get-system-time/)[1]);
  return {
    ...e.data,
    site: {
      id: t
    }
  };
});
const createDevSite$2 = new Definition("/cloud-account", "POST", e => new Site(e.data), null, e => {
  const t = {
    install_app: e.installApp,
    copy_account: e.copyData,
    package_id: e.packageId,
    ref_cloud_account_id: e.siteId,
    ref_service_id: e.planId,
    ref_type: e.environmentType,
    cloud_id: e.locationId,
    addon_ids: e.addonIds
  };
  return e.copyData && !e.copyUserData && (t.scrub_users = !0, t.scrub_account = !0), t;
});
const deleteDevSite$2 = new Definition("/service/{planId}", "DELETE", e => e.data);var site$1=/*#__PURE__*/Object.freeze({__proto__:null,createDevSite:createDevSite$2,createSite:createSite$2,createSiteFromStencil:createSiteFromStencil$2,deleteDevSite:deleteDevSite$2,deleteSite:deleteSite$2,getSite:getSite$4,getSiteSystemTime:getSiteSystemTime$2});class CertInfo {
  constructor(t) {
    this.altNames = void 0;
    this.chain = void 0;
    this.commonName = void 0;
    this.expired = void 0;
    this.installed = void 0;
    this.keySize = void 0;
    this.raw = void 0;
    this.validFrom = void 0;
    this.validTo = void 0;
    this.status = void 0;
    this.altNames = t.certificate?.alt_names, this.chain = t.chain, this.commonName = t.certificate?.distinguished_name?.commonName, this.expired = t.expired, this.installed = t.installed, this.keySize = t.key_size, this.raw = t.certificate?.raw, this.validFrom = t.certificate?.valid_from, this.validTo = t.certificate?.valid_to, this.status = CertInfo.getStatus(t);
  }
  static getStatus(t) {
    return t.expired ? "EXPIRED" : t.installed ? "INSTALLED" : "NOT_INSTALLED";
  }
}const installSiteSSLCert$1 = new Definition("/cloud-account/{siteId}", "POST", t => t.data, null, t => ({
  cert_id: t.certificateId,
  _action: "install-ssl"
}));
const uploadSiteSSLCert$1 = new Definition("/cloud-account/{siteId}", "POST", t => t.data, null, t => ({
  chain_crts: t.chain ? t.chain.trim() : null,
  crt: t.certificate.trim(),
  key: t.key.trim(),
  _action: "install-ssl"
}));
const getSiteSSLInfo$2 = new Definition("/cloud-account/{siteId}/domain-ssl-info", "GET", t => new CertInfo(t.data));var ssl$1=/*#__PURE__*/Object.freeze({__proto__:null,getSiteSSLInfo:getSiteSSLInfo$2,installSiteSSLCert:installSiteSSLCert$1,uploadSiteSSLCert:uploadSiteSSLCert$1});const getUsageMetrics$2 = new Definition("/cloud-account/{id}/get-usage-metrics", "GET", ({
  data: t
}) => ({
  storageTotalGb: t.storage_gb,
  storageUsedGb: t.storage_used_gb,
  bandwidthTotalGb: t.bandwidth_gb,
  bandwidthUsedGb: t.bandwidth_used_gb
}));var usage=/*#__PURE__*/Object.freeze({__proto__:null,getUsageMetrics:getUsageMetrics$2});const {
  getAutoscaleMetrics: getAutoscaleMetrics$1,
  updateSiteAutoScale: updateSiteAutoScale$1
} = autoScale$1;
const {
  addSiteCron: addSiteCron$2,
  deleteSiteCron: deleteSiteCron$1,
  getSiteCronOptions: getSiteCronOptions$1,
  getSiteCronPresets: getSiteCronPresets,
  getSiteCronTasks: getSiteCronTasks$1,
  updateSiteCron: updateSiteCron$1,
  updateSiteCronOptions: updateSiteCronOptions$2
} = cron;
const {
  addSiteContainer: addSiteContainer$1,
  removeSiteContainer: removeSiteContainer$1,
  resizeSiteContainer: resizeSiteContainer,
  getSiteContainerGroups: getSiteContainerGroups$1,
  getContainerPassword: getContainerPassword
} = container$1;
const {
  getSiteDns: getSiteDns$1
} = dns;
const {
  updateSiteDomain: updateSiteDomain$2,
  validateDomain: validateDomain
} = domain$1;
const {
  createSiteEmailAlias: createSiteEmailAlias$1,
  createSiteEmailBox: createSiteEmailBox$3,
  deleteSiteEmailAlias: deleteSiteEmailAlias$1,
  deleteSiteEmailBox: deleteSiteEmailBox$1,
  getSiteEmailAliases: getSiteEmailAliases$1,
  getSiteEmailBoxes: getSiteEmailBoxes$1,
  getWebmailUrl: getWebmailUrl$1,
  regenPasswordSiteEmailBox: regenPasswordSiteEmailBox$1,
  updateSiteEmailAlias: updateSiteEmailAlias$1
} = email$2;
const {
  createSiteFtpUser: createSiteFtpUser$1,
  getSiteFtpHomeDirOptions: getSiteFtpHomeDirOptions$1,
  removeSiteFtpUser: removeSiteFtpUser$1,
  updateSiteFtpUser: updateSiteFtpUser$1,
  updateSiteFtpUserHomeDir: updateSiteFtpUserHomeDir$1,
  updateSiteFtpUserPassword: updateSiteFtpUserPassword$1
} = ftp$1;
const {
  getSiteHttpPasswordInfo: getSiteHttpPasswordInfo$1,
  resetSiteHttpPassword: resetSiteHttpPassword$1
} = httpPassword;
const {
  updateSiteNginx: updateSiteNginx$1
} = nginx;
const {
  getSitePhpVersions: getSitePhpVersions$1
} = php$1;
const {
  createSitePointerDomain: createSitePointerDomain$1,
  deleteSitePointerDomain: deleteSitePointerDomain$1
} = pointerDomain$1;
const {
  getSiteRemoteUserInfo: getSiteRemoteUserInfo$1,
  updateSiteRemotePassword: updateSiteRemotePassword$1
} = remoteUser;
const {
  createSecondarySite: createSecondarySite$1
} = secondarySite;
const {
  createSite: createSite$1,
  createDevSite: createDevSite$1,
  createSiteFromStencil: createSiteFromStencil$1,
  deleteSite: deleteSite$1,
  deleteDevSite: deleteDevSite$1,
  getSite: getSite$3,
  getSiteSystemTime: getSiteSystemTime$1
} = site$1;
const {
  installSiteSSLCert: installSiteSSLCert,
  uploadSiteSSLCert: uploadSiteSSLCert,
  getSiteSSLInfo: getSiteSSLInfo$1
} = ssl$1;
const {
  getUsageMetrics: getUsageMetrics$1
} = usage;
const {
  getSiteBackups: getSiteBackups$3,
  createSiteBackup: createSiteBackup$1,
  deleteSiteBackup: deleteSiteBackup$1,
  restoreSiteBackup: restoreSiteBackup$1,
  getSiteBackupRestoreStatus: getSiteBackupRestoreStatus$1
} = backups$1;var legacySites=/*#__PURE__*/Object.freeze({__proto__:null,addSiteContainer:addSiteContainer$1,addSiteCron:addSiteCron$2,createDevSite:createDevSite$1,createSecondarySite:createSecondarySite$1,createSite:createSite$1,createSiteBackup:createSiteBackup$1,createSiteEmailAlias:createSiteEmailAlias$1,createSiteEmailBox:createSiteEmailBox$3,createSiteFromStencil:createSiteFromStencil$1,createSiteFtpUser:createSiteFtpUser$1,createSitePointerDomain:createSitePointerDomain$1,deleteDevSite:deleteDevSite$1,deleteSite:deleteSite$1,deleteSiteBackup:deleteSiteBackup$1,deleteSiteCron:deleteSiteCron$1,deleteSiteEmailAlias:deleteSiteEmailAlias$1,deleteSiteEmailBox:deleteSiteEmailBox$1,deleteSitePointerDomain:deleteSitePointerDomain$1,getAutoscaleMetrics:getAutoscaleMetrics$1,getContainerPassword:getContainerPassword,getSite:getSite$3,getSiteBackupRestoreStatus:getSiteBackupRestoreStatus$1,getSiteBackups:getSiteBackups$3,getSiteContainerGroups:getSiteContainerGroups$1,getSiteCronOptions:getSiteCronOptions$1,getSiteCronPresets:getSiteCronPresets,getSiteCronTasks:getSiteCronTasks$1,getSiteDns:getSiteDns$1,getSiteEmailAliases:getSiteEmailAliases$1,getSiteEmailBoxes:getSiteEmailBoxes$1,getSiteFtpHomeDirOptions:getSiteFtpHomeDirOptions$1,getSiteHttpPasswordInfo:getSiteHttpPasswordInfo$1,getSitePhpVersions:getSitePhpVersions$1,getSiteRemoteUserInfo:getSiteRemoteUserInfo$1,getSiteSSLInfo:getSiteSSLInfo$1,getSiteSystemTime:getSiteSystemTime$1,getUsageMetrics:getUsageMetrics$1,getWebmailUrl:getWebmailUrl$1,installSiteSSLCert:installSiteSSLCert,regenPasswordSiteEmailBox:regenPasswordSiteEmailBox$1,removeSiteContainer:removeSiteContainer$1,removeSiteFtpUser:removeSiteFtpUser$1,resetSiteHttpPassword:resetSiteHttpPassword$1,resizeSiteContainer:resizeSiteContainer,restoreSiteBackup:restoreSiteBackup$1,updateSiteAutoScale:updateSiteAutoScale$1,updateSiteCron:updateSiteCron$1,updateSiteCronOptions:updateSiteCronOptions$2,updateSiteDomain:updateSiteDomain$2,updateSiteEmailAlias:updateSiteEmailAlias$1,updateSiteFtpUser:updateSiteFtpUser$1,updateSiteFtpUserHomeDir:updateSiteFtpUserHomeDir$1,updateSiteFtpUserPassword:updateSiteFtpUserPassword$1,updateSiteNginx:updateSiteNginx$1,updateSiteRemotePassword:updateSiteRemotePassword$1,uploadSiteSSLCert:uploadSiteSSLCert,validateDomain:validateDomain});const validateCoupon$1 = new Definition({
  path: "/order/check-discount",
  method: "POST",
  responseBody: o => o.data,
  requestBody: o => ({
    discount_code: o.couponCode,
    term: o.term,
    package_id: o.packageId,
    amount: o.amount
  })
});var legacy$7=/*#__PURE__*/Object.freeze({__proto__:null,validateCoupon:validateCoupon$1});class Order {
  constructor(t = {}) {
    this.id = void 0;
    this.invoice = void 0;
    this.orderDate = void 0;
    this.status = void 0;
    this.total = void 0;
    this.type = void 0;
    this.identity = void 0;
    this.formattedDate = void 0;
    this.formattedStatus = void 0;
    this.service = void 0;
    this.package = void 0;
    this.package_label = void 0;
    this.id = t.id, this.orderDate = t.order_date, this.formattedDate = dateFormat(t.order_date), this.status = t.status, this.formattedStatus = `${t.status?.charAt(0)?.toUpperCase()}${t.status?.slice(1)}`, this.total = t.total, this.type = t.type, this.identity = t.identity, this.serviceId = t.service_id, this.service_host = t.service_host, this.invoice = t.invoice, this.service = t.service, this.package = t.package, this.package_label = t.package_label;
  }
}const getOrder$1 = new Definition({
    path: "/api/v1/order/{id}",
    method: "GET",
    responseBody: e => new Order(e.data)
  }),
  getOrders$1 = new Definition({
    path: "/api/v1/order",
    method: "GET",
    responseBody: e => ({
      list: e.data.map(e => new Order(e)),
      pagination: new Pagination(e)
    }),
    transformParams: e => transformSortParamsToV1(e)
  }),
  estimateOrder$1 = new Definition({
    path: "/api/v1/order/estimate",
    method: "POST",
    responseBody: e => e.data,
    requestBody: e => {
      const o = [];
      return e.items.sort((e, o) => "virt-guest-cloud" === e.orderType && "virt-guest-cloud" !== o.orderType ? -1 : 0).forEach(e => {
        const r = {
          order_type: e.orderType,
          term: e.term
        };
        e.addons && e.addons.length && (r.addons = e.addons), e.packageId && (r.package_id = e.packageId), e.packageBundle && (r.package_bundle = e.packageBundle), e.locationId && (r.cloud_id = e.locationId), e.appId && (r.app_id = e.appId), e.domainName && (r.domain_name = e.domainName), e.tld && (r.tld_id = e.tld.id), o.push(r);
      }), {
        discounts: e.discounts.length ? e.discounts : null,
        items: o
      };
    }
  });var v1$7=/*#__PURE__*/Object.freeze({__proto__:null,estimateOrder:estimateOrder$1,getOrder:getOrder$1,getOrders:getOrders$1});const {
  getOrder: getOrder,
  getOrders: getOrders,
  estimateOrder: estimateOrder
} = v1$7;
const {
  validateCoupon: validateCoupon
} = legacy$7;var orders=/*#__PURE__*/Object.freeze({__proto__:null,estimateOrder:estimateOrder,getOrder:getOrder,getOrders:getOrders,validateCoupon:validateCoupon});class OS {
  constructor(i = {}) {
    this.id = void 0;
    this.distribution = void 0;
    this.version = void 0;
    this.architecture = void 0;
    this.family = void 0;
    this.default = void 0;
    this.id = i.id, this.distribution = i.distribution, this.version = i.version, this.architecture = i.arch, this.family = i.family, this.default = i.default;
  }
}class OSTemplate {
  constructor(s = {}) {
    this.id = void 0;
    this.status = void 0;
    this.os = void 0;
    this.id = s.id, this.status = s.status, this.os = new OS(s.os);
  }
}const getOses = new Definition("/os-install-template", "GET", e => e.data.map(e => new OSTemplate(e)));var os=/*#__PURE__*/Object.freeze({__proto__:null,getOses:getOses});class Other extends Service {
  constructor(e = {}) {
    (super(e), this.addons = void 0, this.edgecast = void 0, this.isCancellable = void 0), this.addons = e.addons?.map(({
      identity: e,
      qty: t,
      term_price_total: c
    }) => ({
      name: e,
      quantity: t,
      price: c
    })), e.edgecast && (this.edgecast = new EdgecastAccount(e.edgecast)), this.isCancellable = this.isCancellable || e.is_cancellable;
  }
}const enableOtherApacCdn = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "enable-apac"
}));
const enableOtherSharedSsl = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "enable-shared-ssl"
}));
const disableOtherApacCdn = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "disable-apac"
}));
const disableOtherSharedSsl = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "disable-shared-ssl"
}));
const getOther = new Definition("/service/{id}", "GET", e => new Other(e.data));
const getOtherCdnControlPanelUrl = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "cdn-account"
}));
const getOthers = new Definition("/service?type=generic", "GET", e => ({
  list: e.data.map(e => new Other(e)),
  pagination: new Pagination(e)
}));
const purgeOtherCache = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "purge-cache"
}));var others=/*#__PURE__*/Object.freeze({__proto__:null,disableOtherApacCdn:disableOtherApacCdn,disableOtherSharedSsl:disableOtherSharedSsl,enableOtherApacCdn:enableOtherApacCdn,enableOtherSharedSsl:enableOtherSharedSsl,getOther:getOther,getOtherCdnControlPanelUrl:getOtherCdnControlPanelUrl,getOthers:getOthers,purgeOtherCache:purgeOtherCache});const getCloudServerPackages$2 = new Definition("/package?type=virt-guest", "GET", e => e.data);const getDevSitePackages$2 = new Definition("/package?type=virt-guest-cloud&pageSize=250&environment_type=development", "GET", e => e.data);class UpgradePackage extends Package {
  constructor(e, a) {
    (super(e, a), this.id = void 0, this.label = void 0, this.upgradeFee = void 0), this.id = a.id, this.label = a.label, this.upgradeFee = a.resize_amount;
  }
}const getSiteUpgradePrices$1 = new Definition("/package?type=virt-guest-cloud&environment_type=production&resize_pricing=true&service_id={planId}&app_id={appId}&plan_type={notTShirt}&pageSize=30", "GET", e => {
  const t = new URLSearchParams(e.config.url.split("?")[1]),
    i = Number(t.get("app_id")),
    r = "true" !== t.get("plan_type"),
    a = e.data.filter(({
      virt_cluster: e,
      label: t
    }) => {
      const i = r ? t.startsWith("nc.") : t.startsWith("mwp.") || t.startsWith("mwc.") || t.startsWith("dedi."),
        a = !r && !t.startsWith("mw") && !t.startsWith("dedi.");
      return 0 === e && i && !a;
    }),
    s = [];
  return a.forEach(e => {
    if (r) s.push(new UpgradePackage({}, e));else {
      (!e.restrictions || e.restrictions.apps.map(({
        id: e
      }) => e).includes(i)) && s.push(new UpgradePackage({}, e));
    }
  }), s;
});class SslPackage {
  constructor(e = {}) {
    this.annualFee = void 0;
    this.id = void 0;
    this.name = void 0;
    this.sslProductCode = void 0;
    this.pricing = void 0;
    this.annualFee = e.term_fee[12], this.pricing = e.term_fee, this.id = e.id, this.name = e.name, this.sslProductCode = e.ssl_product_code;
  }
}const getSslPackages$1 = new Definition("/package?type=ssl&sortProperty=id&sortDirection=desc", "GET", i => ({
  list: i.data.map(i => new SslPackage(i)),
  pagination: new Pagination(i)
}));const getStagingSitePackages$2 = new Definition("/package?type=virt-guest-cloud&pageSize=250&environment_type=staging", "GET", e => e.data);var legacy$6=/*#__PURE__*/Object.freeze({__proto__:null,getCloudServerPackages:getCloudServerPackages$2,getDevSitePackages:getDevSitePackages$2,getSiteUpgradePrices:getSiteUpgradePrices$1,getSslPackages:getSslPackages$1,getStagingSitePackages:getStagingSitePackages$2});const getCloudServerPackages$1 = new Definition("/api/v1/package/cloud-server?pageSize=250", "GET", e => e.data);const getDevSitePackages$1 = new Definition("/api/v1/package/dev-site?pageSize=250&sortBy=monthly_fee", "GET", e => e.data);const getSitePackage$1 = new Definition("/api/v1/package/site/{id}", "GET", a => new Package(a.data));
const getSitePackages$1 = new Definition({
  path: "/api/v1/package/site?pageSize=250&sortBy=monthly_fee",
  method: "GET",
  responseBody: a => ({
    list: a.data.map(a => new Package(a)),
    pagination: new Pagination(a)
  })
});const getStagingSitePackages$1 = new Definition("/api/v1/package/staging-site?pageSize=250&sortBy=monthly_fee", "GET", i => i.data);const getDomainPackage$1 = new Definition({
  path: "/api/v1/package/domain/{id}",
  method: "GET",
  responseBody: a => new DomainPackage(a.data)
});
const getDomainPackages$1 = new Definition({
  path: "/api/v1/package/domain?pageSize=2000",
  method: "GET",
  responseBody: a => ({
    list: a.data.map(a => new DomainPackage(a)),
    pagination: new Pagination(a)
  })
});const getPackageDesignServicesAddons$1 = new Definition({
  path: "/api/v1/package/addon/site?filter[label]=design-services",
  method: "GET",
  responseBody: e => e?.data.map(e => ({
    configuration: {
      products: e.configuration?.products,
      productVariations: e.configuration?.product_variations,
      revisions: e.configuration?.revisions,
      subpages: e.configuration?.core_pages
    },
    fee: e.setup_fee,
    id: e.id,
    identity: e.identity,
    label: e.label,
    name: e.name
  }))
});
const getPackageSiteKeepAddons$1 = new Definition({
  path: "/api/v1/package/addon/site?filter[label]=sitekeep",
  method: "GET",
  responseBody: e => e.data
});var v1$6=/*#__PURE__*/Object.freeze({__proto__:null,getCloudServerPackages:getCloudServerPackages$1,getDevSitePackages:getDevSitePackages$1,getDomainPackage:getDomainPackage$1,getDomainPackages:getDomainPackages$1,getPackageDesignServicesAddons:getPackageDesignServicesAddons$1,getPackageSiteKeepAddons:getPackageSiteKeepAddons$1,getSitePackage:getSitePackage$1,getSitePackages:getSitePackages$1,getStagingSitePackages:getStagingSitePackages$1});const {
  getSitePackages: getSitePackages,
  getSitePackage: getSitePackage,
  getDomainPackage: getDomainPackage,
  getDomainPackages: getDomainPackages,
  getPackageDesignServicesAddons: getPackageDesignServicesAddons,
  getPackageSiteKeepAddons: getPackageSiteKeepAddons
} = v1$6;
const {
  getSslPackages: getSslPackages,
  getSiteUpgradePrices: getSiteUpgradePrices
} = legacy$6;
const getCloudServerPackages = new GroupDefinition([getCloudServerPackages$1, getCloudServerPackages$2], (e, a) => {
  const t = e => a.data.find(a => a.id === e);
  return {
    list: e.data.filter(e => t(e.id)).map(e => new CloudServerPackage(e, t(e.id))),
    pagination: new Pagination(e)
  };
});
const packagesResponseBody = (e, a) => {
  const t = e => a.data.find(a => a.id === e);
  return {
    list: e.data.filter(e => t(e.id)).map(e => new Package(e, t(e.id))),
    pagination: new Pagination(e)
  };
};
const getDevSitePackages = new GroupDefinition([getDevSitePackages$1, getDevSitePackages$2], packagesResponseBody);
const getStagingSitePackages = new GroupDefinition([getStagingSitePackages$1, getStagingSitePackages$2], packagesResponseBody);var packages=/*#__PURE__*/Object.freeze({__proto__:null,getCloudServerPackages:getCloudServerPackages,getDevSitePackages:getDevSitePackages,getDomainPackage:getDomainPackage,getDomainPackages:getDomainPackages,getPackageDesignServicesAddons:getPackageDesignServicesAddons,getPackageSiteKeepAddons:getPackageSiteKeepAddons,getSitePackage:getSitePackage,getSitePackages:getSitePackages,getSiteUpgradePrices:getSiteUpgradePrices,getSslPackages:getSslPackages,getStagingSitePackages:getStagingSitePackages});class ApiToken {
  constructor(e = {}) {
    this.id = void 0;
    this.name = void 0;
    this.tokenId = void 0;
    this.userId = void 0;
    this.id = e.id, this.name = e.name, this.tokenId = e.token_id, this.userId = e.user_id;
  }
}class BackupRestore {
  constructor(t) {
    this.id = void 0;
    this.status = void 0;
    this.formattedStatus = void 0;
    this.completeDate = void 0;
    this.error = void 0;
    this.startDate = void 0;
    this.backupUuid = void 0;
    this.id = t.id, this.status = t.status, this.formattedStatus = `${t.status?.charAt(0)?.toUpperCase()}${t.status?.slice(1)}`, this.completeDate = t.complete_date, this.error = t.error, this.startDate = t.start_date, this.backupUuid = t.backup_uuid;
  }
}class ContainerPort {
  constructor(t = {}) {
    this.id = void 0;
    this.publishPort = void 0;
    this.id = t.port_id, this.publishPort = t.publish_port;
  }
}class Container {
  constructor(t = {}) {
    this.id = void 0;
    this.hostname = void 0;
    this.ports = void 0;
    this.state = void 0;
    this.group = void 0;
    this.typeId = void 0;
    this.version = void 0;
    this.isStable = void 0;
    this.id = t.id, this.hostname = t.hostname, this.ports = t.ports ? t.ports.map(t => new ContainerPort(t)) : [], this.state = t.state, this.group = new ContainerGroups(t.type), this.typeId = t.addon?.id, this.version = t.version, this.isStable = "stable" === t.state;
  }
}class DailyBackup {
  constructor(t) {
    this.filedate = void 0;
    this.filedateIso = void 0;
    this.formattedStatus = void 0;
    this.id = void 0;
    this.status = void 0;
    this.filedate = Date.parse(t.created), this.filedateIso = t, this.formattedStatus = "Completed", this.id = t.backup_id, this.status = "completed";
  }
}function handleError(r) {
  let t = r;
  return this?.translations?.[r] && (t = this.translations[r]), t;
}
function equals(r, t) {
  return Array.isArray(r) && Array.isArray(t) ? r.length === t.length && r.every(r => t.includes(r)) : r === t;
}
class FormValidatorField {
  constructor(r = null, t = {}, s = {}) {
    this.name = void 0;
    this.autoDirty = void 0;
    this.dirty = void 0;
    this.errors = void 0;
    this.form = void 0;
    this.oldValue = void 0;
    this.origValue = void 0;
    this.ruleKeys = void 0;
    this.rules = void 0;
    this.valid = void 0;
    this.translations = void 0;
    this.value = void 0;
    this.loading = void 0;
    this.isValid = () => !this.errors || !this.errors.length;
    this.name = s.name || null, this.dirty = !1, this.oldValue = null;
    const i = Array.isArray(r) ? Array.from(r) : r;
    this.origValue = i, this.value = this.origValue, this.rules = t, this.ruleKeys = Object.keys(t), this.valid = !0, this.errors = !1, this.autoDirty = !s.disableAutoDirty, this.translations = s.translations, this.loading = !1;
  }
  getErrors(r, t) {
    return new Promise(s => {
      if (!this.ruleKeys.length) return void s(!1);
      let i = 0;
      const e = [],
        l = !equals(this.oldValue, this.value),
        a = this.name !== t,
        h = this.value === this.origValue && null === this.origValue;
      h || a && h || l && !this.errors || l && !a && this.errors ? this.ruleKeys.forEach(async t => {
        const l = this.rules[t](this.value, r);
        if (l.then) {
          const r = await l.then(r => r ? null : Promise.resolve(handleError.call(this, t)));
          r && e.push(r);
        } else {
          const r = handleError.call(this, t);
          l || e.push(r);
        }
        i += 1, i === this.ruleKeys.length && (e.length || (this.oldValue = this.value), s(!!e.length && e));
      }) : s(!!this.errors && this.errors);
    });
  }
  async update(r, t, s) {
    this.autoDirty && (this.dirty = !0), this.oldValue = this.value;
    const i = Array.isArray(t) ? Array.from(t) : t;
    return this.value = i, this.validate(r, s);
  }
  async validate(r, t) {
    this.loading = !0, this.errors = await this.getErrors(r, t), this.valid = this.isValid(), this.loading = !1;
  }
  touch() {
    this.dirty = !0;
  }
  reset() {
    this.dirty = !1;
  }
}class FormValidator {
  constructor(e, s = {}, i = {}, t = {}) {
    this.errors = [];
    this.fieldKeys = void 0;
    this.fields = void 0;
    this.valid = void 0;
    if ("object" != typeof e) throw new Error("Fields must be an object with properties for each field");
    this.fieldKeys = Object.keys(e);
    const r = {};
    this.fieldKeys.forEach(l => {
      let h = {
        name: l
      };
      i[l] && (h = {
        ...h,
        ...i[l]
      }), t[l] && (h.translations = t[l]), r[l] = new FormValidatorField(e[l], s?.[l], h);
    }), this.fields = r;
  }
  async update(e, s) {
    this.fields[e] && (await this.fields[e].update(this.fields, s, e), await this.checkFields(!1, [e]));
  }
  async checkFields(e = !1, s = []) {
    const i = [];
    await new Promise(t => {
      let r = 0;
      this.fieldKeys.forEach(async l => {
        s.includes(l) || this.fields[l].loading || (await this.fields[l].validate(this.fields, l), e && this.fields[l].touch()), this.fields[l].errors && this.fields[l].errors.length && i.push({
          name: l,
          errors: this.fields[l].errors
        }), r += 1, r === this.fieldKeys.length && t();
      });
    }), this.errors = i, this.valid = !!this.errors?.length;
  }
  touch(e) {
    this.fields[e].touch();
  }
  reset(e) {
    e ? this.fields[e].reset() : this.fieldKeys.forEach(e => {
      this.fields[e].reset();
    });
  }
  async validate() {
    if (await this.checkFields(!0), this.errors && this.errors.length) throw new Error(this.errors);
    return !0;
  }
}class InvoicePayment {
  constructor(e = {}) {
    this.id = void 0;
    this.amount = void 0;
    this.originalAmount = void 0;
    this.paymentDate = void 0;
    this.reference = void 0;
    this.type = void 0;
    this.id = e.id, this.amount = e.amount, this.originalAmount = e.original_amount, this.paymentDate = e.payment_date, this.reference = e.reference, this.type = e.type;
  }
}class Log {
  constructor(o = {}) {
    this.date = void 0;
    this.download = void 0;
    this.fileLocation = void 0;
    this.name = void 0;
    this.date = o.date, this.download = o.download_url, this.fileLocation = o.log_file, this.name = o.log_file.split("/").pop();
  }
}class Member {
  constructor(e = {}) {
    this.id = void 0;
    this.identity = void 0;
    this.firstName = void 0;
    this.lastName = void 0;
    this.superuser = void 0;
    this.owner = void 0;
    this.teams = void 0;
    this.status = void 0;
    this.email = void 0;
    this.verified = void 0;
    this.teamIds = void 0;
    this.id = e.id, this.identity = e.identity, this.firstName = e.first_name, this.lastName = e.last_name, this.superuser = e.is_sueruser, this.owner = e.is_owner, this.teams = e.roles.map(({
      id: e,
      identity: s
    }) => ({
      id: e,
      name: s
    })), this.status = e.status, this.email = e.email, this.verified = e.verified, this.teamIds = e.role_ids;
  }
}const migration_sources = ["1and1 Hosting", "20i", "A Small Orange", "A2 Hosting", "Amazon AWS", "Armor", "Aspiration Hosting", "Azure", "Backup (From File)", "Bluehost", "ChemiCloud", "clearFusionCMS", "Cloudways", "Contabo", "ControlVM", "Cyber Studios", "Deluxe Hosting", "Digital Eel", "Digital Ocean", "DomainKing", "Dreamhost", "Dropbox Files", "EarthLink Web Hosting", "Elastycloud", "Execulink", "Exonhost", "Expedient", "FastComet", "Fasthosts", "Fastly", "Flexwebhosting", "Flywheel", "Future Hosting", "Gandi Hosting", "GoDaddy", "Google Cloud", "GreenDreamWeb", "Guru Web Hosting", "Heart Internet", "Hetzner", "Host1Plus(Heficed)", "HostArmada", "HostDime", "HostGator", "Hosting24", "Hostinger", "HostMaria", "HostMonster", "Hostwinds", "HybrHost", "iFastNet", "InMotion Hosting", "Inputhost", "IONOS(1&1)", "iPage", "IPOWER", "Just Host", "Kinsta", "Knownhost", "Krystal", "LetsHost", "Linode", "Liquid Web", "M3 Group", "MageMojo", "Main Street Design", "Media Temple", "MGT-Commerce(AWS Magento Cloud)", "MochaHost", "Namecheap", "NameHero", "Network Solutions", "Nexcess", "Orangewebsite", "OVHcloud", "OzHosting", "Pagely", "Pantheon Hosting", "Performative(ZeroLag)", "Pressidium", "Pulsant", "QServers", "Rackspace", "Rainmaker Platform", "SiteGround", "SoftLayer(IBM)", "Sucuri", "TierraNet", "TOPIMR", "Tranquility", "TSS/Performive", "UKFast", "Valiant Hosting", "VeeroTech", "Voyager", "VPS.Data Center", "vpsdime", "Vultr", "WebCreationUS", "WebFraction", "Webnames", "Westhost", "Wordpress.com", "WP Engine", "ZeroLag", "Other", "Unkown/NA"];
class MigrationFormSite {
  constructor(e, t) {
    this.index = 0;
    this.website = null;
    this.migrate_from = null;
    this.migrate_from_other = null;
    this.hosting_access = null;
    this.application_type = null;
    this.application_type_other = null;
    this.php_version = "8.3";
    this.multisite = "No";
    this.multisite_configuration = null;
    this.migrate_email = "No";
    this.outside_files = "No";
    this.outside_files_locations = null;
    this.redis = "No";
    this.final_sync = "No";
    this.dns_hosted = null;
    this.special_requirements = null;
    this.migration_sources = migration_sources;
    this.index = e, t && Object.assign(this, t);
  }
  getLines() {
    const e = [];
    return e.push({
      label: "Website",
      content: this.website
    }), "Other" === this.migrate_from ? e.push({
      label: "Migrating From",
      content: `Other (${this.migrate_from_other})`
    }) : e.push({
      label: "Migrating From",
      content: this.migrate_from
    }), e.push({
      label: "Hosting Access",
      content: this.hosting_access
    }), "Other" === this.application_type ? e.push({
      label: "Application Type",
      content: `Other (${this.application_type_other})`
    }) : e.push({
      label: "Application Type",
      content: this.application_type
    }), e.push({
      label: "PHP Version",
      content: this.php_version
    }), ["WordPress", "WooCommerce", "Magento"].includes(this.application_type) && (e.push({
      label: "Magento" === this.application_type ? "Multistore" : "Multisite",
      content: this.multisite
    }), "Yes" === this.multisite && e.push({
      label: "Multisite Configuration",
      content: this.multisite_configuration
    })), ["Nexcess", "Liquid Web"].includes(this.migrate_from) && e.push({
      label: "Migrate Email",
      content: this.migrate_email
    }), e.push({
      label: "Redis",
      content: this.redis
    }), e.push({
      label: "Outside Files",
      content: this.outside_files
    }), "Yes" === this.outside_files && e.push({
      label: "Outside Files Locations",
      content: this.outside_files_locations
    }), e.push({
      label: "Special Requirements",
      content: this.special_requirements || "None"
    }), e.push({
      label: "DNS Hosted",
      content: this.dns_hosted
    }), e.push({
      label: "Needs final sync",
      content: this.final_sync
    }), e;
  }
}const bodyData$1 = (e, t) => `${e}:\r\n${t}\r\n\r\n`,
  bodyBreak = () => "------------\r\n\r\n",
  bodyTitle$1 = e => `------------\r\n${e}\r\n\r\n`,
  checkSite = e => {
    let t = e;
    return t instanceof MigrationFormSite || (t = new MigrationFormSite(e.index, e)), t;
  };
class MigrationForm {
  constructor(e = {}) {
    this.name = void 0;
    this.phone = void 0;
    this.email = void 0;
    this.destination = "New Nexcess Plan";
    this.reason = void 0;
    this.recommendedBy = void 0;
    this.sites = [];
    this.reasonOptions = ["Upgrading", "Downgrading", "Performance and Scalability", "Separating from Source Account", "Pricing", "Added Features", "Unhappy with previous host", "Nexcess Support", "Recommended by:"];
    this.name = e.name || null, this.phone = e.phone || null, this.email = e.email || null, this.destination = e.destination || "New Nexcess Plan", this.reason = e.reason || null, this.recommendedBy = e.recommendedBy || null;
  }
  addSite(e) {
    return this.sites.push(checkSite(e)), this.sites;
  }
  addOrUpdateSite(e) {
    const t = checkSite(e),
      i = this.sites.findIndex(e => e.index === t.index);
    return i > -1 ? this.sites[i] = t : this.addSite(t), this.sites;
  }
  deleteSite(e) {
    const t = checkSite(e);
    return this.sites = this.sites.filter(e => e.index !== t.index), this.sites;
  }
  nextSiteIndex() {
    return Math.max(...this.sites.map(e => e.index)) + 1;
  }
  getLastSite() {
    return this.sites[this.sites.length - 1];
  }
  getReason() {
    return "Recommended by:" === this.reason ? `Recommended by: ${this.recommendedBy}` : this.reason;
  }
  getLines() {
    return {
      contact: [{
        label: "Name",
        content: this.name
      }, {
        label: "Email",
        content: this.email
      }, {
        label: "Phone",
        content: this.phone
      }, {
        label: "Destination Plan",
        content: this.destination
      }, {
        label: "Reason For Migrating",
        content: this.getReason()
      }],
      sites: this.sites.map(e => ({
        lines: e.getLines(),
        site: e
      }))
    };
  }
  getBody(e) {
    const t = this.getLines();
    let i = "";
    return i += bodyData$1("Name", this.name), i += bodyData$1("Email", this.email), i += bodyData$1("Phone", this.phone), i += bodyData$1("Client ID", e), i += bodyData$1("Destination Plan", this.destination), i += bodyData$1("Reason For Migrating", this.getReason()), i += bodyBreak(), this.sites.length && (i += bodyData$1("Website Count", this.sites.length), i += bodyTitle$1("WEBSITES"), t.sites.forEach(e => {
      e.lines.forEach(e => {
        i += bodyData$1(e.label, e.content);
      }), i += bodyBreak();
    })), i;
  }
}class PartnerLinkBanner {
  constructor(t = {}) {
    this.altText = void 0;
    this.id = void 0;
    this.name = void 0;
    this.status = void 0;
    this.url = void 0;
    this.altText = t.alt_text, this.id = t.id, this.name = t.name, this.status = t.status, this.url = t.url;
  }
}let PartnerLink$1=class PartnerLink {
  constructor(t = {}) {
    this.banners = void 0;
    this.hits = void 0;
    this.id = void 0;
    this.link = void 0;
    this.name = void 0;
    this.provided = void 0;
    this.status = void 0;
    this.formattedStatus = void 0;
    this.target = void 0;
    this.banners = (t.banners || []).map(t => new PartnerLinkBanner(t)), this.hits = t.hits, this.id = t.id, this.link = t.link, this.name = t.name, this.provided = t.provided, this.status = t.status, this.formattedStatus = `${t.status?.charAt(0)?.toUpperCase()}${t.status?.slice(1)}`, this.target = t.target_url;
  }
};const bodyData = (a, e) => `${a}:\r\n${e}\r\n\r\n`,
  bodyTitle = a => `------------\r\n${a}\r\n\r\n`;
class PartnerPaymentMethodForm {
  constructor(a, e = {}) {
    this.method = void 0;
    this.payPalAddress = void 0;
    this.payeeName = void 0;
    this.payeeContactName = void 0;
    this.payeePhone = void 0;
    this.payeeEmail = void 0;
    this.payeeAddress = void 0;
    this.bankName = void 0;
    this.bankAddress = void 0;
    this.bankAccountName = void 0;
    this.bankAccountNumber = void 0;
    this.bankRoutingNumber = void 0;
    this.bankSwiftCode = void 0;
    this.bankAccountType = void 0;
    this.method = a, this.payPalAddress = e.address, this.payeeName = e.payeeName, this.payeeContactName = e.payeeContactName, this.payeePhone = e.payeePhone, this.payeeEmail = e.payeeEmail, this.payeeAddress = e.payeeAddress, this.bankName = e.bankName, this.bankAddress = e.bankAddress, this.bankAccountName = e.bankAccountName, this.bankAccountNumber = e.bankAccountNumber, this.bankRoutingNumber = e.bankRoutingNumber, this.bankSwiftCode = e.bankSwiftCode, this.bankAccountType = e.bankAccountType;
  }
  getBody() {
    let a = "";
    switch (a += bodyData("Method", this.method), this.method) {
      case "PayPal":
        a += bodyTitle("PayPal Information"), a += bodyData("PayPal Address", this.payPalAddress);
        break;
      case "Wire Transfer / ACH":
        a += bodyTitle("Vendor/Payee Information"), a += bodyData("Payee Name", this.payeeName), this.payeeContactName && (a += bodyData("Payee Contact Name", this.payeeContactName)), a += bodyData("Payee Phone Number", this.payeePhone), a += bodyData("Payee Email Address", this.payeeEmail), a += bodyData("Payee Address", this.payeeAddress), a += bodyTitle("Financial Institution Information"), a += bodyData("Bank Name", this.bankName), a += bodyData("Bank Address", this.bankAddress), a += bodyData("Name on Bank Account", this.bankAccountName), a += bodyData("Bank Account Number", this.bankAccountNumber), a += bodyData("Bank Routing Number", this.bankRoutingNumber), this.bankSwiftCode && (a += bodyData("Bank Swift Code", this.bankSwiftCode)), a += bodyData("Type of Account", this.bankAccountType);
    }
    return a;
  }
}class PartnerReferralService {
  constructor(t = {}) {
    this.commission = void 0;
    this.description = void 0;
    this.pricingType = void 0;
    this.startDate = void 0;
    this.status = void 0;
    this.type = void 0;
    this.formattedStartDate = void 0;
    this.commission = t.commission, this.description = t.description, this.pricingType = t.pricing_type, this.startDate = t.start_date, this.status = t.status, this.type = t.type, this.formattedStartDate = dateFormat(t.start_date);
  }
}class PartnerLink {
  constructor(e = {}) {
    this.id = void 0;
    this.formattedReferredDate = void 0;
    this.referredDate = void 0;
    this.services = void 0;
    this.status = void 0;
    this.id = e.id, this.formattedReferredDate = dateFormat(e.referred_date), this.referredDate = e.referred_date, this.status = e.status, this.services = (e.services || []).map(e => new PartnerReferralService(e));
  }
}class Payment {
  constructor(t = {}) {
    this.amount = void 0;
    this.date = void 0;
    this.formattedDate = void 0;
    this.id = void 0;
    this.invoiceDescription = void 0;
    this.invoiceId = void 0;
    this.reference = void 0;
    this.type = void 0;
    this.amount = t.amount, this.formattedDate = dateFormat(t.payment_date), this.id = t.id, this.invoiceId = t.invoice.id, this.invoiceDescription = t.invoice.description, this.date = t.payment_date, this.reference = t.reference || null, this.type = t.type;
  }
}class PayPalAccount {
  constructor(t = {}) {
    this.id = void 0;
    this.identity = void 0;
    this.name = void 0;
    this.paymentType = void 0;
    this.type = void 0;
    this.id = t.id, this.identity = t.identity, this.name = "Billing Agreement on File", this.type = "PayPal", this.paymentType = "paypal";
  }
}class PhpCompatibilityCheck {
  constructor(t = {}) {
    this.phpVersion = void 0;
    this.report = void 0;
    this.siteId = void 0;
    this.status = void 0;
    this.phpVersion = t.php_version, this.status = t.status, this.siteId = t.site?.id, t.report && void 0 === t.report.invalid && (this.report = {
      files: (t.report?.files || {}).map(({
        errors: t,
        messages: s,
        file: e,
        warnings: i
      }) => ({
        name: e,
        errors: t,
        warnings: i,
        messages: s
      })),
      totals: t.report?.totals
    });
  }
  static formatWebsocketEvent(t) {
    return new PhpCompatibilityCheck({
      site: {
        id: t.account_id
      },
      php_version: t.php_version,
      status: t.status
    });
  }
}class Plan extends Service {
  constructor(t = {}) {
    super(t);
    this.allowsStencils = void 0;
    this.app = void 0;
    this.billing = void 0;
    this.childCloudAccounts = void 0;
    this.cloudAccounts = void 0;
    this.cloudAccount = void 0;
    this.created = void 0;
    this.primarySite = void 0;
    this.description = void 0;
    this.devEnvironments = void 0;
    this.devEnvironmentCount = void 0;
    this.environmentType = void 0;
    this.isCancellable = void 0;
    this.isProduction = void 0;
    this.isTShirt = void 0;
    this.location = void 0;
    this.package = void 0;
    this.secondarySiteCount = void 0;
    this.siteCount = void 0;
    this.totalSiteCount = void 0;
    this.addons = void 0;
    const {
      child_accounts: n,
      dev_accounts: c,
      primary_accounts: o,
      term_fee: i
    } = t?.package || {};
    this.billing = new Billing(t.billing_info), this.childCloudAccounts = t.child_cloud_accounts || [], this.cloudAccounts = t.sites || t.cloud_accounts || [], this.cloudAccount = t.site || t.cloud_account || {}, this.created = t.start_date, this.primarySite = new Site(t.site || t.cloud_account), this.description = t.identity, this.devEnvironmentCount = t.dev_accounts?.length || t?.counts?.dev_accounts || 0, this.devEnvironments = t.dev_accounts || [], this.environmentType = t.environment_type, this.isAws = "aws" === t.location?.type, this.isCancellable = !!t.cancellation_info?.can_cancel, this.isProduction = "production" === t.environmentType, this.isTShirt = !t.plan_type, this.location = new Location(t.location), this.package = new Package({
      ...t.package,
      term_fees: i
    }, {
      child_accounts: n,
      dev_accounts: c,
      primary_accounts: o
    }), this.allowsStencils = this.package.cloudAccounts >= 3 && !["development", "staging"].includes(this.environmentType), this.siteCount = t?.counts?.cloud_accounts || t.cloud_accounts?.length || 0, this.secondarySiteCount = t?.counts?.child_accounts || t.child_cloud_accounts?.length || 0, this.totalSiteCount = Plan.getTotalSiteCount(t), this.app = new App(this.cloudAccount?.app), this.addons = t.addons;
  }
  static formatLegacy(t) {
    return new Plan({
      billing_info: {
        amount: t.billing_term?.amount,
        next_bill_date: t.next_bill_date,
        months: t.billing_term?.months,
        type: t.billing_term?.type
      },
      child_accounts: t.child_cloud_accounts,
      cloud_accounts: t.cloud_accounts,
      cloud_account: t.cloud_account,
      dev_accounts: new Array(t.dev_account_count).fill({}),
      environment_type: t.environment_type,
      id: t.id,
      location: {
        id: t.location?.id,
        location: t.location?.location,
        country: t.location?.country
      },
      nickname: t.nickname,
      start_date: t.start_date,
      state: t.state,
      package: {
        id: t.package?.id,
        name: t.package?.name,
        primary_accounts: t.package?.primary_accounts,
        child_accounts: t.package?.child_accounts
      },
      plan_type: t.plan_type
    });
  }
  static getProduction(t) {
    return t.filter(t => "production" === t.environmentType);
  }
  static getTotalSiteCount(t) {
    return t?.counts ? (t?.counts?.sites || 0) + (t?.counts?.child_sites || 0) : (t.cloud_accounts?.length || 0) + (t.child_cloud_accounts?.length || 0);
  }
}class PointerDomain {
  constructor(i = {}) {
    this.domain = i.domain, this.mailAlias = i.mail_alias, this.pointsTo = i.points_to, this.type = "Server Alias" === i.type ? "Alias/CNAME" : i.type;
  }
}class ResellerHost extends Service {
  constructor(e = {}) {
    (super(e), this.autoRenew = void 0, this.bandwidth = void 0, this.isCancellable = void 0, this.hostname = void 0, this.settings = void 0), this.autoRenew = e.auto_renew, this.hostname = e.host?.hostname, this.bandwidth = new BandwidthProfile({
      bandwidth: e.bandwidth,
      overageFee: e.bandwidth_overage_fee,
      profileId: e.bandwidth_profile_id
    }), this.edgecast = new EdgecastAccount(e.edgecast), this.isCancellable = e.is_cancellable, this.settings = e.settings;
  }
}const formatPermissionRadio = i => {
  const e = Object.values(i),
    s = e.filter(i => "Edit" === i);
  return [...e.filter(i => "Edit" !== i), ...s];
};
class Role {
  constructor(i = {}) {
    this.id = void 0;
    this.resourceId = void 0;
    this.name = void 0;
    this.category = void 0;
    this.priority = void 0;
    this.permissionRadio = void 0;
    this.permissionCheck = void 0;
    this.id = i.id, this.resourceId = i.resource_id, this.name = i.name, this.category = i.category, this.priority = i.priority, this.permissionRadio = formatPermissionRadio(i?.permissions?.options), this.permissionCheck = i?.permissions?.delete ? ["Delete"] : [];
  }
}class Stencil {
  constructor(t = {}) {
    this.id = void 0;
    this.name = void 0;
    this.site = void 0;
    this.created = void 0;
    this.state = void 0;
    this.screenshotUrl = void 0;
    this.id = t.id, this.name = t.name, this.site = {
      id: t?.site?.id || t?.cloud_account?.id
    }, this.created = t.stencil_date, this.state = t.state, this.screenshotUrl = t.screenshot_url, this.isStable = "stable" === t.state;
  }
  static formatLegacy(t) {
    return new Stencil({
      id: t.id,
      name: t.name,
      cloud_account: {
        id: t.account_id
      },
      stencil_date: t.stencil_date,
      screenshot_url: t.screenshot_url,
      state: t.state
    });
  }
}class TicketAttachment {
  constructor(t = {}) {
    this.id = void 0;
    this.download_url = void 0;
    this.last_modified_date = void 0;
    this.name = void 0;
    this.id = t.id, this.downloadUrl = t.download_url, this.lastModifiedDate = t.last_modified_date, this.name = t.name;
  }
}class TicketComment {
  constructor(t = {}) {
    this.body = void 0;
    this.contact = void 0;
    this.created_date = void 0;
    this.type = void 0;
    this.body = t.body, this.contact = t.contact, this.createdDate = t.created_date, this.type = t.type;
  }
}class TicketRating {
  constructor(t = {}) {
    this.contact = void 0;
    this.created_date = void 0;
    this.feedback = void 0;
    this.rating = void 0;
    this.contact = t.contact?.identity, this.createdDate = t.created_date, this.feedback = t.feedback, this.rating = t.rating;
  }
}class Ticket {
  constructor(t = {}) {
    this.attachments = void 0;
    this.case_number = void 0;
    this.category = void 0;
    this.comments = void 0;
    this.department = void 0;
    this.id = void 0;
    this.is_closed = void 0;
    this.last_modified_date = void 0;
    this.ratings = void 0;
    this.service = void 0;
    this.status = void 0;
    this.subject = void 0;
    this.watchers = void 0;
    this.id = t.case_number, this.nocworxId = t.id, this.status = t.status, this.attachments = (t.attachments || []).map(t => new TicketAttachment(t)).sort((t, e) => e.lastModifiedDate - t.lastModifiedDate), this.category = t.category, this.comments = (t.comments || []).map(t => new TicketComment(t)).sort((t, e) => e.createdDate - t.createdDate), this.department = t.department, this.isClosed = t.is_closed, this.lastModifiedDate = t.last_modified_date, this.ratings = (t.ratings || []).map(t => new TicketRating(t)).sort((t, e) => e.createdDate - t.createdDate), this.service = t.service, this.subject = t.subject, this.watchers = t.watchers;
  }
}
Ticket.ParseCustomFields = (t, e, s) => {
  let a = s,
    i = !0;
  return Object.entries(t).forEach(([t, s]) => {
    e[t] && (i && (a += "\r\n\r\n------------\r\n\r\n", i = !1), a += `${s}:\r\n${e[t]}\r\n\r\n`);
  }), a;
};class Team {
  constructor(s = {}) {
    this.id = void 0;
    this.isUsed = void 0;
    this.name = void 0;
    this.permissions = void 0;
    this.roleId = void 0;
    this.superuser = void 0;
    this.clientId = void 0;
    this.id = s.id, this.name = s.name, this.roleId = s.role_id, this.superuser = s.is_superuser, this.clientId = s.client_id, this.isUsed = s.is_used, this.permissions = {}, permissionResources.forEach(s => {
      this.permissions[s] = [];
    }), this.superuser ? permissionResources.forEach(s => {
      this.permissions[s] = permissionLevels[7];
    }) : Object.keys(s.resources).forEach(e => {
      this.permissions[permissionResources[e - 1]] = permissionLevels[s.resources[e]];
    });
  }
}class Token {
  constructor(t) {
    this.issued = void 0;
    this.expiration = void 0;
    this.fullObject = void 0;
    this.fullString = void 0;
    this.isAdmin = !1;
    this.fullString = t, this.fullObject = tokenDecode(t), this.issued = this.fullObject?.iat ? new Date(1e3 * this.fullObject.iat) : null, this.expiration = this.fullObject?.exp ? new Date(1e3 * this.fullObject.exp) : null, this.isAdmin = this.fullObject?.sub?.admin, this.client = this.fullObject?.sub?.extranet?.client, this.user = this.fullObject?.sub?.extranet?.user;
  }
  toString() {
    return this.fullString;
  }
}class User {
  constructor(e = {}) {
    this.cell = void 0;
    this.countryCode = void 0;
    this.defaultClientId = void 0;
    this.email = void 0;
    this.firstName = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.isBetaTester = void 0;
    this.lastName = void 0;
    this.overdueHalt = void 0;
    this.permissions = void 0;
    this.settings = void 0;
    this.verified = void 0;
    this.roles = void 0;
    this.status = void 0;
    this.loginableClients = void 0;
    this.email = e.user?.email, this.firstName = e.user?.first_name, this.id = e.user?.id, this.identity = e.user?.identity, this.isBetaTester = e.user?.is_beta_tester, this.lastName = e.user?.last_name, this.overdueHalt = e.user?.overdue_halt, this.permissions = humanReadablePerms(e.permissions), this.verified = e.user?.verified, this.teams = e.roles ? e.roles.map(e => new Team(e)) : [], this.settings = e?.settings, this.status = e.user?.status, this.cell = e.user?.cell, this.countryCode = e.user?.country_code, this.loginableClients = e.user?.access?.loginable_clients, this.defaultClientId = e.user?.access?.default_client?.id;
  }
}class VisCompRegression {
  constructor(e) {
    this.id = void 0;
    this.status = void 0;
    this.afterImageUrl = void 0;
    this.beforeImageUrl = void 0;
    this.appReferenceUrl = void 0;
    this.diffImageUrl = void 0;
    this.score = void 0;
    this.id = e.id, this.status = e.status, this.afterImageUrl = e.after_image_url, this.beforeImageUrl = e.before_image_url, this.appReferenceUrl = e.app_reference_url, this.diffImageUrl = e.diff_image_url, this.score = e.score;
  }
}class VisCompUpgrade {
  constructor(t) {
    this.id = void 0;
    this.state = void 0;
    this.status = void 0;
    this.type = void 0;
    this.startDate = void 0;
    this.completedDate = void 0;
    this.name = void 0;
    this.newVersion = void 0;
    this.version = void 0;
    this.id = t.id, this.upgradeGroupId = t.upgrade_id, this.state = t.state, this.status = t.status, this.type = t.type, this.startDate = t.upgrade_date, this.completedDate = t.upgrade_complete_date, this.uuid = t.upgrade_uuid || t.item_uuid, this.name = t.name, this.newVersion = t.new_version, this.version = t.version;
  }
}class VisCompUpgradeGroup {
  constructor(t) {
    this.id = void 0;
    this.state = void 0;
    this.status = void 0;
    this.type = void 0;
    this.startDate = void 0;
    this.completedDate = void 0;
    this.uuid = void 0;
    this.id = t.id, this.state = t.state, this.status = t.status, this.type = t.type, this.startDate = t.upgrade_date, this.completedDate = t.upgrade_complete_date, this.uuid = t.upgrade_uuid;
  }
}var index$3=/*#__PURE__*/Object.freeze({__proto__:null,Addon:Addon,Address:Address,Announcement:Announcement,ApiToken:ApiToken,App:App,Backup:Backup,BackupRestore:BackupRestore,CertInfo:CertInfo,Certificate:Certificate,Container:Container,ContainerGroup:ContainerGroups,ContainerPassword:ContainerPassword,Credit:Credit,CreditCard:CreditCard,DailyBackup:DailyBackup,Database:Database,DatabaseUser:DatabaseUser,DatabaseUserPassword:DatabaseUserPassword,DomainPackage:DomainPackage,EmailBox:EmailBox,EmailPassword:EmailPassword,FormValidator:FormValidator,FormValidatorField:FormValidatorField,HUD:HUD,HUDFraud:HUDFraud,HUDSite:HUDSite,Invoice:Invoice,InvoiceLineItem:InvoiceLineItem,InvoicePayment:InvoicePayment,Location:Location,Log:Log,Member:Member,MigrationForm:MigrationForm,MigrationFormSite:MigrationFormSite,OS:OS,OSTemplate:OSTemplate,Order:Order,Package:Package,PartnerLink:PartnerLink$1,PartnerPaymentMethodForm:PartnerPaymentMethodForm,PartnerReferral:PartnerLink,Password:Password,PayPalAccount:PayPalAccount,Payment:Payment,PhpCompatibilityCheck:PhpCompatibilityCheck,Plan:Plan,PointerDomain:PointerDomain,ResellerHost:ResellerHost,Role:Role,Site:Site,SslPackage:SslPackage,Stencil:Stencil,Team:Team,Ticket:Ticket,TicketAttachment:TicketAttachment,TicketComment:TicketComment,TicketRating:TicketRating,Token:Token,User:User,VisCompRegression:VisCompRegression,VisCompUpgrade:VisCompUpgrade,VisCompUpgradeGroup:VisCompUpgradeGroup});const setPartnerPaymentInformation$1 = new Definition("/api/v1/client/payment-instructions", "POST", () => null, null, ({
  method: t,
  data: e
}) => ({
  body: new PartnerPaymentMethodForm(t, e).getBody()
}));
const setPartnerPaymentMethod$1 = new Definition({
  path: "/api/v1/affiliate/payout-type",
  method: "POST",
  requestBody: t => ({
    payout_type: t.payoutType.toLowerCase(),
    id: t.clientId
  })
});var v1$5=/*#__PURE__*/Object.freeze({__proto__:null,setPartnerPaymentInformation:setPartnerPaymentInformation$1,setPartnerPaymentMethod:setPartnerPaymentMethod$1});const addPartnerLink$2 = new Definition("/affiliate-link", "POST", e => new PartnerLink$1(e.data), null, e => ({
    name: e.name,
    target_url: e.target,
    status: e.status
  })),
  updatePartnerLink$1 = new Definition("/affiliate-link/{id}", "PATCH", e => new PartnerLink$1(e.data), null, e => ({
    name: e.name,
    target_url: e.target,
    status: e.status
  })),
  getPartnerLinks$1 = new Definition("/affiliate-link", "GET", e => ({
    list: e.data.map(e => new PartnerLink$1(e)),
    pagination: new Pagination(e)
  })),
  getPartnerCredits$1 = new Definition("/affiliate-credit", "GET", e => ({
    list: e.data.map(e => new Credit(e)),
    pagination: new Pagination(e)
  })),
  getPartnerLink$1 = new Definition("/affiliate-link/{id}", "GET", e => new PartnerLink$1(e.data)),
  deletePartnerLink$1 = new Definition("/affiliate-link/{id}", "DELETE", e => e.data),
  getPartnerReferral$1 = new Definition("/affiliate-referral/{id}", "GET", e => new PartnerLink(e.data)),
  getPartnerReferrals$1 = new Definition("/affiliate-referral", "GET", e => ({
    list: e.data.map(e => new PartnerLink(e)),
    pagination: new Pagination(e)
  }));var legacy$5=/*#__PURE__*/Object.freeze({__proto__:null,addPartnerLink:addPartnerLink$2,deletePartnerLink:deletePartnerLink$1,getPartnerCredits:getPartnerCredits$1,getPartnerLink:getPartnerLink$1,getPartnerLinks:getPartnerLinks$1,getPartnerReferral:getPartnerReferral$1,getPartnerReferrals:getPartnerReferrals$1,updatePartnerLink:updatePartnerLink$1});const {
  addPartnerLink: addPartnerLink$1,
  updatePartnerLink: updatePartnerLink,
  getPartnerLinks: getPartnerLinks,
  getPartnerLink: getPartnerLink,
  deletePartnerLink: deletePartnerLink,
  getPartnerCredits: getPartnerCredits,
  getPartnerReferral: getPartnerReferral,
  getPartnerReferrals: getPartnerReferrals
} = legacy$5;
const {
  setPartnerPaymentInformation: setPartnerPaymentInformation,
  setPartnerPaymentMethod: setPartnerPaymentMethod
} = v1$5;var partner=/*#__PURE__*/Object.freeze({__proto__:null,addPartnerLink:addPartnerLink$1,deletePartnerLink:deletePartnerLink,getPartnerCredits:getPartnerCredits,getPartnerLink:getPartnerLink,getPartnerLinks:getPartnerLinks,getPartnerReferral:getPartnerReferral,getPartnerReferrals:getPartnerReferrals,setPartnerPaymentInformation:setPartnerPaymentInformation,setPartnerPaymentMethod:setPartnerPaymentMethod,updatePartnerLink:updatePartnerLink});const generatePassword$1 = new Definition("user/generate-passphrase", "GET", e => e.data);
const getPassword$1 = new Definition("/datashare/{id}", "POST", e => e.data.data, null, () => ({
  _action: "retrieve"
}));var legacy$4=/*#__PURE__*/Object.freeze({__proto__:null,generatePassword:generatePassword$1,getPassword:getPassword$1});const getSiteAppPasswordInfo$1 = new Definition("/api/v1/datashare/virt-guest-cloudaccount/{id}?filter[type]=app-password", "GET", o => new SitePassword(o.data[0]));var v1$4=/*#__PURE__*/Object.freeze({__proto__:null,getSiteAppPasswordInfo:getSiteAppPasswordInfo$1});const {
  generatePassword: generatePassword,
  getPassword: getPassword
} = legacy$4;
const {
  getSiteAppPasswordInfo: getSiteAppPasswordInfo
} = v1$4;var passwords=/*#__PURE__*/Object.freeze({__proto__:null,generatePassword:generatePassword,getPassword:getPassword,getSiteAppPasswordInfo:getSiteAppPasswordInfo});class PaymentOptions {
  constructor(i = {}) {
    this.invoice = void 0;
    this.client = void 0;
    this.type = void 0;
    this.invoice = i.invoice, this.client = i.client, this.type = i.type, this.paypalPayLink = i.paypal_subscribe_link || i.paypal_pay_link || !1;
  }
}const getPayment = new Definition("/payment{id}", "GET", n => new Payment(n.data)),
  getInvoicePayments = new Definition("/payment?invoice_id={id}", "GET", n => ({
    list: n.data.map(n => new InvoicePayment(n)),
    pagination: new Pagination(n)
  })),
  getPayments = new Definition("/payment", "GET", n => ({
    list: n.data.map(n => new Payment(n)),
    pagination: new Pagination(n)
  })),
  getPaymentOptions = new Definition("/payment/new?invoice_id={id}", "GET", n => new PaymentOptions(n.data)),
  addPayment$1 = new Definition("payment/new", "POST", n => new Payment(n.data), null, n => {
    const e = {
      payment_method: n.paymentMethod,
      creditcard_id: n.creditCard,
      cvv: n.cvv,
      invoice_id: n.invoiceId,
      number: n.creditCardNumber
    };
    if (n.cardExpirationDate) {
      const t = n.cardExpirationDate.split("/");
      e.expiration = new Date(t[1], t[0] - 1, 15).getTime() / 1e3;
    }
    return e;
  });var payments=/*#__PURE__*/Object.freeze({__proto__:null,addPayment:addPayment$1,getInvoicePayments:getInvoicePayments,getPayment:getPayment,getPaymentOptions:getPaymentOptions,getPayments:getPayments});const createPayPalAccount = new Definition({
  path: "/api/v1/paypal-account",
  method: "POST",
  responseBody: a => new PayPalAccount(a.data),
  requestBody: a => ({
    braintree_token: a.nonce
  })
});
const deletePayPalAccount = new Definition({
  path: "/api/v1/paypal-account/{id}",
  method: "DELETE",
  responseBody: a => a.data
});
const getPayPalAccount = new Definition({
  path: "/api/v1/paypal-account/{id}",
  method: "GET",
  responseBody: a => new PayPalAccount(a.data)
});
const getPayPalAccounts = new Definition({
  path: "/api/v1/paypal-account",
  method: "GET",
  responseBody: a => ({
    list: a.data.map(a => new PayPalAccount(a)),
    pagination: new Pagination(a)
  })
});
const getPayPalToken = new Definition({
  path: "/api/v1/paypal-account/token",
  method: "POST",
  responseBody: a => a.data
});var payPal=/*#__PURE__*/Object.freeze({__proto__:null,createPayPalAccount:createPayPalAccount,deletePayPalAccount:deletePayPalAccount,getPayPalAccount:getPayPalAccount,getPayPalAccounts:getPayPalAccounts,getPayPalToken:getPayPalToken});class PlanDiskSpace {
  constructor(e = {}) {
    this.free = void 0;
    this.planId = void 0;
    this.sites = void 0;
    this.used = void 0;
    this.quota = void 0;
    this.free = {
      gb: Number(Math.max(0, e.quota - e.used_gb).toFixed(2)),
      percent: Math.max(0, Number((100 - e.used_percent).toFixed(2)))
    }, this.planId = e.service.id, this.sites = e.site_usage.map(t => ({
      id: t.site.id,
      identity: t.site.identity,
      gb: Number(Number(t.used_gb).toFixed(2)),
      updated: t.updated,
      percent: Number((t.used_gb / e.quota * 100).toFixed(2))
    })), this.used = {
      gb: Number(Number(e.used_gb).toFixed(2)),
      percent: Number(e.used_percent.toFixed(2))
    }, this.quota = e.quota;
  }
}const getPlan$2 = new Definition({
  path: "/api/v1/service/{id}",
  method: "GET",
  responseBody: e => new Plan(e.data)
});
const getPlanDiskSpace$1 = new Definition({
  path: "/api/v1/service/cloud-account/{id}/apm/storage",
  method: "GET",
  responseBody: e => new PlanDiskSpace(e.data)
});
const getPlans$2 = new Definition({
  path: "/api/v1/service/cloud-account-list?filter[environment_type]=production&_v2=true",
  method: "GET",
  responseBody: e => ({
    list: e.data.map(e => new Plan(e)),
    pagination: new Pagination(e)
  }),
  transformParams: e => transformSortParamsToV1(e)
});
const updatePlanName$1 = new Definition({
  path: "/api/v1/service/{id}/nickname",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    nickname: e.name
  })
});
const updatePlanTerm$1 = new Definition({
  path: "/api/v1/service/{id}/term",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    term: e.term
  })
});
const updatePlanPackage$1 = new Definition("/api/v1/service/{id}/resize", "POST", e => e.data, null, e => ({
  package_id: e.packageId
}));
const createPlan$1 = new Definition({
  path: "/api/v1/site/plan",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    app_id: e.appId,
    package_id: e.packageId,
    install_app: e.installApp,
    cloud_id: e.locationId,
    nickname: e.nickname,
    affiliate: e.affiliate,
    addon_ids: e.addonIds,
    has_creds: e.hasCreds,
    discount_code: e.discountCode,
    term: e.term,
    storebuilder_uuid: e.storeBuilderId,
    context: e.context
  }),
  validation: e => {
    if (null == e.appId || "number" != typeof e.appId) throw new Error("Field 'appId' is required and must be a number");
    if (null == e.packageId || "number" != typeof e.packageId) throw new Error("Field 'packageId' is required and must be a number");
    if (null == e.locationId || "number" != typeof e.locationId) throw new Error("Field 'locationId' is required and must be a number");
    if (null != e.term && ("number" != typeof e.term || ![1, 12, 24, 36].includes(e.term))) throw new Error("Field 'term' must be the number 1, 12, 24, or 36.");
    if (null != e.nickname && "string" != typeof e.nickname) throw new Error("Field 'nickname' must be a string");
    if (null != e.discountCode && "string" != typeof e.discountCode) throw new Error("Field 'discountCode' must be a string");
    if (null != e.storeBuilderId && "string" != typeof e.storeBuilderId) throw new Error("Field 'storeBuilderId' must be a string");
    if (null != e.installApp && "boolean" != typeof e.installApp) throw new Error("Field 'installApp' must be a boolean");
    if (null != e.hasCreds && "boolean" != typeof e.hasCreds) throw new Error("Field 'hasCreds' must be a boolean");
    if (null != e.affiliate && "number" != typeof e.affiliate) throw new Error("Field 'affiliate' must be a number");
    if (null != e.context && !Array.isArray(e.context)) throw new Error("Field 'context' must be an array");
    if (null != e.addonIds && !Array.isArray(e.addonIds)) throw new Error("Field 'addonIds' must be an array");
  }
});var v1$3=/*#__PURE__*/Object.freeze({__proto__:null,createPlan:createPlan$1,getPlan:getPlan$2,getPlanDiskSpace:getPlanDiskSpace$1,getPlans:getPlans$2,updatePlanName:updatePlanName$1,updatePlanPackage:updatePlanPackage$1,updatePlanTerm:updatePlanTerm$1});class BandwidthChartData {
  constructor(s = {}) {
    this.labels = void 0;
    this.lines = void 0;
    this.yAxesUnits = void 0;
    this.labels = [], this.lines = [], this.yAxesUnits = [];
    const t = {
      GB: 1073741824,
      MB: 1048576,
      KB: 1024,
      B: 1
    };
    s.forEach((s, a) => {
      const e = {
          data: []
        },
        i = Math.max(...s.values.map(s => s.y));
      switch (!0) {
        case i > t.GB:
          this.yAxesUnits[a] = "GB";
          break;
        case i > t.MB:
          this.yAxesUnits[a] = "MB";
          break;
        case i > t.KB:
          this.yAxesUnits[a] = "KB";
          break;
        default:
          this.yAxesUnits[a] = "B";
      }
      s.values.forEach(s => {
        0 === a ? (e.label = "In", this.labels.push(dateFormat(s.x, "hh:mm a"))) : e.label = "Out", e.data.push(s.y / t[this.yAxesUnits[a]]);
      }), this.lines.push(e);
    });
  }
}class PhpFpmChartData {
  constructor(t = {}) {
    this.labels = void 0;
    this.lines = void 0;
    this.yAxesUnit = void 0;
    this.labels = [], this.lines = [], this.yAxesUnit = "", t.forEach(t => {
      const a = {
        data: []
      };
      t.values.forEach(t => {
        this.labels.push(dateFormat(t.x, "hh:mm a")), a.label = "Total Processes", a.data.push(t.y);
      }), this.lines.push(a);
    });
  }
}const getPlan$1 = new Definition("/service/{id}", "GET", t => new Plan(t.data)),
  getPlanBandwidthChart$1 = new Definition("/service/{id}.chart?options%5Bmetric%5D=bandwidth", "GET", t => new BandwidthChartData(t.data)),
  getPlanPhpFpmChart$1 = new Definition("/service/{id}.chart?options%5Bmetric%5D=phpfpm%3Atotal_processes", "GET", t => new PhpFpmChartData(t.data)),
  getPlans$1 = new Definition("/service?type=virt-guest-cloud&environment_type=production", "GET", t => ({
    list: t.data.map(t => Plan.formatLegacy(t)),
    pagination: new Pagination(t)
  }));var legacy$3=/*#__PURE__*/Object.freeze({__proto__:null,getPlan:getPlan$1,getPlanBandwidthChart:getPlanBandwidthChart$1,getPlanPhpFpmChart:getPlanPhpFpmChart$1,getPlans:getPlans$1});const getPlan = new GroupDefinition([getPlan$2, getPlan$1], (a, e) => {
  const {
      billing_info: t
    } = a.data,
    n = {
      ...e.data,
      billing_info: t,
      child_accounts: e.data.package?.child_accounts,
      primary_accounts: e.data.package?.primary_accounts,
      has_safe_harbor: e.data.has_safe_harbor
    };
  return n.package.name = e.data.package?.identity, new Plan(n);
});
const {
  getPlanBandwidthChart: getPlanBandwidthChart,
  getPlanPhpFpmChart: getPlanPhpFpmChart
} = legacy$3;
const {
  createPlan: createPlan,
  getPlans: getPlans,
  getPlanDiskSpace: getPlanDiskSpace,
  updatePlanName: updatePlanName,
  updatePlanTerm: updatePlanTerm,
  updatePlanPackage: updatePlanPackage
} = v1$3;var plans=/*#__PURE__*/Object.freeze({__proto__:null,createPlan:createPlan,getPlan:getPlan,getPlanBandwidthChart:getPlanBandwidthChart,getPlanDiskSpace:getPlanDiskSpace,getPlanPhpFpmChart:getPlanPhpFpmChart,getPlans:getPlans,updatePlanName:updatePlanName,updatePlanPackage:updatePlanPackage,updatePlanTerm:updatePlanTerm});const getResellerHost = new Definition("/service/{id}", "GET", e => new ResellerHost(e.data)),
  getResellerHosts = new Definition("/service?type=shared-reseller", "GET", e => ({
    list: e.data.map(e => new ResellerHost(e)),
    pagination: new Pagination(e)
  }));var resellerHosting=/*#__PURE__*/Object.freeze({__proto__:null,getResellerHost:getResellerHost,getResellerHosts:getResellerHosts});class Blacklist {
  constructor(t = {}) {
    this.date = void 0;
    this.id = void 0;
    this.ipAddress = void 0;
    this.location = void 0;
    this.date = t.time, this.id = t.id, this.ipAddress = t.location.ip, this.location = Blacklist.getLocation(t.location);
  }
  static getLocation(t = {}) {
    return t.region_name ? `${t.region_name}, ${t.country_name}` : t.country_name;
  }
}class MagentoPatch {
  constructor(a = {}) {
    this.date = void 0;
    this.download = void 0;
    this.name = void 0;
    this.url = void 0;
    this.date = a.date, this.download = a.download, this.name = a.name, this.url = a.url;
  }
}class MalwareScanHit {
  constructor(i = {}) {
    this.date = void 0;
    this.file = void 0;
    this.id = void 0;
    this.vulnerability = void 0;
    this.date = i.mtime, this.file = i.path, this.id = i.id, this.vulnerability = i.name;
  }
}const createSharedHostSafeHarborMigrationLead$1 = new Definition("/service/{id}", "POST", e => e.data, null, e => ({
  budget: e.budget,
  description: e.description,
  type: "Migration",
  _action: "lead"
}));
const isSafeHarborAllowed$1 = new Definition("/service/{id}/safe-harbor", "GET", e => {
  const t = Number(e.config.url.match(/\/service\/(.*)\/safe-harbor/)[1]);
  return {
    isAllowed: e.data.allow_safeharbor,
    serviceId: t
  };
});
const getSiteSafeHarborStagingServices$1 = new Definition("/service?type=virt-guest-cloud&environment_type=staging&ref_account_id={id}", "GET", e => {
  const t = Number(e.config.url.split("/service?type=virt-guest-cloud&environment_type=staging&ref_account_id=")[1]);
  return {
    list: e.data?.map(e => new Plan(e)) || [],
    siteId: t
  };
});
const getSharedHostSafeHarborMagentoPatches$1 = new Definition("/service/{id}/patches", "GET", e => {
  const t = Number(e.config.url.match(/\/service\/(.*)\/patches/)[1]);
  return {
    app: e.data.app,
    patches: e.data.patches.map(e => new MagentoPatch(e)),
    serviceId: t,
    version: e.data.version
  };
});
const getSharedHostSafeHarborMalwareScans$1 = new Definition("/service/{id}/malware", "GET", e => {
  const t = Number(e.config.url.match(/\/service\/(.*)\/malware/)[1]);
  return {
    hits: e.data.hits.map(e => new MalwareScanHit(e)),
    scannedFiles: e.data.scanned_files,
    serviceId: t
  };
});
const getSharedHostSafeHarborThreatProtection$1 = new Definition("/service/{id}/blacklist", "GET", e => {
  const t = Number(e.config.url.match(/\/service\/(.*)\/blacklist/)[1]);
  return {
    blacklist: e.data.map(e => new Blacklist(e)),
    serviceId: t
  };
});
const getSharedHostSafeHarborStagingServices$1 = new Definition("/service?type=virt-guest-cloud&environment_type=staging&ref_service_id={id}", "GET", e => {
  const t = Number(e.config.url.split("/service?type=virt-guest-cloud&environment_type=staging&ref_service_id=")[1]);
  return {
    list: e.data?.map(e => new Plan(e)) || [],
    serviceId: t
  };
});var legacy$2=/*#__PURE__*/Object.freeze({__proto__:null,createSharedHostSafeHarborMigrationLead:createSharedHostSafeHarborMigrationLead$1,getSharedHostSafeHarborMagentoPatches:getSharedHostSafeHarborMagentoPatches$1,getSharedHostSafeHarborMalwareScans:getSharedHostSafeHarborMalwareScans$1,getSharedHostSafeHarborStagingServices:getSharedHostSafeHarborStagingServices$1,getSharedHostSafeHarborThreatProtection:getSharedHostSafeHarborThreatProtection$1,getSiteSafeHarborStagingServices:getSiteSafeHarborStagingServices$1,isSafeHarborAllowed:isSafeHarborAllowed$1});const createSiteSafeHarborDevelopmentLead$1 = new Definition("/api/v1/site/{id}/app/lead", "POST", e => e.data, null, e => ({
  budget: e.budget,
  description: e.description,
  type: "DevelopmentWork"
}));
const createSiteSafeHarborMigrationLead$1 = new Definition("/api/v1/site/{id}/app/lead", "POST", e => e.data, null, e => ({
  budget: e.budget,
  description: e.description,
  type: "Migration"
}));
const getSafeHarborPackageByLabel$1 = new Definition("/api/v1/package/dev-site?filter[label]={label}", "GET", e => {
  const a = e.data[0];
  return {
    id: a.id,
    identity: a.identity,
    label: a.label,
    monthlyFee: a.monthly_fee,
    type: a.type
  };
});
const getSiteSafeHarborInfo$1 = new Definition("/api/v1/site/{siteId}/app/safe-harbor", "GET", e => ({
  isAllowed: e.data.safe_harbor_eligible,
  isEnabled: e.data.safe_harbor_enrolled,
  siteId: e.data.site.id
}));
const getSiteSafeHarborMagentoPatches$1 = new Definition("/api/v1/site/{siteId}/app/patches", "GET", e => ({
  app: e.data?.patches?.app,
  patches: e.data?.patches?.patches?.map(e => new MagentoPatch(e)),
  siteId: e.data?.site?.id,
  version: e.data?.patches?.version
}));
const getSiteSafeHarborMalwareScans$1 = new Definition("/api/v1/site/{siteId}/app/malware-scan", "GET", e => ({
  hits: e.data.malware_scan_results.hits.map(e => new MalwareScanHit(e)),
  scannedFiles: e.data.malware_scan_results.scanned_files,
  siteId: e.data?.site?.id
}));
const getSiteSafeHarborThreatProtection$1 = new Definition("/api/v1/site/{siteId}/app/ip-blacklist", "GET", e => ({
  blacklist: e.data.ip_blacklist.map(e => new Blacklist(e)),
  siteId: e.data?.site?.id
}));
const purchaseSafeHarbor$1 = new Definition("/api/v1/service/{serviceId}/addon", "POST", e => e.data, null, e => ({
  addon_id: e.addonId
}));
const removeSafeHarbor$1 = new Definition("/api/v1/service/{serviceId}/addon/{addonId}", "DELETE", e => e.data, null, e => e.stagingAction ? {
  options: {
    staging: e.stagingAction
  }
} : null);var v1$2=/*#__PURE__*/Object.freeze({__proto__:null,createSiteSafeHarborDevelopmentLead:createSiteSafeHarborDevelopmentLead$1,createSiteSafeHarborMigrationLead:createSiteSafeHarborMigrationLead$1,getSafeHarborPackageByLabel:getSafeHarborPackageByLabel$1,getSiteSafeHarborInfo:getSiteSafeHarborInfo$1,getSiteSafeHarborMagentoPatches:getSiteSafeHarborMagentoPatches$1,getSiteSafeHarborMalwareScans:getSiteSafeHarborMalwareScans$1,getSiteSafeHarborThreatProtection:getSiteSafeHarborThreatProtection$1,purchaseSafeHarbor:purchaseSafeHarbor$1,removeSafeHarbor:removeSafeHarbor$1});const {
  createSharedHostSafeHarborMigrationLead: createSharedHostSafeHarborMigrationLead,
  getSiteSafeHarborStagingServices: getSiteSafeHarborStagingServices,
  getSharedHostSafeHarborMagentoPatches: getSharedHostSafeHarborMagentoPatches,
  getSharedHostSafeHarborMalwareScans: getSharedHostSafeHarborMalwareScans,
  getSharedHostSafeHarborThreatProtection: getSharedHostSafeHarborThreatProtection,
  getSharedHostSafeHarborStagingServices: getSharedHostSafeHarborStagingServices,
  isSafeHarborAllowed: isSafeHarborAllowed
} = legacy$2;
const {
  createSiteSafeHarborDevelopmentLead: createSiteSafeHarborDevelopmentLead,
  createSiteSafeHarborMigrationLead: createSiteSafeHarborMigrationLead,
  getSafeHarborPackageByLabel: getSafeHarborPackageByLabel,
  getSiteSafeHarborInfo: getSiteSafeHarborInfo,
  getSiteSafeHarborMagentoPatches: getSiteSafeHarborMagentoPatches,
  getSiteSafeHarborMalwareScans: getSiteSafeHarborMalwareScans,
  getSiteSafeHarborThreatProtection: getSiteSafeHarborThreatProtection,
  purchaseSafeHarbor: purchaseSafeHarbor,
  removeSafeHarbor: removeSafeHarbor
} = v1$2;var safeHarbor=/*#__PURE__*/Object.freeze({__proto__:null,createSharedHostSafeHarborMigrationLead:createSharedHostSafeHarborMigrationLead,createSiteSafeHarborDevelopmentLead:createSiteSafeHarborDevelopmentLead,createSiteSafeHarborMigrationLead:createSiteSafeHarborMigrationLead,getSafeHarborPackageByLabel:getSafeHarborPackageByLabel,getSharedHostSafeHarborMagentoPatches:getSharedHostSafeHarborMagentoPatches,getSharedHostSafeHarborMalwareScans:getSharedHostSafeHarborMalwareScans,getSharedHostSafeHarborStagingServices:getSharedHostSafeHarborStagingServices,getSharedHostSafeHarborThreatProtection:getSharedHostSafeHarborThreatProtection,getSiteSafeHarborInfo:getSiteSafeHarborInfo,getSiteSafeHarborMagentoPatches:getSiteSafeHarborMagentoPatches,getSiteSafeHarborMalwareScans:getSiteSafeHarborMalwareScans,getSiteSafeHarborStagingServices:getSiteSafeHarborStagingServices,getSiteSafeHarborThreatProtection:getSiteSafeHarborThreatProtection,isSafeHarborAllowed:isSafeHarborAllowed,purchaseSafeHarbor:purchaseSafeHarbor,removeSafeHarbor:removeSafeHarbor});class Settings {
  constructor(a = {}) {
    this.loginCaptchaEnabled = void 0;
    this.signUpCaptchaEnabled = void 0;
    this.loginCaptchaEnabled = a?.captcha_enabled?.login, this.signUpCaptchaEnabled = a?.captcha_enabled?.register;
  }
}class CannySettings {
  constructor(t = {}) {
    this.appId = void 0;
    this.boards = void 0;
    this.token = void 0;
    this.appId = t?.app_id, this.boards = t?.boards, this.token = t?.token;
  }
}const getSettings = new Definition("/api/v1/company/settings", "GET", t => new Settings(t.data)),
  getCannySettings = new Definition("/feedback", "GET", t => new CannySettings(t.data));var settings=/*#__PURE__*/Object.freeze({__proto__:null,getCannySettings:getCannySettings,getSettings:getSettings});class CancellationFormOptions {
  constructor(e = {}) {
    this.form = void 0;
    this.identity = void 0;
    this.scheduled_date = void 0;
    this.service = void 0;
    this.form = e.form, this.identity = e.identity, this.service = e.service, this.scheduled_date = new Date(1e3 * e.scheduled_date).toLocaleDateString(void 0, {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  }
}class ClientEvent {
  constructor(t = {}) {
    this.action = void 0;
    this.classId = void 0;
    this.date = void 0;
    this.formattedDate = void 0;
    this.object = void 0;
    this.scope = void 0;
    this.user = void 0;
    this.action = t.action, this.classId = t.class_id, this.date = t.event_date, this.object = t.object, this.scope = t.scope, this.user = new User(t), this.formattedDate = dateFormat(t.event_date);
  }
}class NewRelicAccount {
  constructor(t = {}) {
    this.id = void 0;
    this.timestamp = void 0;
    this.token = void 0;
    this.url = void 0;
    this.id = t.id, this.timestamp = t.timestamp, this.token = t.token, this.url = t.url;
  }
}class ReverseDnsRecord {
  constructor(t = {}) {
    this.host = void 0;
    this.id = void 0;
    this.target = void 0;
    this.ttl = void 0;
    this.type = void 0;
    this.zone = void 0;
    this.host = t.host, this.id = t.id, this.target = t.target, this.ttl = t.ttl, this.type = t.type, this.zone = new DnsZone(t.zone);
  }
}const addRdnsRecord$1 = new Definition("/dns-reverse", "POST", e => e.data, null, e => ({
  host: e.ipAddress,
  target: e.hostname,
  ttl: e.ttl,
  type: "PTR"
}));
const cancelService = new Definition("/service-cancellation/add", "POST", e => e.data);
const disableEdgecastApac = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "disable-apac"
}));
const disableEdgecastSharedSsl = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "disable-shared-ssl"
}));
const disableNetworking = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "disable"
}));
const enableEdgecastApac = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "enable-apac"
}));
const enableEdgecastSharedSsl = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "enable-shared-ssl"
}));
const enableNetworking = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "enable"
}));
const getCancellationFormOptions = new Definition("/service-cancellation/new?service_id={id}", "GET", e => new CancellationFormOptions(e.data));
const getCdnControlPanel = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "cdn-account"
}));
const getConsoleLog = new Definition("service/{id}", "POST", e => e.data, null, () => ({
  _action: "console-log"
}));
const getHistory = new Definition("service/{id}/history", "get", e => e.data.map(e => new ClientEvent(e)));
const getNewRelicAccount = new Definition("/service/{id}", "POST", e => new NewRelicAccount(e.data), null, () => ({
  _action: "newrelic-account"
}));
const getReverseDnsByIp = new Definition("/dns-reverse/0", "GET", e => new ReverseDnsRecord(e.data));
const getReverseDnsDefault = new Definition("/dns-reverse/new", "GET", e => new ReverseDnsRecord(e.data));
const getReverseDnsIps = new Definition("/dns-reverse/get-rdns-ips", "GET", e => e.data.map(e => e.identity));
const hardReboot = new Definition("service/{id}", "post", e => e.data, null, () => ({
  _action: "reboot",
  force: !0
}));
const purgeCache = new Definition("/service/{id}", "POST", e => e.data, null, () => ({
  _action: "purge-cache"
}));
const restoreService = new Definition("/service-cancellation/{id}", "DELETE", e => e.data);
const startServer = new Definition("service/{id}", "post", e => new Service(e.data), null, () => ({
  _action: "start"
}));
const softReboot = new Definition("service/{id}", "post", e => e.data, null, () => ({
  _action: "reboot"
}));
const stopServer = new Definition("service/{id}", "post", e => new Service(e.data), null, () => ({
  _action: "stop"
}));
const updateReverseDns$1 = new Definition("/dns-reverse/{id}", "POST", e => new ReverseDnsRecord(e.data));
const updateRdnsRecord = new Definition("/dns-reverse/{recordId}", "PATCH", e => e.data, null, e => ({
  host: e.ipAddress,
  target: e.hostname,
  ttl: e.ttl,
  type: "PTR"
}));var service$1=/*#__PURE__*/Object.freeze({__proto__:null,addRdnsRecord:addRdnsRecord$1,cancelService:cancelService,disableEdgecastApac:disableEdgecastApac,disableEdgecastSharedSsl:disableEdgecastSharedSsl,disableNetworking:disableNetworking,enableEdgecastApac:enableEdgecastApac,enableEdgecastSharedSsl:enableEdgecastSharedSsl,enableNetworking:enableNetworking,getCancellationFormOptions:getCancellationFormOptions,getCdnControlPanel:getCdnControlPanel,getConsoleLog:getConsoleLog,getHistory:getHistory,getNewRelicAccount:getNewRelicAccount,getReverseDnsByIp:getReverseDnsByIp,getReverseDnsDefault:getReverseDnsDefault,getReverseDnsIps:getReverseDnsIps,hardReboot:hardReboot,purgeCache:purgeCache,restoreService:restoreService,softReboot:softReboot,startServer:startServer,stopServer:stopServer,updateRdnsRecord:updateRdnsRecord,updateReverseDns:updateReverseDns$1});class SharedHost extends Service {
  constructor(t = {}) {
    (super(t), this.autoRenew = void 0, this.addons = void 0, this.bandwidth = void 0, this.domain = void 0, this.hostname = void 0, this.ip = void 0), this.addons = t.addons?.map(({
      identity: t,
      qty: e,
      term_price_total: i
    }) => ({
      name: t,
      quantity: e,
      price: i
    })), this.autoRenew = t.auto_renew, this.bandwidth = {
      allotted: t.bandwidth?.given,
      lastPeriod: t.bandwidth?.previous,
      projected: t.bandwidth?.projected,
      units: t.bandwidth?.type,
      used: t.bandwidth?.used?.billable
    }, this.domain = t.domain, this.hostname = t.host?.hostname, this.ip = t.main_ip?.identity;
  }
}const createSharedHostSafeHarborDevelopmentLead = new Definition("/service/{id}", "POST", e => e.data, null, e => ({
  budget: e.budget,
  description: e.description,
  type: "DevelopmentWork",
  _action: "lead"
}));
const getSharedHost = new Definition("/service/{id}", "GET", e => new SharedHost(e.data));
const getSharedHosts = new Definition("/service?type=shared", "GET", e => ({
  list: e.data.map(e => new SharedHost(e)),
  pagination: new Pagination(e)
}));var sharedHosts=/*#__PURE__*/Object.freeze({__proto__:null,createSharedHostSafeHarborDevelopmentLead:createSharedHostSafeHarborDevelopmentLead,getSharedHost:getSharedHost,getSharedHosts:getSharedHosts});class AutoScaleUsage {
  constructor(e = {}) {
    this.billableCost = void 0;
    this.billableUsed = void 0;
    this.minutesGraceEnd = void 0;
    this.billableCost = e.billable_cost, this.billableUsed = e.billable_used, this.minutesGraceEnd = e.minutes_grace.end;
  }
}const getSiteAutoScaleUsage$2 = new Definition("/api/v1/site/{id}/autoscale-usage", "GET", e => new AutoScaleUsage(e.data));var autoScale=/*#__PURE__*/Object.freeze({__proto__:null,getSiteAutoScaleUsage:getSiteAutoScaleUsage$2});let AdvancedAutoScale$1=class AdvancedAutoScale {
  constructor(a = {}) {
    this.addon = void 0;
    this.enabled = void 0;
    this.site = void 0;
    this.usage = void 0;
    this.addon = {
      baseQuantity: {
        containers: a.addon?.base_quantity?.containers,
        workersPerContainer: a.addon?.base_quantity?.workers_per_container
      },
      quantity: {
        containers: a.addon?.quantity?.containers,
        workersPerContainer: a.addon?.quantity?.workers_per_container
      }
    }, this.enabled = a.enabled, this.site = {
      id: a.site?.id
    }, this.usage = {
      additionalHoursPrice: a.usage?.additional_hours_price,
      additionalHoursUsed: a.usage?.additional_hours_used,
      baseCost: a.usage?.base_cost,
      cost: a.usage?.cost
    };
  }
};class AdvancedAutoScalePackage {
  constructor(i = {}) {
    this.baseQuantity = void 0;
    this.id = void 0;
    this.identity = void 0;
    this.site = void 0;
    this.pricing = void 0;
    this.baseQuantity = {
      containers: i.base_quantity?.containers,
      workersPerContainer: i.base_quantity?.workers_per_container
    }, this.id = i.id, this.identity = i.identity, this.site = {
      id: i.site?.id
    }, this.pricing = {
      base: i.pricing?.base,
      additionalHours: i.pricing?.additional_hours
    };
  }
}const enableSiteAdvancedAutoScale$3 = new Definition("/api/v1/site/{id}/advanced-autoscale", "POST", e => e.data, null, e => ({
  addon_id: e.addonId,
  version: e.version,
  scale: e.scale,
  __free: e.free
}));
const disableSiteAdvancedAutoScale$2 = new Definition("/api/v1/site/{id}/advanced-autoscale", "DELETE", e => e.data);
const getSiteAdvancedAutoScale$2 = new Definition("/api/v1/site/{id}/advanced-autoscale/status", "GET", e => new AdvancedAutoScale$1(e.data));
const getSiteAdvancedAutoScalePackages$2 = new Definition("/api/v1/site/{id}/advanced-autoscale", "GET", e => e.data.map(e => new AdvancedAutoScalePackage(e)));
const updateSiteAdvancedAutoScale$2 = new Definition("/api/v1/site/{id}/advanced-autoscale", "POST", e => e.data, null, e => ({
  scale: e.scale
}));var advancedAutoScale=/*#__PURE__*/Object.freeze({__proto__:null,disableSiteAdvancedAutoScale:disableSiteAdvancedAutoScale$2,enableSiteAdvancedAutoScale:enableSiteAdvancedAutoScale$3,getSiteAdvancedAutoScale:getSiteAdvancedAutoScale$2,getSiteAdvancedAutoScalePackages:getSiteAdvancedAutoScalePackages$2,updateSiteAdvancedAutoScale:updateSiteAdvancedAutoScale$2});const getSiteAccessLogMetrics$2 = new Definition("/api/v1/site/{URL_CLOUDACCOUNT}/apm/log/web-access?start={URL_START}&end={URL_END}&page={URL_PAGE}", "GET", e => {
  if (!e) throw new Error("Problem parsing bandwidth response");
  let r = {
    ...e.data
  };
  return r = r.lines.map(e => {
    const r = e.message.replace(/,/g, ""),
      [t, s] = r.split(/ - (.+)/),
      [i, o] = s.split(/] "(.+)/),
      a = o.replace(/\/ /, "").replace(/\//g, " ").replace(/"-" /, "").replace(/"/g, "").split(" ");
    return {
      ...e,
      date: new Date(e.timestamp),
      ips: t.split(" "),
      method: a[0],
      protocol_type: a[1],
      protocol_version: a[2],
      status: a[3],
      curl_version: a[6],
      messageParsed: {
        ips: t.split(" "),
        timestamp: i.replace("[", ""),
        http: {
          method: a[0],
          protocol: {
            type: a[1],
            version: a[2]
          },
          status: a[3],
          curl: {
            version: a[6]
          }
        }
      }
    };
  }), r;
}, null, null, e => {
  if (!e.URL_CLOUDACCOUNT) throw new Error("Request requires cloud account id for URL_CLOUDACCOUNT");
  if (!e.URL_START) throw new Error("Request requires start");
  if (!e.URL_END) throw new Error("Request requires start");
  if (!e.URL_PAGE) throw new Error("Request requires start");
});
const getSiteBandwidthMetrics$2 = new Definition("/api/v1/site/{URL_CLOUDACCOUNT}/apm/bandwidth/chart?start={URL_START}&end={URL_END}", "GET", e => {
  if (!e) throw new Error("Problem parsing bandwidth response");
  const r = e?.data?.[0]?.values.map(e => ({
      date: new Date(1e3 * e.x),
      value: e.y
    })),
    t = e?.data?.[1]?.values.map(e => ({
      date: new Date(1e3 * e.x),
      value: e.y
    }));
  return {
    in: r,
    out: t
  };
}, null, null, e => {
  if (!e.URL_CLOUDACCOUNT) throw new Error("Request requires cloud account id for URL_CLOUDACCOUNT");
  if (!e.URL_START) throw new Error("Request requires start");
  if (!e.URL_END) throw new Error("Request requires start");
});var apm=/*#__PURE__*/Object.freeze({__proto__:null,getSiteAccessLogMetrics:getSiteAccessLogMetrics$2,getSiteBandwidthMetrics:getSiteBandwidthMetrics$2});const getSiteBackups$2 = new Definition("/api/v1/site/{siteId}/backup", "GET", e => e.data.backups.map(e => new Backup(e)));
const getSiteBackupDatabases$2 = new Definition({
  path: "/api/v1/site/{siteId}/backup/{backupId}/database",
  method: "GET",
  responseBody: e => e.data.databases
});
const getSiteDailyBackups$2 = new Definition({
  path: "/api/v1/site/{siteId}/backup/daily",
  method: "GET",
  responseBody: e => e.data.backups.map(e => new DailyBackup(e))
});
const restoreSiteDailyBackup$2 = new Definition("/api/v1/site/{siteId}/backup/daily/restore-request", "POST", e => e.data, null, e => ({
  restore_point: e.filedateIso
}));
const restoreSiteDailyBackupDatabases$2 = new Definition({
  path: "/api/v1/site/{siteId}/backup/{backupId}/restore",
  method: "POST",
  responseBody: e => e.data,
  requestBody: ({
    databases: e
  }) => ({
    db: {
      databases: e
    }
  })
});
const restoreSiteDailyBackupFullFiles$2 = new Definition({
  path: "/api/v1/site/{siteId}/backup/{backupId}/restore",
  method: "POST",
  responseBody: e => e.data,
  requestBody: () => ({
    files: {
      full: !0
    }
  })
});
const restoreSiteDailyBackupFullFilesAndDatabases$2 = new Definition({
  path: "/api/v1/site/{siteId}/backup/{backupId}/restore",
  method: "POST",
  responseBody: e => e.data,
  requestBody: ({
    databases: e
  }) => ({
    files: {
      full: !0
    },
    db: {
      databases: e
    }
  })
});
const getLastSiteDailyBackupRestore$2 = new Definition({
  path: "/api/v1/site/{siteId}/backup/restore/last",
  method: "GET",
  responseBody: e => new BackupRestore(e.data)
});var backups=/*#__PURE__*/Object.freeze({__proto__:null,getLastSiteDailyBackupRestore:getLastSiteDailyBackupRestore$2,getSiteBackupDatabases:getSiteBackupDatabases$2,getSiteBackups:getSiteBackups$2,getSiteDailyBackups:getSiteDailyBackups$2,restoreSiteDailyBackup:restoreSiteDailyBackup$2,restoreSiteDailyBackupDatabases:restoreSiteDailyBackupDatabases$2,restoreSiteDailyBackupFullFiles:restoreSiteDailyBackupFullFiles$2,restoreSiteDailyBackupFullFilesAndDatabases:restoreSiteDailyBackupFullFilesAndDatabases$2});const getSiteBandwidthChart$2 = new Definition({
  path: "/api/v1/site/{id}/apm/php/chart?options%5Bmetric%5D=bandwidth",
  method: "GET",
  responseBody: t => new BandwidthChartData(t.data)
});var bandwidth=/*#__PURE__*/Object.freeze({__proto__:null,getSiteBandwidthChart:getSiteBandwidthChart$2});const purgeSiteCache$2 = new Definition("/api/v1/site/{id}/purge-caches", "POST", i => i.data);var cache=/*#__PURE__*/Object.freeze({__proto__:null,purgeSiteCache:purgeSiteCache$2});const enableSiteCdn$2 = new Definition("/api/v1/site/{siteId}/cdn/enable", "POST", i => i.data);
const getSiteCdn$2 = new Definition("/api/v1/site/{id}/cdn", "GET", i => i.data);
const getSiteCdnUsage$2 = new Definition("/api/v1/site/{id}/eadn/usage", "GET", i => i.data);
const getSiteEadn$2 = new Definition("/api/v1/site/{id}/eadn", "GET", i => i.data);
const getSiteEadnOrigins$2 = new Definition("/api/v1/eadn/{id}/origin", "GET", i => i.data);
const getSiteEadnOriginUris$2 = new Definition("/api/v1/eadn/{account_id}/origin/{origin_id}/uri", "GET", i => i.data);
const purgeSiteCdn$2 = new Definition("/api/v1/site/{siteId}/cdn/purge", "POST", i => i.data);var cdn=/*#__PURE__*/Object.freeze({__proto__:null,enableSiteCdn:enableSiteCdn$2,getSiteCdn:getSiteCdn$2,getSiteCdnUsage:getSiteCdnUsage$2,getSiteEadn:getSiteEadn$2,getSiteEadnOriginUris:getSiteEadnOriginUris$2,getSiteEadnOrigins:getSiteEadnOrigins$2,purgeSiteCdn:purgeSiteCdn$2});const addSiteCloudflare$2 = new Definition("/api/v1/site/{siteId}/cloudflare/{addonId}", "POST", e => e.data);
const getSiteCloudflareAddons$2 = new Definition({
  path: "/api/v1/package/addon/cloudflare",
  method: "GET",
  responseBody: e => e.data.map(({
    configuration: e,
    id: t,
    identity: a,
    description: o,
    label: d,
    monthly_fee: i,
    name: n
  }) => ({
    configuration: {
      allowedTransferGBPerMonth: e?.allowed_monthly_data_transfer_gb,
      allowedMonthlyRequestsPerTb: e?.allowed_monthly_requests_per_tb,
      overageCostPerMonth: e?.overage_cost_per_gb
    },
    id: t,
    identity: a,
    description: o,
    label: d,
    monthlyFee: i,
    name: n
  }))
});
const getSiteCloudflareDetails$2 = new Definition({
  path: "/api/v1/site/{siteId}/cloudflare",
  method: "GET",
  responseBody: e => ({
    addon: {
      configuration: {
        allowedTransferGBPerMonth: e.data?.addon?.configuration?.allowed_monthly_data_transfer_gb,
        allowedMonthlyRequestsPerTb: e.data?.addon?.configuration?.allowed_monthly_requests_per_tb,
        overageCostPerMonth: e.data?.addon?.configuration?.overage_cost_per_gb
      },
      id: e.data?.addon?.id,
      identity: e.data?.addon?.identity,
      description: e.data?.addon?.description,
      label: e.data?.addon?.label,
      monthlyFee: e.data?.addon?.monthly_fee,
      name: e.data?.addon?.name,
      type: e.data?.addon?.type
    },
    autoRenew: e.data?.autorenew,
    settings: {
      securityLevel: e.data?.settings?.security_level || "medium"
    },
    startDate: e.data?.start_date
  })
});
const getSiteCloudflareEligible$2 = new Definition({
  path: "/api/v1/site/{siteId}/cloudflare/eligible",
  method: "GET",
  responseBody: e => ({
    eligible: e.data.is_domain_eligible,
    hasNameServersConfigured: e.data.has_nexcess_ns,
    hasClientDomain: e.data.has_client_domain,
    canActivate: e.data.can_add_cloudflare
  })
});
const removeSiteCloudflare$2 = new Definition("/api/v1/site/{siteId}/cloudflare", "DELETE", e => e.data);
const updateSiteCloudflareSecurityLevel$2 = new Definition({
  path: "/api/v1/site/{siteId}/cloudflare/security-level",
  method: "POST",
  requestBody: ({
    level: e
  }) => ({
    action: e
  }),
  responseBody: ({
    data: e
  }) => e
});var cloudflare=/*#__PURE__*/Object.freeze({__proto__:null,addSiteCloudflare:addSiteCloudflare$2,getSiteCloudflareAddons:getSiteCloudflareAddons$2,getSiteCloudflareDetails:getSiteCloudflareDetails$2,getSiteCloudflareEligible:getSiteCloudflareEligible$2,removeSiteCloudflare:removeSiteCloudflare$2,updateSiteCloudflareSecurityLevel:updateSiteCloudflareSecurityLevel$2});class ContainerType {
  constructor(i = {}) {
    this.id = void 0;
    this.cpus = void 0;
    this.disk = void 0;
    this.memory = void 0;
    this.type = void 0;
    this.description = void 0;
    this.name = void 0;
    this.monthlyFee = void 0;
    this.size = void 0;
    this.id = i.id, this.cpus = i.configuration.cpu, this.disk = Number(i?.configuration?.disk?.replace(/g/g, "")), this.memory = Number(i?.configuration?.memory?.replace(/g/g, "")), this.type = i.configuration.service, this.description = i.description, this.monthlyFee = i.monthly_fee, this.name = i.name, this.size = i.name.split("-").pop();
  }
}const getSiteContainers$2 = new Definition("/api/v1/site/{id}/container", "GET", n => n.data.map(n => new Container(n)));
const getSiteContainerTypes$2 = new Definition("/api/v1/package/addon/container", "GET", n => n.data.map(n => new ContainerType(n)));var container=/*#__PURE__*/Object.freeze({__proto__:null,getSiteContainerTypes:getSiteContainerTypes$2,getSiteContainers:getSiteContainers$2});class EmailResponder {
  constructor(e = {}) {
    this.ccEmailAddress = void 0;
    this.message = void 0;
    this.username = void 0;
    this.email = void 0;
    this.ccEmailAddress = e.copyto, this.message = e.message, this.username = e.username, this.email = e.email;
  }
}const createSiteEmailBox$2 = new Definition({
  path: "/api/v1/site/{siteId}/email",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => ({
    username: e.username,
    quota: e.storage
  })
});
const disableLocalMailDelivery$2 = new Definition("/api/v1/site/{siteId}/local-email-delivery/disable", "POST", e => e.data.enabled);
const enableLocalMailDelivery$2 = new Definition({
  path: "/api/v1/site/{siteId}/local-email-delivery/enable",
  method: "POST",
  responseBody: e => e.data.enabled
});
const getLocalMailDeliveryInfo$2 = new Definition("/api/v1/site/{siteId}/local-email-delivery?domain={domain}", "GET", e => e.data.enabled);
const createSiteEmailResponders$2 = new Definition({
  path: "/api/v1/site/{siteId}/email/autoresponder",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => {
    if (!e.response || "string" != typeof e.response) throw new Error("'response' is required and must be a string to create site email auto responder.");
    if (!e.username || "string" != typeof e.username) throw new Error("'username' is required and must be a string to create site email auto responder.");
    if (e.copyto && !Array.isArray(e.copyto)) throw new Error("'copyto' is required and must be an array of  to create site email auto responder.");
    return {
      response: e.response,
      username: e.username,
      copyto: e.copyto
    };
  }
});
const updateSiteEmailResponders$2 = new Definition({
  path: "/api/v1/site/{siteId}/email/autoresponder/{username}",
  method: "POST",
  responseBody: e => e.data,
  requestBody: e => {
    if (!e.response || "string" != typeof e.response) throw new Error("'response' is required and must be a string to create site email auto responder.");
    if (e.copyto && !Array.isArray(e.copyto)) throw new Error("'copyto' is required and must be an array of  to create site email auto responder.");
    return {
      response: e.response,
      copyto: e.copyto
    };
  }
});
const getSiteEmailResponders$2 = new Definition({
  path: "/api/v1/site/{siteId}/email/autoresponder",
  method: "GET",
  responseBody: e => ({
    list: e.data.autoresponders.map(e => new EmailResponder(e)),
    pagination: new Pagination(e)
  })
});
const deleteSiteEmailResponders$2 = new Definition({
  path: "/api/v1/site/{siteId}/email/autoresponder/{username}",
  method: "DELETE",
  responseBody: e => e.data.enabled
});var email$1=/*#__PURE__*/Object.freeze({__proto__:null,createSiteEmailBox:createSiteEmailBox$2,createSiteEmailResponders:createSiteEmailResponders$2,deleteSiteEmailResponders:deleteSiteEmailResponders$2,disableLocalMailDelivery:disableLocalMailDelivery$2,enableLocalMailDelivery:enableLocalMailDelivery$2,getLocalMailDeliveryInfo:getLocalMailDeliveryInfo$2,getSiteEmailResponders:getSiteEmailResponders$2,updateSiteEmailResponders:updateSiteEmailResponders$2});class FTPUser {
  constructor(s = {}) {
    this.homeDir = void 0;
    this.uuid = void 0;
    this.user = void 0;
    this.username = void 0;
    this.hostname = void 0;
    this.homeDir = s.homedir, this.uuid = s.password_share?.metadata?.uri?.match(/\/v1\/datashare\/(.*)/)[1] || null, this.user = s.fulluser, this.username = s.username, this.hostname = s.hostname;
  }
}const getSiteFtpUsers$2 = new Definition({
  path: "/api/v1/site/{id}/ftp",
  method: "GET",
  responseBody: e => {
    const t = Number(e.config.url.match(/api\/v1\/site\/(.*)\/ftp/)[1]);
    return {
      list: Object.entries(e.data).map(e => new FTPUser(e[1])),
      siteId: t
    };
  }
});var ftp=/*#__PURE__*/Object.freeze({__proto__:null,getSiteFtpUsers:getSiteFtpUsers$2});const getSiteLogs$2 = new Definition("/api/v1/site/{siteId}/log", "GET", i => ({
  list: i.data.map(i => new Log(i)),
  pagination: new Pagination(i)
}));var logs=/*#__PURE__*/Object.freeze({__proto__:null,getSiteLogs:getSiteLogs$2});class AdvancedAutoScale {
  constructor(e = {}) {
    this.enabled = void 0;
    this.key = void 0;
    this.site = void 0;
    this.enabled = e.enabled, this.site = {
      id: e.site?.id
    }, this.key = e.key;
  }
}const enableSiteNewRelic$2 = new Definition("/api/v1/site/{id}/newrelic-license", "POST", e => e.data, null, e => ({
  key: e.key
}));
const disableSiteNewRelic$2 = new Definition("/api/v1/site/{id}/newrelic-license", "DELETE", e => e.data);
const getSiteNewRelic$2 = new Definition("/api/v1/site/{id}/newrelic", "GET", e => new AdvancedAutoScale(e.data));var newRelic=/*#__PURE__*/Object.freeze({__proto__:null,disableSiteNewRelic:disableSiteNewRelic$2,enableSiteNewRelic:enableSiteNewRelic$2,getSiteNewRelic:getSiteNewRelic$2});class PasswordProtection {
  constructor(a = {}) {
    this.dataShare = void 0;
    this.enabled = void 0;
    this.siteId = void 0;
    this.dataShare = {
      id: a.data_share?.id,
      uuid: a.data_share?.metadata?.uri?.match(/\/v1\/datashare\/(.*)/)[1],
      type: a.data_share?.type
    }, this.enabled = a.enabled, this.siteId = a.site?.id;
  }
}const enableSitePasswordProtection$2 = new Definition("/api/v1/site/{id}/password-protection/enable", "POST", () => null);
const disableSitePasswordProtection$2 = new Definition("/api/v1/site/{id}/password-protection/disable", "POST", () => null);
const getSitePasswordProtection$2 = new Definition("/api/v1/site/{id}/password-protection", "GET", o => new PasswordProtection(o.data));var passwordProtection=/*#__PURE__*/Object.freeze({__proto__:null,disableSitePasswordProtection:disableSitePasswordProtection$2,enableSitePasswordProtection:enableSitePasswordProtection$2,getSitePasswordProtection:getSitePasswordProtection$2});const getSitePhpCompatibilityCheck$2 = new Definition("/api/v1/site/{id}/app/compatibility-check/last", "GET", t => new PhpCompatibilityCheck(t.data));
const getSitePhpFpmChart$2 = new Definition({
  path: "/api/v1/site/{id}/apm/php/chart?options%5Bmetric%5D=phpfpm%3Atotal_processes",
  method: "GET",
  responseBody: t => new PhpFpmChartData(t.data)
});
const getSitePhpMetrics$2 = new Definition("/api/v1/site/{URL_CLOUDACCOUNT}/apm/php/chart?start={URL_START}&end={URL_END}", "GET", t => {
  if (!t) throw new Error("Problem parsing php response");
  const e = t?.data?.[0]?.values.map(t => ({
    date: new Date(1e3 * t.x),
    value: t.y
  }));
  return e;
}, null, null, t => {
  if (!t.URL_CLOUDACCOUNT) throw new Error("Request requires cloud account id for URL_CLOUDACCOUNT");
  if (!t.URL_START) throw new Error("Request requires start");
  if (!t.URL_END) throw new Error("Request requires start");
});
const updateSitePhpVersion$2 = new Definition("/api/v1/site/{id}/php-version", "POST", t => t.data, null, t => ({
  php_version: t.version,
  skip_compatibility_check: !t.checkCompatibility
}));
const cancelPhpVersionChange$2 = new Definition("/api/v1/site/{id}/app/compatibility-check/clear", "POST", t => t.data);var php=/*#__PURE__*/Object.freeze({__proto__:null,cancelPhpVersionChange:cancelPhpVersionChange$2,getSitePhpCompatibilityCheck:getSitePhpCompatibilityCheck$2,getSitePhpFpmChart:getSitePhpFpmChart$2,getSitePhpMetrics:getSitePhpMetrics$2,updateSitePhpVersion:updateSitePhpVersion$2});const getDevSites$2 = new Definition({
  path: "/api/v1/site?filter[reference_site_id]={parentSiteId}",
  method: "GET",
  responseBody: e => {
    const t = Number(e.config.url.split("/api/v1/site?filter[reference_site_id]=")[1]);
    return {
      list: e.data.map(e => new Site(e)),
      pagination: new Pagination(e),
      siteId: t
    };
  },
  transformParams: e => transformSortParamsToV1(e)
});
const getSite$2 = new Definition({
  path: "/api/v1/site/{id}",
  method: "GET",
  responseBody: e => new Site(e.data)
});
const getSitePermissions$2 = new Definition({
  mocked: !0,
  path: "/api/v1/site/{id}/permissions",
  method: "GET",
  mockedResponse: {
    visualComparison: {
      allowed: !0
    }
  }
});
const getSites$2 = new Definition({
  path: "/api/v1/site",
  method: "GET",
  responseBody: e => ({
    list: e.data.map(e => new Site(e)),
    pagination: new Pagination(e)
  }),
  transformParams: e => transformSortParamsToV1(e)
});
const getSitesByServiceId$2 = new Definition({
  path: "/api/v1/site/domains?filter[service_id]={serviceId}",
  method: "GET",
  responseBody: e => e.data?.map(e => ({
    domain: e?.client_domain || e?.site?.identity,
    id: e?.site?.id
  }))
});
const searchSites$2 = new Definition({
  path: "/api/v1/site",
  method: "GET",
  transformParams: e => {
    const t = {
      "filter[service_id]": e.planId,
      "filter[is_production_site]": !0,
      pageSize: e.pageSize,
      pageIndex: e.pageIndex,
      sortBy: e.sortProperty,
      sortOrder: e.sortDirection
    };
    return e.searchItems && e.searchItems.forEach(e => {
      t[`${e.type}[${e.name}]`] = e.value;
    }), t;
  },
  responseBody: e => ({
    list: e.data.map(e => new Site(e)),
    pagination: new Pagination(e)
  })
});
const getSitesByPlanId$2 = new Definition({
  path: "/api/v1/site?filter[service_id]={planId}",
  method: "GET",
  responseBody: e => {
    const t = Number(e.config.url.split("/api/v1/site?filter[service_id]=")[1]);
    return {
      list: e.data.map(e => new Site(e)),
      planId: t,
      pagination: new Pagination(e)
    };
  },
  transformParams: e => transformSortParamsToV1(e)
});
const getSitesCreatedAfter = new Definition({
    path: "/api/v1/site?range[deploy_date]={timestamp}..&filter[is_production_account]=true",
    method: "GET",
    responseBody: e => e.data.map(e => new Site(e))
  }),
  getFailedSites = new Definition({
    path: "/api/v1/site?filter[state]=failure&filter[is_production_account]=true",
    method: "GET",
    responseBody: e => e.data.map(e => new Site(e))
  });
const getHudSites$2 = new GroupDefinition([getSitesCreatedAfter, getFailedSites], (e, t) => {
  const i = [...e.data, ...t.data];
  return i.filter((e, t) => i.findIndex(t => e.id === t.id) === t).map(e => new Site(e));
});
const searchSitesByPlanId$2 = new Definition({
  path: "/api/v1/site?filter[service_id]={planId}&match[{searchType}]={searchValue}",
  method: "GET",
  responseBody: e => {
    const t = e.config.url.match(/\/api\/v1\/site\?filter\[service_id]=(.*)&match\[(.*)]=(.*)/),
      i = Number(t[1]);
    return {
      list: e.data.map(e => new Site(e)),
      planId: i,
      pagination: new Pagination(e)
    };
  },
  transformParams: e => transformSortParamsToV1(e)
});
const updateSiteName$3 = new Definition("/api/v1/site/{id}/nickname", "POST", e => e.data, null, e => ({
  nickname: e.name
}));
const getAwstatsUrl$2 = new Definition("/api/v1/site/{id}/sso-url", "GET", e => e.data.awstats_url);
const getPhpMyAdminUrl$2 = new Definition("/api/v1/site/{id}/sso-url", "GET", e => e.data.phpmyadmin_url);
const getSiteWorxUrl$2 = new Definition("/api/v1/site/{id}/sso-url", "GET", e => e.data.siteworx_url);
const getDesignServicesEligibleSitesAvailableToActivate$2 = new Definition({
  path: "/api/v1/site?filter[feature-eligible]=design-services",
  method: "GET",
  responseBody: e => e.data.map(e => new Site(e))
});var site=/*#__PURE__*/Object.freeze({__proto__:null,getAwstatsUrl:getAwstatsUrl$2,getDesignServicesEligibleSitesAvailableToActivate:getDesignServicesEligibleSitesAvailableToActivate$2,getDevSites:getDevSites$2,getHudSites:getHudSites$2,getPhpMyAdminUrl:getPhpMyAdminUrl$2,getSite:getSite$2,getSitePermissions:getSitePermissions$2,getSiteWorxUrl:getSiteWorxUrl$2,getSites:getSites$2,getSitesByPlanId:getSitesByPlanId$2,getSitesByServiceId:getSitesByServiceId$2,searchSites:searchSites$2,searchSitesByPlanId:searchSitesByPlanId$2,updateSiteName:updateSiteName$3});class LetsEncryptDomains {
  constructor(t) {
    this.domain = t.domain, this.onCertificate = t.on_certificate;
  }
}class LetsEncryptDomain {
  constructor(t) {
    this.domain = t.domain, this.live = t.is_live, this.onCertificate = t.on_certificate;
  }
}class LetsEncryptInfo {
  constructor(o) {
    this.domains = void 0;
    this.domains = o.covered_domains;
  }
}const enableSiteLetsEncrypt$2 = new Definition("/api/v1/site/{siteId}/letsencrypt-enable", "POST", t => t.data);
const disableSiteLetsEncrypt$2 = new Definition("/api/v1/site/{siteId}/letsencrypt-disable", "POST", t => t.data);
const deleteSiteSslCert$2 = new Definition({
  path: "/api/v1/site/{siteId}/ssl-cert",
  method: "DELETE",
  responseBody: t => t
});
const getSiteLetsEncryptStatus$2 = new Definition("/api/v1/site/{siteId}/letsencrypt", "GET", t => t.data.enabled);
const getSiteLetsEncryptInfo$2 = new Definition("/api/v1/site/{siteId}/letsencrypt/status", "GET", t => new LetsEncryptInfo(t.data));
const getSiteLetsEncryptDomain$2 = new Definition("/api/v1/site/{siteId}/letsencrypt/domain/{domain}", "GET", t => new LetsEncryptDomain(t.data));
const getSiteLetsEncryptDomains$2 = new Definition("/api/v1/site/{siteId}/letsencrypt/domains/cert-inclusive", "GET", t => t.data.map(t => new LetsEncryptDomains(t)));
const issueSiteLetsEncryptCertificate$2 = new Definition("/api/v1/site/{siteId}/letsencrypt/issue", "POST", t => t.data, null, ({
  domains: t
}) => ({
  domains: t
}));var ssl=/*#__PURE__*/Object.freeze({__proto__:null,deleteSiteSslCert:deleteSiteSslCert$2,disableSiteLetsEncrypt:disableSiteLetsEncrypt$2,enableSiteLetsEncrypt:enableSiteLetsEncrypt$2,getSiteLetsEncryptDomain:getSiteLetsEncryptDomain$2,getSiteLetsEncryptDomains:getSiteLetsEncryptDomains$2,getSiteLetsEncryptInfo:getSiteLetsEncryptInfo$2,getSiteLetsEncryptStatus:getSiteLetsEncryptStatus$2,issueSiteLetsEncryptCertificate:issueSiteLetsEncryptCertificate$2});const getSiteVanityDomainSuggestions$2 = new Definition({
  path: "/api/v1/site/{siteId}/vanity-suggestions",
  method: "GET",
  responseBody: i => Object.entries(i.data.suggestions).map(([i, t]) => ({
    uuid: i,
    domain: t
  }))
});
const updateSiteVanityDomain$2 = new Definition("/api/v1/site/{siteId}/change-vanity-domain", "POST", i => i.data, null, ({
  uuid: i
}) => ({
  uuid: i
}));var vanityDomain=/*#__PURE__*/Object.freeze({__proto__:null,getSiteVanityDomainSuggestions:getSiteVanityDomainSuggestions$2,updateSiteVanityDomain:updateSiteVanityDomain$2});const getSiteVisCompUpgradeGroups$2 = new Definition("/api/v1/site/{siteId}/app/upgrade?sortOrder=desc", "GET", e => e.data.map(e => new VisCompUpgradeGroup(e)));
const getSiteVisCompUpgrades$2 = new Definition("/api/v1/site/{siteId}/app/upgrade/{upgradeGroupId}/item", "GET", e => e.data.map(e => new VisCompUpgrade(e)));
const getSiteVisCompUpgradeRegressions$2 = new Definition("/api/v1/site/{siteId}/app/upgrade/{upgradeGroupId}/item/{upgradeId}/regression", "GET", e => e.data.map(e => new VisCompRegression(e)));var visualComparison=/*#__PURE__*/Object.freeze({__proto__:null,getSiteVisCompUpgradeGroups:getSiteVisCompUpgradeGroups$2,getSiteVisCompUpgradeRegressions:getSiteVisCompUpgradeRegressions$2,getSiteVisCompUpgrades:getSiteVisCompUpgrades$2});class CoreSettings {
  constructor(e = {}) {
    this.enabled = void 0;
    this.enabledDate = void 0;
    this.siteId = void 0;
    this.enabled = e.enabled, this.enabledDate = e.enabled_date, this.siteId = e.site?.id;
  }
}class PluginSettings {
  constructor(e = {}) {
    this.enabled = void 0;
    this.siteId = void 0;
    this.enabled = e.enabled, this.siteId = e.site?.id;
  }
}const getSiteWpWooCoreSettings$2 = new Definition("/api/v1/site/{id}/app/core-update-settings", "GET", t => new CoreSettings(t.data));
const getSiteWpWooPluginSettings$2 = new Definition("/api/v1/site/{id}/app/plugin-update-settings", "GET", t => new PluginSettings(t.data));
const getSiteWpWooSso$2 = new Definition({
  path: "/api/v1/site/{id}/sso",
  method: "POST"
});
const updateSiteWpWooCoreSettings$2 = new Definition("/api/v1/site/{id}/app/core-update-settings", "POST", t => t.data, null, t => ({
  enable: t.enable,
  minor_updates_only: !1
}));
const updateSiteWpWooPluginSettings$2 = new Definition("/api/v1/site/{id}/app/plugin-update-settings", "POST", t => t.data, null, t => ({
  enable: t.enable
}));var wpWoo=/*#__PURE__*/Object.freeze({__proto__:null,getSiteWpWooCoreSettings:getSiteWpWooCoreSettings$2,getSiteWpWooPluginSettings:getSiteWpWooPluginSettings$2,getSiteWpWooSso:getSiteWpWooSso$2,updateSiteWpWooCoreSettings:updateSiteWpWooCoreSettings$2,updateSiteWpWooPluginSettings:updateSiteWpWooPluginSettings$2});const addSiteKeep$2 = new Definition({
  path: "/api/v1/site/{siteId}/addon/{addonId}",
  method: "POST",
  responseBody: e => e.data
});
const removeSiteKeep$2 = new Definition({
  path: "v1/site/{siteId}/addon/{addonId}",
  method: "DELETE",
  responseBody: e => e.data
});var siteKeep=/*#__PURE__*/Object.freeze({__proto__:null,addSiteKeep:addSiteKeep$2,removeSiteKeep:removeSiteKeep$2});const addSiteDesignServices$2 = new Definition({
  path: "/api/v1/site/{siteId}/addon/{addonId}",
  method: "POST",
  responseBody: e => e.data
});
const removeSiteDesignServices$2 = new Definition({
  path: "/api/v1/site/{siteId}/addon/{addonId}",
  method: "DELETE",
  responseBody: e => e.data
});var designServices=/*#__PURE__*/Object.freeze({__proto__:null,addSiteDesignServices:addSiteDesignServices$2,removeSiteDesignServices:removeSiteDesignServices$2});const getSitePointerDomains$2 = new Definition({
  path: "/api/v1/site/{siteId}/domain-pointers",
  method: "GET",
  responseBody: i => ({
    domains: i.data.pointers.map(i => new PointerDomain(i)),
    types: Object.keys(i.data.types)
  })
});var pointerDomain=/*#__PURE__*/Object.freeze({__proto__:null,getSitePointerDomains:getSitePointerDomains$2});const {
  getSiteAutoScaleUsage: getSiteAutoScaleUsage$1
} = autoScale;
const {
  purgeSiteCache: purgeSiteCache$1
} = cache;
const {
  enableSiteAdvancedAutoScale: enableSiteAdvancedAutoScale$2,
  disableSiteAdvancedAutoScale: disableSiteAdvancedAutoScale$1,
  getSiteAdvancedAutoScale: getSiteAdvancedAutoScale$1,
  getSiteAdvancedAutoScalePackages: getSiteAdvancedAutoScalePackages$1,
  updateSiteAdvancedAutoScale: updateSiteAdvancedAutoScale$1
} = advancedAutoScale;
const {
  getSiteAccessLogMetrics: getSiteAccessLogMetrics$1,
  getSiteBandwidthMetrics: getSiteBandwidthMetrics$1
} = apm;
const {
  getSiteBackups: getSiteBackups$1,
  getLastSiteDailyBackupRestore: getLastSiteDailyBackupRestore$1,
  getSiteBackupDatabases: getSiteBackupDatabases$1,
  getSiteDailyBackups: getSiteDailyBackups$1,
  restoreSiteDailyBackup: restoreSiteDailyBackup$1,
  restoreSiteDailyBackupDatabases: restoreSiteDailyBackupDatabases$1,
  restoreSiteDailyBackupFullFiles: restoreSiteDailyBackupFullFiles$1,
  restoreSiteDailyBackupFullFilesAndDatabases: restoreSiteDailyBackupFullFilesAndDatabases$1
} = backups;
const {
  getSiteBandwidthChart: getSiteBandwidthChart$1
} = bandwidth;
const {
  enableSiteCdn: enableSiteCdn$1,
  getSiteCdn: getSiteCdn$1,
  getSiteCdnUsage: getSiteCdnUsage$1,
  getSiteEadn: getSiteEadn$1,
  getSiteEadnOrigins: getSiteEadnOrigins$1,
  getSiteEadnOriginUris: getSiteEadnOriginUris$1,
  purgeSiteCdn: purgeSiteCdn$1
} = cdn;
const {
  addSiteCloudflare: addSiteCloudflare$1,
  getSiteCloudflareAddons: getSiteCloudflareAddons$1,
  getSiteCloudflareDetails: getSiteCloudflareDetails$1,
  getSiteCloudflareEligible: getSiteCloudflareEligible$1,
  getNameServers: getNameServers,
  removeSiteCloudflare: removeSiteCloudflare$1,
  updateSiteCloudflareSecurityLevel: updateSiteCloudflareSecurityLevel$1
} = cloudflare;
const {
  getSiteContainers: getSiteContainers$1,
  getSiteContainerTypes: getSiteContainerTypes$1
} = container;
const {
  createSiteEmailBox: createSiteEmailBox$1,
  disableLocalMailDelivery: disableLocalMailDelivery$1,
  enableLocalMailDelivery: enableLocalMailDelivery$1,
  getLocalMailDeliveryInfo: getLocalMailDeliveryInfo$1,
  createSiteEmailResponders: createSiteEmailResponders$1,
  updateSiteEmailResponders: updateSiteEmailResponders$1,
  getSiteEmailResponders: getSiteEmailResponders$1,
  deleteSiteEmailResponders: deleteSiteEmailResponders$1
} = email$1;
const {
  getSiteFtpUsers: getSiteFtpUsers$1
} = ftp;
const {
  enableSiteNewRelic: enableSiteNewRelic$1,
  disableSiteNewRelic: disableSiteNewRelic$1,
  getSiteNewRelic: getSiteNewRelic$1
} = newRelic;
const {
  enableSitePasswordProtection: enableSitePasswordProtection$1,
  disableSitePasswordProtection: disableSitePasswordProtection$1,
  getSitePasswordProtection: getSitePasswordProtection$1
} = passwordProtection;
const {
  getSitePhpCompatibilityCheck: getSitePhpCompatibilityCheck$1,
  getSitePhpFpmChart: getSitePhpFpmChart$1,
  getSitePhpMetrics: getSitePhpMetrics$1,
  updateSitePhpVersion: updateSitePhpVersion$1,
  cancelPhpVersionChange: cancelPhpVersionChange$1
} = php;
const {
  getDevSites: getDevSites$1,
  getSite: getSite$1,
  getSitePermissions: getSitePermissions$1,
  getSites: getSites$1,
  getSitesByPlanId: getSitesByPlanId$1,
  getSitesByServiceId: getSitesByServiceId$1,
  getHudSites: getHudSites$1,
  searchSites: searchSites$1,
  searchSitesByPlanId: searchSitesByPlanId$1,
  updateSiteName: updateSiteName$2,
  getAwstatsUrl: getAwstatsUrl$1,
  getPhpMyAdminUrl: getPhpMyAdminUrl$1,
  getSiteWorxUrl: getSiteWorxUrl$1,
  getDesignServicesEligibleSitesAvailableToActivate: getDesignServicesEligibleSitesAvailableToActivate$1
} = site;
const {
  getSiteWpWooCoreSettings: getSiteWpWooCoreSettings$1,
  getSiteWpWooPluginSettings: getSiteWpWooPluginSettings$1,
  getSiteWpWooSso: getSiteWpWooSso$1,
  updateSiteWpWooCoreSettings: updateSiteWpWooCoreSettings$1,
  updateSiteWpWooPluginSettings: updateSiteWpWooPluginSettings$1
} = wpWoo;
const {
  getSiteLogs: getSiteLogs$1
} = logs;
const {
  enableSiteLetsEncrypt: enableSiteLetsEncrypt$1,
  deleteSiteSslCert: deleteSiteSslCert$1,
  disableSiteLetsEncrypt: disableSiteLetsEncrypt$1,
  getSiteLetsEncryptStatus: getSiteLetsEncryptStatus$1,
  getSiteLetsEncryptInfo: getSiteLetsEncryptInfo$1,
  getSiteLetsEncryptDomain: getSiteLetsEncryptDomain$1,
  getSiteLetsEncryptDomains: getSiteLetsEncryptDomains$1,
  issueSiteLetsEncryptCertificate: issueSiteLetsEncryptCertificate$1
} = ssl;
const {
  getSiteVanityDomainSuggestions: getSiteVanityDomainSuggestions$1,
  updateSiteVanityDomain: updateSiteVanityDomain$1
} = vanityDomain;
const {
  getSiteVisCompUpgradeGroups: getSiteVisCompUpgradeGroups$1,
  getSiteVisCompUpgrades: getSiteVisCompUpgrades$1,
  getSiteVisCompUpgradeRegressions: getSiteVisCompUpgradeRegressions$1
} = visualComparison;
const {
  addSiteKeep: addSiteKeep$1,
  removeSiteKeep: removeSiteKeep$1
} = siteKeep;
const {
  addSiteDesignServices: addSiteDesignServices$1,
  removeSiteDesignServices: removeSiteDesignServices$1
} = designServices;
const {
  getSitePointerDomains: getSitePointerDomains$1
} = pointerDomain;var v1$1=/*#__PURE__*/Object.freeze({__proto__:null,addSiteCloudflare:addSiteCloudflare$1,addSiteDesignServices:addSiteDesignServices$1,addSiteKeep:addSiteKeep$1,cancelPhpVersionChange:cancelPhpVersionChange$1,createSiteEmailBox:createSiteEmailBox$1,createSiteEmailResponders:createSiteEmailResponders$1,deleteSiteEmailResponders:deleteSiteEmailResponders$1,deleteSiteSslCert:deleteSiteSslCert$1,disableLocalMailDelivery:disableLocalMailDelivery$1,disableSiteAdvancedAutoScale:disableSiteAdvancedAutoScale$1,disableSiteLetsEncrypt:disableSiteLetsEncrypt$1,disableSiteNewRelic:disableSiteNewRelic$1,disableSitePasswordProtection:disableSitePasswordProtection$1,enableLocalMailDelivery:enableLocalMailDelivery$1,enableSiteAdvancedAutoScale:enableSiteAdvancedAutoScale$2,enableSiteCdn:enableSiteCdn$1,enableSiteLetsEncrypt:enableSiteLetsEncrypt$1,enableSiteNewRelic:enableSiteNewRelic$1,enableSitePasswordProtection:enableSitePasswordProtection$1,getAwstatsUrl:getAwstatsUrl$1,getDesignServicesEligibleSitesAvailableToActivate:getDesignServicesEligibleSitesAvailableToActivate$1,getDevSites:getDevSites$1,getHudSites:getHudSites$1,getLastSiteDailyBackupRestore:getLastSiteDailyBackupRestore$1,getLocalMailDeliveryInfo:getLocalMailDeliveryInfo$1,getNameServers:getNameServers,getPhpMyAdminUrl:getPhpMyAdminUrl$1,getSite:getSite$1,getSiteAccessLogMetrics:getSiteAccessLogMetrics$1,getSiteAdvancedAutoScale:getSiteAdvancedAutoScale$1,getSiteAdvancedAutoScalePackages:getSiteAdvancedAutoScalePackages$1,getSiteAutoScaleUsage:getSiteAutoScaleUsage$1,getSiteBackupDatabases:getSiteBackupDatabases$1,getSiteBackups:getSiteBackups$1,getSiteBandwidthChart:getSiteBandwidthChart$1,getSiteBandwidthMetrics:getSiteBandwidthMetrics$1,getSiteCdn:getSiteCdn$1,getSiteCdnUsage:getSiteCdnUsage$1,getSiteCloudflareAddons:getSiteCloudflareAddons$1,getSiteCloudflareDetails:getSiteCloudflareDetails$1,getSiteCloudflareEligible:getSiteCloudflareEligible$1,getSiteContainerTypes:getSiteContainerTypes$1,getSiteContainers:getSiteContainers$1,getSiteDailyBackups:getSiteDailyBackups$1,getSiteEadn:getSiteEadn$1,getSiteEadnOriginUris:getSiteEadnOriginUris$1,getSiteEadnOrigins:getSiteEadnOrigins$1,getSiteEmailResponders:getSiteEmailResponders$1,getSiteFtpUsers:getSiteFtpUsers$1,getSiteLetsEncryptDomain:getSiteLetsEncryptDomain$1,getSiteLetsEncryptDomains:getSiteLetsEncryptDomains$1,getSiteLetsEncryptInfo:getSiteLetsEncryptInfo$1,getSiteLetsEncryptStatus:getSiteLetsEncryptStatus$1,getSiteLogs:getSiteLogs$1,getSiteNewRelic:getSiteNewRelic$1,getSitePasswordProtection:getSitePasswordProtection$1,getSitePermissions:getSitePermissions$1,getSitePhpCompatibilityCheck:getSitePhpCompatibilityCheck$1,getSitePhpFpmChart:getSitePhpFpmChart$1,getSitePhpMetrics:getSitePhpMetrics$1,getSitePointerDomains:getSitePointerDomains$1,getSiteVanityDomainSuggestions:getSiteVanityDomainSuggestions$1,getSiteVisCompUpgradeGroups:getSiteVisCompUpgradeGroups$1,getSiteVisCompUpgradeRegressions:getSiteVisCompUpgradeRegressions$1,getSiteVisCompUpgrades:getSiteVisCompUpgrades$1,getSiteWorxUrl:getSiteWorxUrl$1,getSiteWpWooCoreSettings:getSiteWpWooCoreSettings$1,getSiteWpWooPluginSettings:getSiteWpWooPluginSettings$1,getSiteWpWooSso:getSiteWpWooSso$1,getSites:getSites$1,getSitesByPlanId:getSitesByPlanId$1,getSitesByServiceId:getSitesByServiceId$1,issueSiteLetsEncryptCertificate:issueSiteLetsEncryptCertificate$1,purgeSiteCache:purgeSiteCache$1,purgeSiteCdn:purgeSiteCdn$1,removeSiteCloudflare:removeSiteCloudflare$1,removeSiteDesignServices:removeSiteDesignServices$1,removeSiteKeep:removeSiteKeep$1,restoreSiteDailyBackup:restoreSiteDailyBackup$1,restoreSiteDailyBackupDatabases:restoreSiteDailyBackupDatabases$1,restoreSiteDailyBackupFullFiles:restoreSiteDailyBackupFullFiles$1,restoreSiteDailyBackupFullFilesAndDatabases:restoreSiteDailyBackupFullFilesAndDatabases$1,searchSites:searchSites$1,searchSitesByPlanId:searchSitesByPlanId$1,updateSiteAdvancedAutoScale:updateSiteAdvancedAutoScale$1,updateSiteCloudflareSecurityLevel:updateSiteCloudflareSecurityLevel$1,updateSiteEmailResponders:updateSiteEmailResponders$1,updateSiteName:updateSiteName$2,updateSitePhpVersion:updateSitePhpVersion$1,updateSiteVanityDomain:updateSiteVanityDomain$1,updateSiteWpWooCoreSettings:updateSiteWpWooCoreSettings$1,updateSiteWpWooPluginSettings:updateSiteWpWooPluginSettings$1});const {
  addSiteContainer: addSiteContainer,
  addSiteCron: addSiteCron$1,
  createSecondarySite: createSecondarySite,
  createSite: createSite,
  createSiteFromStencil: createSiteFromStencil,
  createSiteFtpUser: createSiteFtpUser,
  createDevSite: createDevSite,
  deleteDevSite: deleteDevSite,
  deleteSite: deleteSite,
  deleteSiteCron: deleteSiteCron,
  getAutoscaleMetrics: getAutoscaleMetrics,
  getSiteContainerGroups: getSiteContainerGroups,
  getSiteCronOptions: getSiteCronOptions,
  getSiteCronTasks: getSiteCronTasks,
  getSiteDns: getSiteDns,
  getSiteHttpPasswordInfo: getSiteHttpPasswordInfo,
  getSitePhpVersions: getSitePhpVersions,
  getSiteRemoteUserInfo: getSiteRemoteUserInfo,
  getSiteSystemTime: getSiteSystemTime,
  getUsageMetrics: getUsageMetrics,
  updateSiteAutoScale: updateSiteAutoScale,
  updateSiteDomain: updateSiteDomain$1,
  updateSiteCron: updateSiteCron,
  updateSiteRemotePassword: updateSiteRemotePassword,
  removeSiteContainer: removeSiteContainer,
  updateSiteCronOptions: updateSiteCronOptions$1,
  updateSiteNginx: updateSiteNginx,
  getSiteEmailBoxes: getSiteEmailBoxes,
  getSiteFtpHomeDirOptions: getSiteFtpHomeDirOptions,
  deleteSiteEmailBox: deleteSiteEmailBox,
  regenPasswordSiteEmailBox: regenPasswordSiteEmailBox,
  getSiteEmailAliases: getSiteEmailAliases,
  createSiteEmailAlias: createSiteEmailAlias,
  updateSiteEmailAlias: updateSiteEmailAlias,
  deleteSiteEmailAlias: deleteSiteEmailAlias,
  getWebmailUrl: getWebmailUrl,
  removeSiteFtpUser: removeSiteFtpUser,
  resetSiteHttpPassword: resetSiteHttpPassword,
  updateSiteFtpUser: updateSiteFtpUser,
  updateSiteFtpUserHomeDir: updateSiteFtpUserHomeDir,
  updateSiteFtpUserPassword: updateSiteFtpUserPassword,
  getSiteSSLInfo: getSiteSSLInfo,
  createSitePointerDomain: createSitePointerDomain,
  deleteSitePointerDomain: deleteSitePointerDomain,
  createSiteBackup: createSiteBackup,
  deleteSiteBackup: deleteSiteBackup,
  restoreSiteBackup: restoreSiteBackup,
  getSiteBackupRestoreStatus: getSiteBackupRestoreStatus
} = legacySites;
const {
  createSiteEmailBox: createSiteEmailBox,
  getDevSites: getDevSites,
  enableSiteAdvancedAutoScale: enableSiteAdvancedAutoScale$1,
  enableSiteCdn: enableSiteCdn,
  enableSiteNewRelic: enableSiteNewRelic,
  enableSitePasswordProtection: enableSitePasswordProtection,
  deleteSiteSslCert: deleteSiteSslCert,
  disableSiteAdvancedAutoScale: disableSiteAdvancedAutoScale,
  disableSiteNewRelic: disableSiteNewRelic,
  disableSitePasswordProtection: disableSitePasswordProtection,
  getLastSiteDailyBackupRestore: getLastSiteDailyBackupRestore,
  getSite: getSite,
  getSitePermissions: getSitePermissions,
  getSiteAccessLogMetrics: getSiteAccessLogMetrics,
  getSiteAdvancedAutoScale: getSiteAdvancedAutoScale,
  getSiteAdvancedAutoScalePackages: getSiteAdvancedAutoScalePackages,
  getSiteAutoScaleUsage: getSiteAutoScaleUsage,
  getSiteBandwidthMetrics: getSiteBandwidthMetrics,
  getSiteCdn: getSiteCdn,
  getSiteCdnUsage: getSiteCdnUsage,
  getSiteEadn: getSiteEadn,
  getSiteEadnOrigins: getSiteEadnOrigins,
  getSiteEadnOriginUris: getSiteEadnOriginUris,
  getSiteNewRelic: getSiteNewRelic,
  getSitePasswordProtection: getSitePasswordProtection,
  getSitePhpCompatibilityCheck: getSitePhpCompatibilityCheck,
  getSitePhpMetrics: getSitePhpMetrics,
  getSites: getSites,
  getSitesByPlanId: getSitesByPlanId,
  getSitesByServiceId: getSitesByServiceId,
  getHudSites: getHudSites,
  getSiteVanityDomainSuggestions: getSiteVanityDomainSuggestions,
  getSiteWpWooCoreSettings: getSiteWpWooCoreSettings,
  getSiteWpWooPluginSettings: getSiteWpWooPluginSettings,
  getSiteWpWooSso: getSiteWpWooSso,
  updateSiteAdvancedAutoScale: updateSiteAdvancedAutoScale,
  updateSitePhpVersion: updateSitePhpVersion,
  updateSiteWpWooCoreSettings: updateSiteWpWooCoreSettings,
  updateSiteWpWooPluginSettings: updateSiteWpWooPluginSettings,
  getLocalMailDeliveryInfo: getLocalMailDeliveryInfo,
  disableLocalMailDelivery: disableLocalMailDelivery,
  enableLocalMailDelivery: enableLocalMailDelivery,
  getSiteContainers: getSiteContainers,
  getSiteContainerTypes: getSiteContainerTypes,
  getSiteLogs: getSiteLogs,
  getSiteLetsEncryptStatus: getSiteLetsEncryptStatus,
  getSiteLetsEncryptInfo: getSiteLetsEncryptInfo,
  enableSiteLetsEncrypt: enableSiteLetsEncrypt,
  disableSiteLetsEncrypt: disableSiteLetsEncrypt,
  getSiteLetsEncryptDomain: getSiteLetsEncryptDomain,
  getSiteLetsEncryptDomains: getSiteLetsEncryptDomains,
  issueSiteLetsEncryptCertificate: issueSiteLetsEncryptCertificate,
  getSiteBackups: getSiteBackups,
  getSiteBackupDatabases: getSiteBackupDatabases,
  getSiteDailyBackups: getSiteDailyBackups,
  restoreSiteDailyBackup: restoreSiteDailyBackup,
  restoreSiteDailyBackupDatabases: restoreSiteDailyBackupDatabases,
  restoreSiteDailyBackupFullFiles: restoreSiteDailyBackupFullFiles,
  restoreSiteDailyBackupFullFilesAndDatabases: restoreSiteDailyBackupFullFilesAndDatabases,
  getSiteVisCompUpgradeGroups: getSiteVisCompUpgradeGroups,
  getSiteVisCompUpgrades: getSiteVisCompUpgrades,
  getSiteVisCompUpgradeRegressions: getSiteVisCompUpgradeRegressions,
  purgeSiteCache: purgeSiteCache,
  purgeSiteCdn: purgeSiteCdn,
  updateSiteName: updateSiteName$1,
  getSiteBandwidthChart: getSiteBandwidthChart,
  getSitePhpFpmChart: getSitePhpFpmChart,
  searchSites: searchSites,
  searchSitesByPlanId: searchSitesByPlanId,
  getSiteFtpUsers: getSiteFtpUsers,
  getAwstatsUrl: getAwstatsUrl,
  getPhpMyAdminUrl: getPhpMyAdminUrl,
  getSiteWorxUrl: getSiteWorxUrl,
  createSiteEmailResponders: createSiteEmailResponders,
  updateSiteEmailResponders: updateSiteEmailResponders,
  getSiteEmailResponders: getSiteEmailResponders,
  deleteSiteEmailResponders: deleteSiteEmailResponders,
  updateSiteVanityDomain: updateSiteVanityDomain,
  getSiteCloudflareEligible: getSiteCloudflareEligible,
  getSiteCloudflareAddons: getSiteCloudflareAddons,
  getSiteCloudflareDetails: getSiteCloudflareDetails,
  addSiteCloudflare: addSiteCloudflare,
  removeSiteCloudflare: removeSiteCloudflare,
  updateSiteCloudflareSecurityLevel: updateSiteCloudflareSecurityLevel,
  cancelPhpVersionChange: cancelPhpVersionChange,
  getDesignServicesEligibleSitesAvailableToActivate: getDesignServicesEligibleSitesAvailableToActivate,
  addSiteKeep: addSiteKeep,
  removeSiteKeep: removeSiteKeep,
  addSiteDesignServices: addSiteDesignServices,
  removeSiteDesignServices: removeSiteDesignServices,
  getSitePointerDomains: getSitePointerDomains
} = v1$1;var sites=/*#__PURE__*/Object.freeze({__proto__:null,addSiteCloudflare:addSiteCloudflare,addSiteContainer:addSiteContainer,addSiteCron:addSiteCron$1,addSiteDesignServices:addSiteDesignServices,addSiteKeep:addSiteKeep,cancelPhpVersionChange:cancelPhpVersionChange,createDevSite:createDevSite,createSecondarySite:createSecondarySite,createSite:createSite,createSiteBackup:createSiteBackup,createSiteEmailAlias:createSiteEmailAlias,createSiteEmailBox:createSiteEmailBox,createSiteEmailResponders:createSiteEmailResponders,createSiteFromStencil:createSiteFromStencil,createSiteFtpUser:createSiteFtpUser,createSitePointerDomain:createSitePointerDomain,deleteDevSite:deleteDevSite,deleteSite:deleteSite,deleteSiteBackup:deleteSiteBackup,deleteSiteCron:deleteSiteCron,deleteSiteEmailAlias:deleteSiteEmailAlias,deleteSiteEmailBox:deleteSiteEmailBox,deleteSiteEmailResponders:deleteSiteEmailResponders,deleteSitePointerDomain:deleteSitePointerDomain,deleteSiteSslCert:deleteSiteSslCert,disableLocalMailDelivery:disableLocalMailDelivery,disableSiteAdvancedAutoScale:disableSiteAdvancedAutoScale,disableSiteLetsEncrypt:disableSiteLetsEncrypt,disableSiteNewRelic:disableSiteNewRelic,disableSitePasswordProtection:disableSitePasswordProtection,enableLocalMailDelivery:enableLocalMailDelivery,enableSiteAdvancedAutoScale:enableSiteAdvancedAutoScale$1,enableSiteCdn:enableSiteCdn,enableSiteLetsEncrypt:enableSiteLetsEncrypt,enableSiteNewRelic:enableSiteNewRelic,enableSitePasswordProtection:enableSitePasswordProtection,getAutoscaleMetrics:getAutoscaleMetrics,getAwstatsUrl:getAwstatsUrl,getDesignServicesEligibleSitesAvailableToActivate:getDesignServicesEligibleSitesAvailableToActivate,getDevSites:getDevSites,getHudSites:getHudSites,getLastSiteDailyBackupRestore:getLastSiteDailyBackupRestore,getLocalMailDeliveryInfo:getLocalMailDeliveryInfo,getPhpMyAdminUrl:getPhpMyAdminUrl,getSite:getSite,getSiteAccessLogMetrics:getSiteAccessLogMetrics,getSiteAdvancedAutoScale:getSiteAdvancedAutoScale,getSiteAdvancedAutoScalePackages:getSiteAdvancedAutoScalePackages,getSiteAutoScaleUsage:getSiteAutoScaleUsage,getSiteBackupDatabases:getSiteBackupDatabases,getSiteBackupRestoreStatus:getSiteBackupRestoreStatus,getSiteBackups:getSiteBackups,getSiteBandwidthChart:getSiteBandwidthChart,getSiteBandwidthMetrics:getSiteBandwidthMetrics,getSiteCdn:getSiteCdn,getSiteCdnUsage:getSiteCdnUsage,getSiteCloudflareAddons:getSiteCloudflareAddons,getSiteCloudflareDetails:getSiteCloudflareDetails,getSiteCloudflareEligible:getSiteCloudflareEligible,getSiteContainerGroups:getSiteContainerGroups,getSiteContainerTypes:getSiteContainerTypes,getSiteContainers:getSiteContainers,getSiteCronOptions:getSiteCronOptions,getSiteCronTasks:getSiteCronTasks,getSiteDailyBackups:getSiteDailyBackups,getSiteDns:getSiteDns,getSiteEadn:getSiteEadn,getSiteEadnOriginUris:getSiteEadnOriginUris,getSiteEadnOrigins:getSiteEadnOrigins,getSiteEmailAliases:getSiteEmailAliases,getSiteEmailBoxes:getSiteEmailBoxes,getSiteEmailResponders:getSiteEmailResponders,getSiteFtpHomeDirOptions:getSiteFtpHomeDirOptions,getSiteFtpUsers:getSiteFtpUsers,getSiteHttpPasswordInfo:getSiteHttpPasswordInfo,getSiteLetsEncryptDomain:getSiteLetsEncryptDomain,getSiteLetsEncryptDomains:getSiteLetsEncryptDomains,getSiteLetsEncryptInfo:getSiteLetsEncryptInfo,getSiteLetsEncryptStatus:getSiteLetsEncryptStatus,getSiteLogs:getSiteLogs,getSiteNewRelic:getSiteNewRelic,getSitePasswordProtection:getSitePasswordProtection,getSitePermissions:getSitePermissions,getSitePhpCompatibilityCheck:getSitePhpCompatibilityCheck,getSitePhpFpmChart:getSitePhpFpmChart,getSitePhpMetrics:getSitePhpMetrics,getSitePhpVersions:getSitePhpVersions,getSitePointerDomains:getSitePointerDomains,getSiteRemoteUserInfo:getSiteRemoteUserInfo,getSiteSSLInfo:getSiteSSLInfo,getSiteSystemTime:getSiteSystemTime,getSiteVanityDomainSuggestions:getSiteVanityDomainSuggestions,getSiteVisCompUpgradeGroups:getSiteVisCompUpgradeGroups,getSiteVisCompUpgradeRegressions:getSiteVisCompUpgradeRegressions,getSiteVisCompUpgrades:getSiteVisCompUpgrades,getSiteWorxUrl:getSiteWorxUrl,getSiteWpWooCoreSettings:getSiteWpWooCoreSettings,getSiteWpWooPluginSettings:getSiteWpWooPluginSettings,getSiteWpWooSso:getSiteWpWooSso,getSites:getSites,getSitesByPlanId:getSitesByPlanId,getSitesByServiceId:getSitesByServiceId,getUsageMetrics:getUsageMetrics,getWebmailUrl:getWebmailUrl,issueSiteLetsEncryptCertificate:issueSiteLetsEncryptCertificate,purgeSiteCache:purgeSiteCache,purgeSiteCdn:purgeSiteCdn,regenPasswordSiteEmailBox:regenPasswordSiteEmailBox,removeSiteCloudflare:removeSiteCloudflare,removeSiteContainer:removeSiteContainer,removeSiteDesignServices:removeSiteDesignServices,removeSiteFtpUser:removeSiteFtpUser,removeSiteKeep:removeSiteKeep,resetSiteHttpPassword:resetSiteHttpPassword,restoreSiteBackup:restoreSiteBackup,restoreSiteDailyBackup:restoreSiteDailyBackup,restoreSiteDailyBackupDatabases:restoreSiteDailyBackupDatabases,restoreSiteDailyBackupFullFiles:restoreSiteDailyBackupFullFiles,restoreSiteDailyBackupFullFilesAndDatabases:restoreSiteDailyBackupFullFilesAndDatabases,searchSites:searchSites,searchSitesByPlanId:searchSitesByPlanId,updateSiteAdvancedAutoScale:updateSiteAdvancedAutoScale,updateSiteAutoScale:updateSiteAutoScale,updateSiteCloudflareSecurityLevel:updateSiteCloudflareSecurityLevel,updateSiteCron:updateSiteCron,updateSiteCronOptions:updateSiteCronOptions$1,updateSiteDomain:updateSiteDomain$1,updateSiteEmailAlias:updateSiteEmailAlias,updateSiteEmailResponders:updateSiteEmailResponders,updateSiteFtpUser:updateSiteFtpUser,updateSiteFtpUserHomeDir:updateSiteFtpUserHomeDir,updateSiteFtpUserPassword:updateSiteFtpUserPassword,updateSiteName:updateSiteName$1,updateSiteNginx:updateSiteNginx,updateSitePhpVersion:updateSitePhpVersion,updateSiteRemotePassword:updateSiteRemotePassword,updateSiteVanityDomain:updateSiteVanityDomain,updateSiteWpWooCoreSettings:updateSiteWpWooCoreSettings,updateSiteWpWooPluginSettings:updateSiteWpWooPluginSettings});const apiStatus = new Definition("api/", "GET", i => i.data);var status=/*#__PURE__*/Object.freeze({__proto__:null,apiStatus:apiStatus});const getStencils = new Definition({
    path: "/api/v1/site/{siteId}/stencil",
    method: "GET",
    responseBody: e => e.data.map(e => new Stencil(e))
  }),
  getStencilsByPlanId = new Definition("/api/v1/site/stencil?filter[service_id]={planId}", "GET", e => e.data.map(e => new Stencil(e))),
  createStencil = new Definition({
    path: "/api/v1/site/{siteId}/stencil",
    method: "POST",
    responseBody: e => e.data,
    requestBody: e => ({
      site_id: e.siteId,
      name: e.name
    })
  }),
  deleteStencil = new Definition("/api/v1/site/{siteId}/stencil/{stencilId}", "DELETE", e => e.data);var stencils=/*#__PURE__*/Object.freeze({__proto__:null,createStencil:createStencil,deleteStencil:deleteStencil,getStencils:getStencils,getStencilsByPlanId:getStencilsByPlanId});const getTask = new Definition({
  path: "/api/v1/task/{uuid}",
  method: "GET",
  responseBody: t => t.data
});
const getTaskByActionAndStatus = new Definition({
  path: "/api/v1/task?filter[action]={action}&filter[status]={status}",
  method: "GET",
  responseBody: t => t.data
});var tasks=/*#__PURE__*/Object.freeze({__proto__:null,getTask:getTask,getTaskByActionAndStatus:getTaskByActionAndStatus});const getSalesTax = new Definition("/cloud-account", "POST", e => e.data, null, e => ({
    app_id: e.appId,
    package_id: e.packageId,
    service_id: e.planId,
    term: e.term,
    addon_ids: e.addonIds,
    discount_code: e.discountCode,
    _action: "estimate-tax"
  })),
  getCloudServerSalesTax = new Definition("/cloud-server", "POST", e => e.data, null, e => ({
    package_id: e.packageId,
    term: e.term,
    addon_ids: e.addonIds,
    discount_code: e.discountCode,
    _action: "estimate-tax"
  }));const setTaxId = new Definition("/api/v1/client/tax-exempt", "POST", e => e.data, null, e => ({
    number: e.taxId,
    document_ids: e.taxFileIds
  })),
  deleteTaxId = new Definition("/api/v1/client/tax-exempt", "DELETE", e => e.data),
  validateTaxId = new Definition("/api/v1/client/tax-exempt/{taxId}/{countryCode}", "GET", e => e.data);var tax=/*#__PURE__*/Object.freeze({__proto__:null,deleteTaxId:deleteTaxId,getCloudServerSalesTax:getCloudServerSalesTax,getSalesTax:getSalesTax,setTaxId:setTaxId,validateTaxId:validateTaxId});const getRoles$1 = new Definition("/user-role", "GET", e => {
  const s = [],
    o = [];
  return Object.keys(e.data.meta.options.resources).forEach(r => {
    const t = e.data.meta.options.resources[r];
    "email" === r ? Object.keys(t).forEach(e => {
      o.push(new Role(t[e]));
    }) : Object.keys(t).forEach(e => {
      s.push(new Role(t[e]));
    });
  }), {
    resourceRoles: s,
    notificationRoles: o
  };
});
const getTeams$1 = new Definition("/user-role", "GET", e => ({
  list: e.data.map(e => new Team(e)),
  pagination: new Pagination(e)
}));
const deleteMember$1 = new Definition("/user/{id}", "DELETE", e => e.data);
const formatTeamPermissions = e => {
    const s = {},
      o = {};
    permissionResources.forEach((e, s) => {
      o[s + 1] = "0";
    }), Object.keys(e.permissions).forEach(o => {
      const r = permissionResources.findIndex(e => e === o) + 1,
        t = e.permissions[o];
      s[r] = t.length ? `${getPermissionLevel(e.permissions[o])}` : "0";
    });
    const r = {
      ...o,
      ...s
    };
    return Object.keys(e.notifications).forEach(s => {
      const o = e.notifications[s];
      r[s] = o.map(e => `${permissionResources.findIndex(s => s === e) + 1}`);
    }), r;
  },
  splitDeleteResources = e => {
    const s = {},
      o = {};
    return Object.entries(e).forEach(([e, r]) => {
      "3" === r ? (o[e] = "1", s[e] = "2") : s[e] = r;
    }), {
      user_resources: s,
      user_resources_delete: o
    };
  };
const createTeam$1 = new Definition("/user-role", "POST", e => e.data, null, e => {
  const s = formatTeamPermissions(e),
    {
      user_resources: o,
      user_resources_delete: r
    } = splitDeleteResources(s);
  return {
    name: e.name,
    user_resources: o,
    user_resources_delete: r
  };
});
const editTeam$1 = new Definition("/user-role/{teamId}", "PATCH", e => e.data, null, e => {
  const s = formatTeamPermissions(e),
    {
      user_resources: o,
      user_resources_delete: r
    } = splitDeleteResources(s);
  return {
    name: e.name,
    user_resources: o,
    user_resources_delete: r
  };
});
const deleteTeam$1 = new Definition("/user-role/{teamId}", "DELETE", e => e.data);
const getTeamMembers$1 = new Definition("/user", "GET", e => ({
  list: e.data.map(e => new Member(e)),
  pagination: new Pagination(e)
}));var legacy$1=/*#__PURE__*/Object.freeze({__proto__:null,createTeam:createTeam$1,deleteMember:deleteMember$1,deleteTeam:deleteTeam$1,editTeam:editTeam$1,getRoles:getRoles$1,getTeamMembers:getTeamMembers$1,getTeams:getTeams$1});const {
  createTeam: createTeam,
  editTeam: editTeam,
  deleteMember: deleteMember,
  getRoles: getRoles,
  getTeams: getTeams,
  deleteTeam: deleteTeam,
  getTeamMembers: getTeamMembers
} = legacy$1;var team=/*#__PURE__*/Object.freeze({__proto__:null,createTeam:createTeam,deleteMember:deleteMember,deleteTeam:deleteTeam,editTeam:editTeam,getRoles:getRoles,getTeamMembers:getTeamMembers,getTeams:getTeams});class TicketCommentAttachmentDownloadLink {
  constructor(t = {}) {
    this.id = void 0;
    this.link = void 0;
    this.name = void 0;
    this.id = t.attachment.id, this.link = t.download_link, this.name = t.attachment.identity;
  }
}class TicketDatashare extends Datashare {
  constructor(a = {}) {
    super(a), this.caseNumber = a?.linked?.metadata?.uri?.match(/\/v1\/ticket\/(.*)/)[1];
  }
}const addTicket$1 = new Definition({
  path: "/api/v1/ticket",
  method: "POST",
  responseBody: t => new Ticket(t.data),
  requestBody: t => ({
    comment: t.reply || t.body,
    category: t.category,
    department: t.department,
    recipients: t.recipients,
    service_id: t.service,
    subject: t.subject,
    _wait: !0
  })
});
const addTicketComment = new Definition({
  path: "/api/v1/ticket/{id}/comment",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    comment: t.body
  })
});
const addTicketFeedback$1 = new Definition({
  path: "/api/v1/ticket/{id}/rate",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    rating: t.rating,
    feedback: t.feedback
  })
});
const addTicketPassword = new Definition({
  path: "/api/v1/ticket/{id}/datashare",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    data: t.password
  })
});
const addTicketWatcher = new Definition({
  path: "/api/v1/ticket/{id}/watcher",
  method: "POST",
  responseBody: t => t.data,
  requestBody: t => ({
    watchers: [t.email]
  })
});
const deleteTicketWatcher = new Definition({
  path: "/api/v1/ticket/{id}/watcher",
  method: "DELETE",
  responseBody: t => t.data,
  requestBody: t => ({
    watchers: [t.email]
  })
});
const claimTicket = new Definition({
  path: "/api/v1/ticket/{id}/claim",
  method: "POST",
  responseBody: t => t.data
});
const closeTicket = new Definition({
  path: "/api/v1/ticket/{id}/close",
  method: "POST",
  responseBody: t => t.data
});
const getOpenTicketCount = new Definition({
  path: "/api/v1/ticket?filter[status]=open&pageSize=0",
  method: "GET",
  responseBody: t => new Pagination(t)?.total
});
const getTicket = new Definition({
  path: "/api/v1/ticket/{id}",
  method: "GET",
  responseBody: t => new Ticket(t.data)
});
const getTicketAttachment = new Definition({
  path: "/api/v1/ticket/{id}/attachment/{attachmentId}",
  method: "GET",
  responseBody: t => t.data,
  headers: {
    Accept: "*/*"
  }
});
const getTicketDownloadAttachmentLink = new Definition({
  path: "/api/v1/attachment/{id}/download-link",
  method: "GET",
  responseBody: t => new TicketCommentAttachmentDownloadLink(t.data)
});
const getTicketPasswords = new Definition({
  path: "/api/v1/datashare/ticket/{id}",
  method: "GET",
  responseBody: t => t.data.map(t => new TicketDatashare(t)).sort((t, e) => e.sharedDate - t.sharedDate)
});
const getTicketOptions = new Definition({
  path: "/api/v1/ticket/options",
  method: "GET",
  responseBody: t => {
    const e = t => Object.entries(t).map(t => {
      const [e, i] = t;
      return {
        id: e,
        identity: i
      };
    });
    return {
      categories: e(t.data.category),
      departments: e(t.data.department),
      rating: e(t.data.rating),
      service: e(t.data.service)
    };
  }
});
const getTickets = new Definition({
  path: "/api/v1/ticket",
  method: "GET",
  responseBody: t => ({
    list: t.data.map(t => new Ticket(t)),
    pagination: new Pagination(t)
  }),
  transformParams: t => transformSortParamsToV1(t)
});
const openTicket = new Definition({
  path: "/api/v1/ticket/{id}/open",
  method: "POST",
  responseBody: t => t.data
});var tickets=/*#__PURE__*/Object.freeze({__proto__:null,addTicket:addTicket$1,addTicketComment:addTicketComment,addTicketFeedback:addTicketFeedback$1,addTicketPassword:addTicketPassword,addTicketWatcher:addTicketWatcher,claimTicket:claimTicket,closeTicket:closeTicket,deleteTicketWatcher:deleteTicketWatcher,getOpenTicketCount:getOpenTicketCount,getTicket:getTicket,getTicketAttachment:getTicketAttachment,getTicketDownloadAttachmentLink:getTicketDownloadAttachmentLink,getTicketOptions:getTicketOptions,getTicketPasswords:getTicketPasswords,getTickets:getTickets,openTicket:openTicket});const getTokens = new Definition("/api-token", "GET", e => ({
    list: e.data.map(e => new ApiToken(e)),
    pagination: new Pagination(e)
  })),
  createToken = new Definition("/api-token", "POST", e => e.data, null, e => ({
    name: e.name
  })),
  renameToken = new Definition("/api-token/{id}", "PATCH", e => e.data),
  deleteToken = new Definition("/api-token/{id}", "DELETE", e => e.data);var apiTokens=/*#__PURE__*/Object.freeze({__proto__:null,createToken:createToken,deleteToken:deleteToken,getTokens:getTokens,renameToken:renameToken});class SshKey {
  constructor(e = {}) {
    this.id = void 0;
    this.name = void 0;
    this.tokenId = void 0;
    this.userId = void 0;
    this.id = e.id, this.name = e.name, this.creationDate = e.creation_date, this.keyId = e.key_id, this.keySize = e.key_size, this.fingerPrint = e.fingerprint, this.userId = e.user_id;
  }
}const getKeys = new Definition("/ssh-key", "GET", e => ({
    list: e.data.map(e => new SshKey(e)),
    pagination: new Pagination(e)
  })),
  createKey = new Definition("/ssh-key", "POST", e => new SshKey(e.data), null, e => ({
    name: e.name,
    key: e.key
  })),
  deleteKey = new Definition("/ssh-key/{id}", "DELETE", e => e.data);var sshKeys=/*#__PURE__*/Object.freeze({__proto__:null,createKey:createKey,deleteKey:deleteKey,getKeys:getKeys});class TwoFactor {
  constructor(e = {}) {
    this.enabled = void 0;
    this.backupCodes = void 0;
    this.QRImage = void 0;
    this.secret = void 0;
    this.provider = void 0;
    this.enabled = e.enabled, this.backupCodes = e.backup_codes, this.QRImage = e.qr_image, this.secret = e.secret, this.provider = e.provider;
  }
}const check2faByUsername$1 = new Definition("/user/check-two-factor", "GET", e => ({
  twoFactorRequired: !!e.data?.two_factor,
  hasCell: !!e.data?.has_cell
}));
const joinWithExistingUser$1 = new Definition("/user/{userId}", "POST", e => {
  if (!e) return !1;
  return {
    token: new Token(e?.headers?.authorization || e?.headers?.Authorization),
    user: e.data
  };
}, null, e => ({
  client_id: e.clientId,
  code: e.code,
  _action: "join"
}));
const joinWithNewUser$1 = new Definition("/user/{userId}", "POST", e => {
  if (!e) return !1;
  return {
    token: new Token(e?.headers?.authorization || e?.headers?.Authorization),
    user: e.data
  };
}, null, e => ({
  client_id: e.clientId,
  code: e.code,
  first_name: e.firstName,
  last_name: e.lastName,
  password: e.password,
  password2: e.passwordConfirmation,
  _action: "join"
}));
const invite$1 = new Definition({
  path: "/user",
  method: "POST",
  requestBody: e => ({
    email: e.email,
    roles: e.roles
  })
});
const resendInvite$1 = new Definition("/user/{id}", "POST", e => e.data, null, () => ({
  _action: "send-invitation"
}));
const check2faById$1 = new Definition("/user/{id}", "POST", e => ({
  twoFactorRequired: !!e.data?.two_factor,
  hasCell: !!e.data?.has_cell
}), null, () => ({
  _action: "check-two-factor"
}));
const send2faSMS$1 = new Definition("/user/send-sms-code", "GET", e => e.data, null, e => ({
  username: e.username
}));
const login$2 = new Definition("/user/login", "POST", e => {
  if (!e) return !1;
  return {
    token: new Token(e?.headers?.authorization || e?.headers?.Authorization),
    user: e.data
  };
}, "Content-Type-Header", e => ({
  username: e.username,
  password: e.password,
  code: e.twoFactorCode,
  remember_me: e.rememberMe,
  "g-recaptcha-response": e.turnstileToken,
  recaptcha_bypass: e.turnstileBypass
}));
const forgotPassword$2 = new Definition("/user/reset-password", "POST", e => e.data);
const resetPassword$2 = new Definition("/user/{userId}", "PATCH", e => e.data, null, e => ({
  code: e.authToken,
  password: e.newPassword,
  password2: e.confirmPassword,
  two_factor_code: e.twoFactorCode,
  request_id: e.requestId,
  _action: "passwordChange"
}));
const get2faInfo$1 = new Definition("/user/two-factor", "GET", e => new TwoFactor(e.data));
const enable2fa$1 = new Definition("user/register-two-factor", "POST", e => new TwoFactor(e.data), null, e => ({
  enabled: "on",
  code: e.code,
  provider: e.provider,
  secret: e.secret
}));
const disable2fa$1 = new Definition("user/register-two-factor", "POST", e => e.data, null, e => ({
  provider: e.provider
}));
const generateBackupCodes$1 = new Definition("user/generate-backup-codes", "GET", e => e.data.backup_codes);
const signup$2 = new Definition({
  path: "/client/register",
  method: "POST",
  responseBody: e => {
    if (!e) return !1;
    return {
      token: new Token(e?.headers?.authorization || e?.headers?.Authorization),
      user: e.data
    };
  },
  requestBody: e => {
    const t = {
      first_name: e.firstName,
      last_name: e.lastName,
      email: e.email,
      password: e.password,
      phone: e.phone,
      company: e.company,
      address1: e.address1,
      address2: e.address2,
      city: e.city,
      state: e.state,
      zip: e.zip,
      country: e.country,
      self_classification: e.classification,
      agency_relation: e.agency_relation,
      marketing_emails: e.marketingEmails ? "yes" : "no",
      recaptcha_bypass: e.turnstileBypass
    };
    return e.acceptTerms && (t.accept_terms = "on"), e.turnstileToken && (t["g-recaptcha-response"] = e.turnstileToken), e.referrerId && (t.referrer_id = e.referrerId), e.gdprRestricted && (t.gdpr_restricted = e.gdprRestricted), t;
  }
});
const switchClient$1 = new Definition("/client/switch", "POST", e => {
  if (!e) return !1;
  return {
    token: new Token(e?.headers?.authorization || e?.headers?.Authorization),
    user: e.data
  };
}, null, e => ({
  client_id: e.clientId
}));
const changeDefaultClient$1 = new Definition("/user/{id}", "POST", e => {
  if (!e) return !1;
  return {
    token: new Token(e?.headers?.authorization || e?.headers?.Authorization),
    user: e.data
  };
}, null, e => ({
  _action: "set-default-client",
  client_id: e.clientId
}));
const editUser$1 = new Definition({
  path: "user/{id}",
  method: "PATCH",
  responseBody: e => e.data,
  requestBody: e => ({
    roles: e.roles,
    first_name: e.firstName,
    last_name: e.lastName,
    email: e.email,
    cell: e.cell ? `${e.cell}`.replace(/[\s()+-]/g, "") : null,
    country_code: e.countryCode,
    password: e.password,
    current_password: e.currentPassword,
    password2: e.passwordConfirm,
    two_factor_code: e.twoFactorCode
  })
});
const getSupportedCountries$1 = new Definition({
  path: "/user/get-supported-countries",
  method: "GET",
  transformParams: ({
    twoFactor: e
  }) => e ? {
    "2fa": e
  } : {},
  responseBody: e => {
    const t = [];
    return e.data?.forEach(e => {
      e.dial_codes.forEach(r => {
        t.push({
          label: `${e.name} (+${r})`,
          value: e.iso3166_1_alpha_2,
          data: e
        });
      });
    }), t;
  }
});
const testCredentials$1 = new Definition("client/test-credentials?email={email}&password={password}&accept_terms={acceptTerms}", "GET", () => null);var legacy=/*#__PURE__*/Object.freeze({__proto__:null,changeDefaultClient:changeDefaultClient$1,check2faById:check2faById$1,check2faByUsername:check2faByUsername$1,disable2fa:disable2fa$1,editUser:editUser$1,enable2fa:enable2fa$1,forgotPassword:forgotPassword$2,generateBackupCodes:generateBackupCodes$1,get2faInfo:get2faInfo$1,getSupportedCountries:getSupportedCountries$1,invite:invite$1,joinWithExistingUser:joinWithExistingUser$1,joinWithNewUser:joinWithNewUser$1,login:login$2,resendInvite:resendInvite$1,resetPassword:resetPassword$2,send2faSMS:send2faSMS$1,signup:signup$2,switchClient:switchClient$1,testCredentials:testCredentials$1});const getUser$1 = new Definition({
  path: "/api/v1/user/self",
  method: "GET",
  responseBody: e => new User(e.data)
});
const getUserSalesforceToken$1 = new Definition({
  path: "/api/v1/user/identity-token/salesforce",
  method: "GET",
  responseBody: e => e.data
});
const logout$1 = new Definition("/api/v1/logout", "POST", e => e.data);var v1=/*#__PURE__*/Object.freeze({__proto__:null,getUser:getUser$1,getUserSalesforceToken:getUserSalesforceToken$1,logout:logout$1});const {
  getUser: getUser,
  getUserSalesforceToken: getUserSalesforceToken,
  logout: logout
} = v1;
const {
  changeDefaultClient: changeDefaultClient,
  check2faById: check2faById,
  check2faByUsername: check2faByUsername,
  disable2fa: disable2fa,
  editUser: editUser,
  enable2fa: enable2fa,
  forgotPassword: forgotPassword$1,
  generateBackupCodes: generateBackupCodes,
  get2faInfo: get2faInfo,
  getSupportedCountries: getSupportedCountries,
  invite: invite,
  joinWithExistingUser: joinWithExistingUser,
  joinWithNewUser: joinWithNewUser,
  login: login$1,
  resendInvite: resendInvite,
  resetPassword: resetPassword$1,
  send2faSMS: send2faSMS,
  signup: signup$1,
  switchClient: switchClient,
  testCredentials: testCredentials
} = legacy;var user=/*#__PURE__*/Object.freeze({__proto__:null,changeDefaultClient:changeDefaultClient,check2faById:check2faById,check2faByUsername:check2faByUsername,disable2fa:disable2fa,editUser:editUser,enable2fa:enable2fa,forgotPassword:forgotPassword$1,generateBackupCodes:generateBackupCodes,get2faInfo:get2faInfo,getSupportedCountries:getSupportedCountries,getUser:getUser,getUserSalesforceToken:getUserSalesforceToken,invite:invite,joinWithExistingUser:joinWithExistingUser,joinWithNewUser:joinWithNewUser,login:login$1,logout:logout,resendInvite:resendInvite,resetPassword:resetPassword$1,send2faSMS:send2faSMS,signup:signup$1,switchClient:switchClient,testCredentials:testCredentials});const getUIFlow = new Definition({
  path: "/api/v1/flow/{id}",
  method: "GET",
  responseBody: i => i.data
});var uiFlows=/*#__PURE__*/Object.freeze({__proto__:null,getUIFlow:getUIFlow});class ACHAccount {
  constructor(t = {}) {
    this.id = void 0;
    this.identity = void 0;
    this.accountNumber = void 0;
    this.routingNumber = void 0;
    this.accountType = void 0;
    this.bankName = void 0;
    this.hasTransactions = void 0;
    this.primary = void 0;
    this.nameOnAccount = void 0;
    this.priority = void 0;
    this.type = void 0;
    this.paymentType = void 0;
    this.id = t.id, this.identity = t.identity, this.accountNumber = t.account_number, this.routingNumber = t.routing_number, this.accountType = t.account_type, this.bankName = t.bank_name, this.hasTransactions = t.has_transactions, this.primary = t.is_primary, this.nameOnAccount = t.name_on_account, this.priority = t.priority, this.type = "ACH", this.paymentType = "ach";
  }
}const getACHAccounts = new Definition({
  path: "/api/v1/ach",
  method: "GET",
  responseBody: n => ({
    list: n.data.map(n => new ACHAccount(n)),
    pagination: new Pagination(n)
  })
});var ach=/*#__PURE__*/Object.freeze({__proto__:null,getACHAccounts:getACHAccounts});const definitions = {
  ...getDomainAddons$1,
  ...addresses,
  ...allocations,
  ...announcements,
  ...apiTokens,
  ...apps,
  ...certificates,
  ...client,
  ...clouds,
  ...cloudServers,
  ...colocations,
  ...creditCards,
  ...credits,
  ...domains$1,
  ...databases,
  ...datashares,
  ...dedicatedServers,
  ...dns$1,
  ...enterpriseCloud,
  ...hud,
  ...invoices,
  ...legacyAddresses,
  ...legacySites,
  ...orders,
  ...os,
  ...others,
  ...packages,
  ...partner,
  ...passwords,
  ...payments,
  ...payPal,
  ...plans,
  ...resellerHosting,
  ...safeHarbor,
  ...settings,
  ...service$1,
  ...sharedHosts,
  ...sites,
  ...sshKeys,
  ...status,
  ...stencils,
  ...tasks,
  ...tax,
  ...team,
  ...tickets,
  ...user,
  ...uiFlows,
  ...ach
};const buildUrl = (t = null, e = null, l = "/", s = !1) => {
  const r = "http" !== l.substr(0, 4);
  let p = `${l}/${t || ""}`;
  p = p.replace(/^(http|https):\/\//g, "");
  const c = {
      ...e
    },
    n = [];
  if (e && "object" == typeof e) {
    const t = Object.keys(e);
    for (let l = 0; l < t.length; l += 1) {
      p.indexOf(`{${t[l]}}`) >= 0 && n.push(t[l]);
      const s = new RegExp(`\\{${t[l]}\\}`, "g");
      p = p.replace(s, e[t[l]]);
    }
  }
  n.forEach(t => {
    delete c[t];
  }), p = p.replace(/\/{2,3}/g, "/"), r || (p = s ? `http://${p}` : `https://${p}`);
  return "/" === p.substr(p.length - 1) && (p = p.slice(0, -1)), {
    url: p,
    params: c
  };
};const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
const getCancelToken = () => {
  const {
    CancelToken: e
  } = axios;
  return e;
};
const mergeHeaders = e => ({
  ...defaultHeaders,
  ...e
});
const setAuthResponseListener = e => {
  axios.interceptors.response.use(t => {
    const o = t?.headers?.authorization || t?.headers?.Authorization;
    return o && e(o), t;
  }, e => Promise.reject(e));
};
const setErrorResponseListener = e => axios.interceptors.response.use(null, t => (e(t), Promise.reject(t)));
const setAuthRequestHeader = e => axios.interceptors.request.use(t => {
  const o = t;
  return o.headers.Authorization = `Bearer ${e}`, o.headers["Exclude-Auth-Token"] && delete o.headers.Authorization, delete o.headers["Exclude-Auth-Token"], o;
}, e => Promise.reject(e));
const setUnAuthRequestHeader = () => axios.interceptors.request.use(e => {
  const t = e;
  return delete t.headers["Exclude-Auth-Token"], t;
}, e => Promise.reject(e));
const setMaintenanceModeResponseListener = e => {
  axios.interceptors.response.use(t => (e(!1), t), t => (e(503 === t?.response?.status), Promise.reject(t)));
};
const ejectInterceptor = e => {
  axios.interceptors.request.eject(e);
};
const setResponseTimeReporter = e => {
  axios.interceptors.request.use(e => {
    const t = e;
    return t.meta = t.meta || {}, t.meta.requestStartedAt = new Date().getTime(), t;
  }), axios.interceptors.response.use(t => (t.config?.meta?.url && e({
    category: "API Response",
    variable: `${t.config.method.toUpperCase()} ${t.config.meta.url}`,
    value: new Date().getTime() - t.config.meta.requestStartedAt
  }), t), t => {
    throw t.config?.meta?.url && e({
      category: "API Response",
      variable: `${t.config.method.toUpperCase()} ${t.config.meta.url}`,
      value: new Date().getTime() - t.config.meta.requestStartedAt
    }), t;
  });
};
const setBaseUrl = e => (axios.defaults.baseURL = e, !0);
const ACTIVE_REQUESTS = {},
  getActiveRequestKey = ({
    method: e,
    path: t
  }) => `${e}:${t}`,
  getActiveRequest = e => ACTIVE_REQUESTS[getActiveRequestKey(e)],
  saveActiveRequest = (e, t, o = {}) => {
    o.lazy && "GET" === e.method.toUpperCase() && !getActiveRequest(e) && (ACTIVE_REQUESTS[getActiveRequestKey(e)] = t);
  },
  deleteActiveRequest = e => {
    delete ACTIVE_REQUESTS[getActiveRequestKey(e)];
  };
const prepRequest = (e, t, o = {}, s = {}, r = {}, n = "/") => {
  if (!n || !e || !t) throw new Error("Requests must have a base, path, and method defined");
  const a = buildUrl(e, o, n),
    i = {
      method: t,
      url: a.url,
      data: s,
      responseType: "json",
      headers: defaultHeaders,
      ...r
    };
  return r && r.headers && (i.headers = mergeHeaders(r.headers)), i.params = a.params, i.meta = i.meta || {}, i.meta.url = e, i;
};
const direct = (e, t = {
  excludeAuthToken: !1
}) => {
  const o = {
    ...e
  };
  return o.headers || (o.headers = {}), o.headers["Exclude-Auth-Token"] = t.excludeAuthToken, axios.request(o);
};
const getDefinition = (e, t) => {
  if (!e) throw new Error("Request must have a base");
  const o = definitions[t];
  if (!t || !o) throw new Error(`No valid request definition found for request "${t}"`);
  if (!(o instanceof Definition || o instanceof GroupDefinition)) throw new Error("The definition must be one of the following classes: Definition or GroupDefinition");
  return o;
};
const make = (e, t = {}, o = {}, s = {}, r = "/") => {
  const n = getDefinition(r, e);
  if (n.validation && n.validation(o), n instanceof GroupDefinition) {
    const e = [];
    return n.definitions.forEach(n => {
      const a = getActiveRequest(n);
      if (s.lazy && a) e.push(a);else {
        const a = axios.request(prepRequest(n.path, n.method, n.transformParams(t), n.requestBody(o), s, r)).catch(e => Promise.reject(n.transformError(e))).finally(() => {
          deleteActiveRequest(n);
        });
        saveActiveRequest(n, a, s), e.push(a);
      }
    }), axios.all(e);
  }
  let a = n.headers || {};
  s && s.headers && (a = {
    ...a,
    ...s.headers
  });
  const i = getActiveRequest(n);
  if (s.lazy && i) return i;
  if (n.mocked && n.mockedResponse) return Promise.resolve(n.mockedResponse);
  const c = axios.request(prepRequest(n.path, n.method, n.transformParams(t), n.requestBody(o), {
    ...s,
    headers: a
  }, r)).catch(e => Promise.reject(n.transformError(e))).finally(() => {
    deleteActiveRequest(n);
  });
  return saveActiveRequest(n, c, s), c;
};
const makeList = e => {
  const t = [];
  return e.forEach(e => {
    const o = getDefinition(e.base || "/", e.namedRoute);
    o.validation && o.validation(e.data || {});
    const s = getActiveRequest(o);
    if (!e.options.lazy && s) t.push(s);else {
      const s = axios.request(prepRequest(o.path, o.method, o.transformParams(e.params || {}), o.requestBody(e.data || {}), e.options || {}, e.base || "/")).catch(e => Promise.reject(o.transformError(e))).finally(() => {
        deleteActiveRequest(o);
      });
      saveActiveRequest(o, s, e.options), t.push(s);
    }
  }), axios.all(t);
};
const getAllData = (e, t, o) => {
  const {
    last: s,
    total: r
  } = Pagination.parseRange(e);
  if (s < r) {
    const s = {
      ...o
    };
    return s.pageIndex = (e?.config?.params?.pageIndex || 0) + 1, Promise.resolve().then(() => make(t, s)).then(o => {
      const r = {
        ...o
      };
      return r.data = [...e.data, ...o.data], getAllData(r, t, s);
    });
  }
  return e.headers["content-range"] = `items 1-${r}/${r}`, e;
};
const makeParse = (e, t = {}, o = {}, s = {}, r = "/") => {
  const n = getDefinition(r, e);
  return make(e, t, o, s, r).then(o => {
    if ("GET" === n.method && s.getAll) {
      const s = {
        ...t
      };
      return t.pageIndex && delete s.pageIndex, getAllData(o, e, s);
    }
    return o;
  }).then(e => {
    if (n.responseBody) {
      let t;
      return t = n instanceof GroupDefinition ? n.responseBody(...e) : n.responseBody(e), t;
    }
    return e;
  });
};
const makeParseList = e => {
  const t = [];
  return e.forEach(e => t.push(getDefinition(e.base || "/", e.namedRoute))), new Promise((o, s) => {
    makeList(e).then(e => {
      const s = [];
      e.forEach((e, o) => {
        const r = t[o];
        if (r.responseBody) {
          let t;
          t = r instanceof GroupDefinition ? r.responseBody(...e) : r.responseBody(e), s.push(t);
        } else s.push(e);
      }), o(s);
    }).catch(e => {
      s(e);
    });
  });
};
const makeDownload = (e, t = {}, o = {}, s = {}, r = "/", n = "download") => {
  const a = getDefinition(r, e),
    i = prepRequest(a.path, a.method, t, o, s, r);
  return new Promise((e, t) => {
    axios.get(i.url, {
      responseType: "blob"
    }).then(t => {
      const o = new Blob([t.data], {
          type: t?.headers?.["content-type"]
        }),
        s = document.createElement("a");
      s.href = URL.createObjectURL(o), s.download = n, s.click(), URL.revokeObjectURL(s.href), e("downloaded");
    }).catch(e => {
      t(e);
    });
  });
};var service=/*#__PURE__*/Object.freeze({__proto__:null,direct:direct,ejectInterceptor:ejectInterceptor,getCancelToken:getCancelToken,make:make,makeDownload:makeDownload,makeList:makeList,makeParse:makeParse,makeParseList:makeParseList,prepRequest:prepRequest,setAuthRequestHeader:setAuthRequestHeader,setAuthResponseListener:setAuthResponseListener,setBaseUrl:setBaseUrl,setErrorResponseListener:setErrorResponseListener,setMaintenanceModeResponseListener:setMaintenanceModeResponseListener,setResponseTimeReporter:setResponseTimeReporter,setUnAuthRequestHeader:setUnAuthRequestHeader});var index$2 = {
  definition: definition,
  groupDefinition: groupDefinition,
  HTTPError: HTTPError$1,
  Pagination: Pagination$1
};var classes=/*#__PURE__*/Object.freeze({__proto__:null,default:index$2});var index$1 = {
  definitions: definitions,
  buildUrl: buildUrl,
  classes: classes,
  ...service
};const domain = r => {
  if (!r) return !0;
  if (!regex(/^(?:[A-Za-z0-9]+(?:-*[A-Za-z0-9])*\.)+[^0-9-][A-Za-z0-9-]{1,}$/)(r)) return !1;
  if ("string" != typeof r) return !1;
  const e = r.split(".");
  if (e.length <= 1) return !1;
  const t = e.pop();
  return !!regex(/^[a-zA-Z0-9]+$/gi)(t) && e.every(r => regex(/^(?!:\/\/)([a-zA-Z0-9]+|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])$/gi)(r));
};
const domains = r => {
  if (!r) return !0;
  const e = r.split("\n");
  for (let r = 0; r < e.length; r += 1) {
    if (!domain(e[r])) return !1;
  }
  return !0;
};
const wildcardDomain = r => {
  if (!r) return !0;
  if (!regex(/^\*\.(?:[A-Za-z0-9]+(?:-*[A-Za-z0-9])*\.)+[^0-9-][A-Za-z0-9-]{1,}$/)(r)) return !1;
  if ("string" != typeof r) return !1;
  const e = r.split(".");
  if (e.length <= 1) return !1;
  const t = e.pop();
  return !!regex(/^[a-zA-Z0-9]+$/gi)(t) && e.every(r => regex(/^(?=.)[A-Za-z-\d]*\*?[A-Za-z-\d]*$/gi)(r));
};const phone = async e => {
  if (!e) return !0;
  try {
    const r = `${e}`.replace(/[\s()+-]/g, "");
    return await makeParse("validatePhone", {
      phone: r
    }), !0;
  } catch (e) {
    return !1;
  }
};const cardExpirationDate = r => !r || regex(/^[0-9]{2}\/2[0-9]{3}$/)(r);const creditCard = r => !r || regex(/^\b(?:\d[ -]*?){13,16}\b$/)(r);const cvv = e => !e || regex(/^[0-9]{3,4}$/)(e);const dnsDomainName = a => regex(/^(([a-zA-Z0-9_]|[a-zA-Z0-9_][a-zA-Z0-9-_]*[a-zA-Z0-9_])\.)*([A-Za-z0-9_]|[A-Za-z0-9_][A-Za-z0-9-_]*[A-Za-z0-9_])$/)(a);const emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/,
  email = regex(emailRegex),
  emailList = e => {
    if (!e) return !0;
    let t = e;
    "string" == typeof e && (t = e.split("\n").map(e => e.trim()));
    for (let e = 0; e < t.length; e += 1) {
      const i = !t[e],
        r = !email(t[e]);
      if (i || r) return !1;
    }
    return !0;
  };const equal = e => a => e === a;const integer = e => {
  if (!e) return !0;
  const r = Number(e);
  return !Number.isNaN(r) && Number.isInteger(r);
};const notEqual = o => t => o !== t;const hostname = a => regex(/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/)(a);const ipAddress = e => regex(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/)(e);const ipv6Address = f => regex(/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/)(f);const length = r => e => Array.isArray(e) ? e.length >= r : len(e) === r;const matchField = (t, e) => (c, n) => {
  const o = typeof e,
    a = n?.[t].value;
  return "function" === o && !e(c, n) || a === c;
};const min = r => e => {
    if (!e) return !0;
    const n = Number(e);
    return !Number.isNaN(n) && n >= r;
  },
  max = r => e => {
    if (!e) return !0;
    const n = Number(e);
    return !Number.isNaN(n) && n <= r;
  },
  range = (r, e) => n => {
    if (!n) return !0;
    const u = Number(n);
    return !Number.isNaN(u) && u >= r && u <= e;
  };const notMatchField = t => (e, n) => {
  const o = n?.[t].value;
  return o !== e;
};const required = r => req("string" == typeof r ? r.trim() : r);const validate$1 = (r, e) => !r || req(e),
  requiredIf = (r, e) => (a, t) => {
    const i = typeof r;
    return validate$1("function" === i ? r() : "string" === i ? e ? Array.isArray(e) ? e.includes(t?.[r].value) : t?.[r].value === e : t?.[r].value : r, a);
  };const validate = (e, r) => !e || req(r),
  requiredUnless = e => (r, t) => {
    const n = typeof e;
    return validate("function" === n ? !e() : "string" === n ? !t?.[e].value : !e, r);
  };const minChars = r => t => {
  if (!t) return !0;
  return "string" == typeof t && t.length >= r;
};
const maxChars = r => t => {
  if (!t) return !0;
  return "string" == typeof t && t.length <= r;
};var rules=/*#__PURE__*/Object.freeze({__proto__:null,cardExpirationDate:cardExpirationDate,creditCard:creditCard,cvv:cvv,dnsDomainName:dnsDomainName,domain:domain,domains:domains,email:email,emailList:emailList,equal:equal,hostname:hostname,integer:integer,ipAddress:ipAddress,ipv6Address:ipv6Address,length:length,matchField:matchField,max:max,maxChars:maxChars,min:min,minChars:minChars,notEqual:notEqual,notMatchField:notMatchField,phone:phone,range:range,required:required,requiredIf:requiredIf,requiredUnless:requiredUnless,taxExempt:taxExempt,wildcardDomain:wildcardDomain});const addSite = {
  installApp: {
    required: required
  },
  name: {
    required: required
  },
  planId: {
    required: required
  }
};
const addSiteCron = {
  frequency: {
    required: required
  },
  script: {
    required: required
  }
};
const addSiteFromStencil = {
  name: {
    required: required
  },
  stencilId: {
    required: required
  }
};
const addSiteNewRelicKey = {
  key: {
    required: required
  }
};
const addSiteSecondary = {
  appId: {
    required: required
  },
  name: {
    required: required
  }
};
const enableSiteAdvancedAutoScale = {
  addonId: {
    required: required
  },
  version: {
    required: required
  },
  scale: {
    required: required
  }
};
const updateSiteCronOptions = {
  path: {
    required: required
  },
  mailTo: {
    email: email
  }
};
const updateSiteDomain = {
  domain: {
    domain: domain,
    required: required
  }
};
const updateSiteName = {
  name: {
    required: required,
    length: maxChars(100)
  }
};const addPartnerLink = {
  name: {
    required: required
  },
  target: {
    required: required
  },
  status: {
    required: required
  }
};const addStencil = {
  name: {
    required: required
  },
  siteId: {
    required: required
  }
};const apiToken = {
  name: {
    required: required
  }
};const checkoutBilling = {
  firstName: {
    required: required
  },
  lastName: {
    required: required
  },
  phone: {
    required: required,
    integer: integer
  },
  address1: {
    required: required
  },
  city: {
    required: required
  },
  state: {
    required: required,
    regex: regex(/^[A-Z]{2}$/)
  },
  zip: {
    required: required
  },
  country: {
    required: required,
    regex: regex(/^[A-Z]{2}$/)
  },
  isTaxExempt: {},
  taxId: {
    requiredIf: requiredIf("isTaxExempt"),
    taxExempt: taxExempt("country")
  }
};const addEmail = {
  email: {
    email: email
  }
};const storeBuilder = {
  industry: {
    required: required
  },
  alreadySelling: {
    required: required
  },
  currentPlatform: {
    requiredIf: requiredIf("alreadySelling", "selling_online_different_platform")
  },
  howSell: {
    requiredIf: requiredIf("alreadySelling")
  },
  catalogSize: {
    required: required
  }
};const checkoutPackageSelection = {
  packageId: {
    required: required
  }
};const checkoutServerDetails = {
  locationId: {
    required: required
  }
};const createFtpUser = {
  confirmPassword: {
    required: required,
    matchField: matchField("password")
  },
  homeDir: {
    required: required
  },
  password: {
    minChars: minChars(12),
    required: required,
    matchField: matchField("confirmPassword", (r, e) => e.confirmPassword.value)
  },
  username: {
    required: required
  }
};
const updateFtpUser = {
  confirmPassword: {
    required: required,
    matchField: matchField("password")
  },
  homeDir: {},
  password: {
    minChars: minChars(12),
    required: required,
    matchField: matchField("confirmPassword", (r, e) => e.confirmPassword.value)
  }
};const wizardStoreBuilderSurvey = {
  firstName: {
    required: required
  },
  lastName: {
    required: required
  },
  email: {
    required: required,
    email: email
  },
  who: {
    required: required
  },
  experience: {
    required: required
  }
};const addSiteEmailAlias = {
  username: {
    required: required
  },
  members: {
    required: required,
    emailList: emailList
  }
};const addSiteEmailBox = {
  storage: {
    requiredUnless: requiredUnless("unlimited"),
    integer: integer,
    min: min(1),
    max: max(999999999)
  },
  unlimited: {},
  username: {
    required: required
  }
};const addSiteEmailResponder = {
  username: {
    required: required
  },
  ccEmailResponder: {
    emailList: emailList
  },
  emailMessage: {
    required: required
  }
};const installCertificate = {
  certificateId: {},
  key: {
    requiredUnless: requiredUnless("certificateId")
  },
  certificate: {
    requiredUnless: requiredUnless("certificateId")
  },
  chain: {}
};const checkoutCreateProfile = {
  firstName: {
    required: required
  },
  lastName: {
    required: required
  },
  email: {
    required: required,
    email: email
  },
  password: {
    required: required
  },
  acceptTerms: {
    isTruthy: isTruthy
  }
};const addDbWithuser = {
  dbName: {
    required: required
  },
  username: {
    required: required,
    length: maxChars(7)
  }
};
const addDb = {
  dbName: {
    required: required
  }
};
const addDbUser = {
  name: {
    required: required,
    length: maxChars(7)
  }
};const addDnsZone = {
  domain: {
    domain: domain,
    required: required
  }
};
const addDnsZoneARecord = {
  hostname: {
    dnsDomainName: dnsDomainName,
    required: required
  },
  ipAddress: {
    ipAddress: ipAddress,
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneAAAARecord = {
  hostname: {
    dnsDomainName: dnsDomainName,
    required: required
  },
  ipv6Address: {
    ipv6Address: ipv6Address,
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneAliasRecord = {
  hostname: {
    dnsDomainName: dnsDomainName,
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneCaaRecord = {
  hostname: {
    dnsDomainName: dnsDomainName,
    required: required
  },
  flag: {
    required: required,
    regex: regex(/^\d+$/)
  },
  tag: {
    required: required
  },
  value: {
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneCnameRecord = {
  aliasTo: {
    required: required
  },
  hostname: {
    dnsDomainName: dnsDomainName,
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneMxRecord = {
  mailServer: {
    hostname: hostname,
    required: required
  },
  subdomain: {
    hostname: hostname
  },
  preference: {
    required: required,
    regex: regex(/^\d+$/)
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneNsRecord = {
  nameServer: {
    hostname: hostname,
    required: required
  },
  subdomain: {
    hostname: hostname,
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneSrvRecord = {
  service: {
    required: required,
    regex: regex(/^(?!_).*$/)
  },
  protocol: {
    required: required,
    regex: regex(/^(?!_).*$/)
  },
  priority: {
    required: required,
    regex: regex(/^\d+$/)
  },
  weight: {
    required: required,
    regex: regex(/^\d+$/)
  },
  port: {
    required: required,
    regex: regex(/^\d+$/)
  },
  target: {
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addDnsZoneTxtRecord = {
  hostname: {
    dnsDomainName: dnsDomainName,
    required: required
  },
  value: {
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};
const addRdnsRecord = {
  hostname: {
    hostname: hostname,
    required: required
  },
  ipAddress: {
    ipAddress: ipAddress,
    required: required
  },
  ttl: {
    required: required,
    regex: regex(/^\d+$/)
  }
};const login = {
  email: {
    required: required
  },
  password: {
    required: required
  },
  twoFactorRequired: {},
  twoFactorCode: {
    requiredIf: requiredIf("twoFactorRequired"),
    regex: regex(/^[0-9]{6}$/)
  }
};const migrationContact = {
  name: {
    required: required,
    length: regex(/^.{1,128}$/)
  },
  email: {
    required: required,
    email: email
  },
  phone: {
    required: required,
    phone: phone
  },
  destination: {
    required: required
  },
  reason: {
    required: required
  },
  recommendedBy: {
    requiredIf: requiredIf("reason", "Recommended by:")
  }
};
const migrationSite = {
  website: {
    required: required
  },
  migrate_from: {
    required: required
  },
  migrate_from_other: {
    requiredIf: requiredIf("migrate_from", "Other")
  },
  hosting_access: {
    required: required
  },
  application_type: {
    required: required
  },
  application_type_other: {
    requiredIf: requiredIf("application_type", "Other")
  },
  multisite_configuration: {
    requiredIf: (e, r) => "Yes" !== r?.multisite.value || !["WordPress", "WooCommerce"].includes(r?.application_type.value) || !!e
  },
  outside_files_locations: {
    requiredIf: requiredIf("outside_files", "Yes")
  },
  dns_hosted: {
    required: required
  },
  special_requirements: {
    maxChars: maxChars(2e3)
  }
};const signup = {
  firstName: {
    required: required
  },
  lastName: {
    required: required
  },
  email: {
    required: required,
    email: email
  },
  password: {
    minChars: minChars(12),
    required: required
  },
  acceptTerms: {
    equal: equal(!0)
  }
};
const userCreateOnJoin = {
  firstName: {
    required: required
  },
  lastName: {
    required: required
  },
  password: {
    required: required
  },
  acceptTerms: {
    equal: equal(!0)
  }
};const teamMemberAdd = {
    email: {
      required: required,
      email: email
    },
    teams: {
      length: length(1)
    }
  },
  teamMemberEdit = {
    teams: {
      length: length(1)
    }
  },
  teamAdd = {
    name: {
      required: required,
      maxChars: maxChars(25)
    }
  };const checkoutPlanDetails = {
  domain: {
    required: required,
    domain: domain
  },
  locationId: {
    required: required
  },
  nickname: {
    required: required
  },
  hasBigCommerce: {
    required: required
  },
  bigCommerceApiUrl: {
    requiredIf: requiredIf("hasBigCommerce")
  },
  bigCommerceClientId: {
    requiredIf: requiredIf("hasBigCommerce")
  },
  bigCommerceClientSecret: {
    requiredIf: requiredIf("hasBigCommerce")
  },
  bigCommerceAccessToken: {
    requiredIf: requiredIf("hasBigCommerce")
  }
};const editAddress = {
  firstName: {
    required: required
  },
  lastName: {
    required: required
  },
  email: {
    required: required,
    email: email
  },
  phone: {
    required: required,
    phone: phone
  },
  address1: {
    required: required
  },
  city: {
    required: required
  },
  state: {
    requiredIf: requiredIf("country", [null, "US", "AF", "AX", "AL", "DZ", "AS", "AD", "AO", "AI", "AQ", "AG", "AR", "AM", "AW", "AU", "AT", "AZ", "BS", "BH", "BD", "BB", "BY", "BE", "BZ", "BJ", "BM", "BT", "BO", "BA", "BW", "BV", "BR", "IO", "BN", "BG", "BF", "BI", "KH", "CM", "CA", "CV", "KY", "CF", "TD", "CL", "CN", "CX", "CC", "CO", "KM", "CG", "CD", "CK", "CR", "CI", "HR", "CU", "CY", "CZ", "DK", "DJ", "DM", "DO", "EC", "EG", "SV", "GQ", "ER", "EE", "ET", "FK", "FO", "FJ", "FI", "FR", "GF", "PF", "TF", "GA", "GM", "GE", "DE", "GH", "GI", "GR", "GL", "GD", "GP", "GU", "GT", "GG", "GN", "GW", "GY", "HT", "HM", "VA", "HN", "HK", "HU", "IS", "IN", "ID", "IR", "IQ", "IE", "IM", "IL", "IT", "JM", "JP", "JE", "JO", "KZ", "KE", "KI", "KP", "KR", "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY", "LI", "LT", "LU", "MO", "MK", "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MQ", "MR", "MU", "YT", "MX", "FM", "MD", "MC", "MN", "ME", "MS", "MA", "MZ", "MM", "NA", "NR", "NP", "NL", "NC", "NZ", "NI", "NE", "NG", "NU", "NF", "MP", "NO", "OM", "PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH", "PN", "PL", "PT", "PR", "QA", "RE", "RO", "RU", "RW", "BL", "SH", "KN", "LC", "MF", "PM", "VC", "WS", "SM", "ST", "SA", "SN", "RS", "SC", "SL", "SG", "SK", "SI", "SB", "SO", "ZA", "GS", "ES", "LK", "SD", "SR", "SJ", "SZ", "SE", "CH", "SY", "TW", "TJ", "TZ", "TH", "TL", "TG", "TK", "TO", "TT", "TN", "TR", "TM", "TC", "TV", "UG", "UA", "AE", "UM", "UY", "UZ", "VU", "VE", "VN", "VG", "VI", "WF", "EH", "YE", "ZM", "ZW"])
  },
  zip: {
    required: required
  },
  country: {
    required: required
  }
};const editCreditCard = {
  expirationMonth: {
    required: required,
    regex: regex(/^(0[1-9]|1[012])$/)
  },
  expirationYear: {
    required: required,
    regex: regex(/^[0-9]{4}$/)
  }
};
const addCreditCard = {
  number: {
    required: required,
    regex: regex(/^\b(?:\d[ -]*?){13,16}\b$/)
  },
  expirationMonth: {
    required: required,
    regex: regex(/^(0[1-9]|1[012])$/)
  },
  expirationYear: {
    required: required,
    regex: regex(/^[0-9]{4}$/)
  },
  csv: {
    required: required,
    regex: regex(/^[0-9]{3,4}$/)
  }
};const cloudServerResize = {
  packageId: {
    required: required
  }
};
const cloudServerAdd = {
  locationId: {
    required: required
  },
  packageId: {
    required: required
  },
  hostname: {
    required: required
  }
};const creditRedeem = {
  name: {
    required: required
  }
};const editDefaultPayment = {
  type: {
    required: required
  }
};const editPin = {
  name: {
    required: required
  }
};const editClient = {
  clientName: {
    required: required
  }
};const enableElasticsearch = {
  typeId: {
    required: required
  },
  versionId: {
    required: required
  }
};const generateCsr = {
  country: {
    required: required
  },
  domain: {
    domains: domains,
    required: required
  },
  email: {
    email: email,
    required: required
  },
  locality: {
    required: required
  },
  organization: {
    required: required
  },
  organizational_unit: {
    required: required
  },
  state: {
    required: required
  },
  street: {
    required: required
  }
};
const generateWildcardCsr = {
  country: {
    required: required
  },
  domain: {
    wildcardDomain: wildcardDomain,
    required: required
  },
  email: {
    email: email,
    required: required
  },
  locality: {
    required: required
  },
  organization: {
    required: required
  },
  organizational_unit: {
    required: required
  },
  state: {
    required: required
  },
  street: {
    required: required
  }
};
const importCsr = {
  csr: {
    required: required
  },
  key: {
    required: required
  }
};
const importSsl = {
  crt: {
    required: required
  },
  key: {
    required: required
  }
};
const orderSsl = {
  package_id: {
    required: required,
    regex: regex(/\d+/)
  }
};const partnerPaymentPayPal = {
  address: {
    email: email,
    required: required
  }
};
const partnerPaymentWireTransfer = {
  payeeName: {
    required: required
  },
  payeePhone: {
    phone: phone,
    required: required
  },
  payeeEmail: {
    email: email,
    required: required
  },
  payeeAddress: {
    required: required
  },
  bankName: {
    required: required
  },
  bankAddress: {
    required: required
  },
  bankAccountName: {
    required: required
  },
  bankAccountNumber: {
    required: required
  },
  bankRoutingNumber: {
    required: required
  },
  bankAccountType: {
    required: required
  }
};const addPayment = {
  paymentMethod: {
    required: required
  },
  creditCardRequired: {},
  creditCardCvvRequired: {},
  creditCardDetailsRequired: {},
  creditCard: {
    requiredIf: requiredIf("creditCardRequired")
  },
  creditCardNumber: {
    creditCard: creditCard,
    requiredIf: requiredIf("creditCardDetailsRequired")
  },
  cardExpirationDate: {
    cardExpirationDate: cardExpirationDate,
    requiredIf: requiredIf("creditCardDetailsRequired")
  },
  cvv: {
    cvv: cvv,
    requiredIf: requiredIf("creditCardCvvRequired")
  }
};const planUpdateName = {
  name: {
    required: required,
    length: regex(/^.{1,128}$/)
  }
};
const planUpdateTerm = {
  term: {
    required: required
  }
};
const planUpgrade = {
  packageId: {
    required: required
  }
};
const planCancellation = e => e.reduce((e, r) => {
  const n = {
    required: required
  };
  return "int" === r.cast && (n.integer = integer, void 0 !== r.min && void 0 !== r.max && (n.range = range(r.min, r.max))), {
    ...e,
    [r.id]: n
  };
}, {});const forgotPassword = {
  email: {
    required: required,
    email: email
  }
};const twoFactor = {
  authenticationCode: {
    required: required,
    regex: regex(/^[0-9]{6}$/)
  }
};const resetPassword = {
  newPassword: {
    required: required,
    matchField: matchField("confirmPassword", (r, e) => e.confirmPassword.value)
  },
  confirmPassword: {
    required: required,
    matchField: matchField("newPassword")
  },
  twoFactorRequired: {},
  twoFactorCode: {
    requiredIf: requiredIf("twoFactorRequired"),
    regex: regex(/^[0-9]{6}$/)
  }
};const sshKey = {
  name: {
    required: required
  },
  key: {
    required: required
  }
};const requestHelp = {
  budget: {
    required: required
  },
  description: {
    required: required
  }
};const sample = {
  field1: {
    required: required
  },
  field2: {
    required: required,
    email: email
  },
  field3: {
    requiredIf: requiredIf("field1")
  },
  field4: {
    requiredIf: requiredIf(!0)
  },
  field5: {
    requiredIf: requiredIf(() => !0)
  },
  field6: {
    email: email
  },
  field7: {
    requiredUnless: requiredUnless("field1")
  },
  taxExemptBool: {},
  taxCountry: {
    required: required
  },
  taxId: {
    requiredIf: requiredIf("taxExemptBool"),
    taxExempt: taxExempt("taxCountry")
  }
};const ticketQuickReply = {
  body: {
    required: required
  }
};
const addTicket = {
  department: {
    required: required
  },
  subject: {
    required: required,
    minChars: minChars(2),
    maxChars: maxChars(250)
  },
  reply: {
    required: required,
    minChars: minChars(2),
    maxChars: maxChars(4e3)
  },
  domain: {
    domain: domain
  },
  phoneOther: {
    phone: phone
  }
};
const verifyTicket = {
  client: {
    required: required
  }
};
const addTicketFeedback = {
  rating: {
    required: required
  }
};const updateReverseDns = {
  target: {
    required: required
  }
};const userInfo = {
    countryCode: {
      requiredIf: requiredIf("cell")
    },
    cell: {
      required: required,
      phone: phone
    }
  },
  userEmail = {
    email: {
      email: email,
      required: required
    },
    currentPassword: {
      required: required
    },
    twoFactorRequired: {},
    twoFactorCode: {
      requiredIf: requiredIf("twoFactorRequired"),
      regex: regex(/^[0-9]{6}$/)
    }
  },
  userPassword = {
    currentPassword: {
      required: required
    },
    password: {
      required: required
    },
    passwordConfirm: {
      requiredIf: requiredIf("password"),
      matchField: matchField("password")
    },
    twoFactorRequired: {},
    twoFactorCode: {
      requiredIf: requiredIf("twoFactorRequired"),
      regex: regex(/^[0-9]{6}$/)
    }
  },
  userDefaultClient = {
    clientId: {
      required: required
    }
  };const activateCloudflare = {
  addonId: {
    required: required
  }
};
const updateCloudflareSettings = {
  securityLevel: {
    required: required
  }
};const activateDesignServices = {
  addonId: {
    required: required
  }
};const activateSiteKeep = {
  addonId: {
    required: required
  }
};var forms=/*#__PURE__*/Object.freeze({__proto__:null,activateCloudflare:activateCloudflare,activateDesignServices:activateDesignServices,activateSiteKeep:activateSiteKeep,addCreditCard:addCreditCard,addDb:addDb,addDbUser:addDbUser,addDbWithuser:addDbWithuser,addDnsZone:addDnsZone,addDnsZoneAAAARecord:addDnsZoneAAAARecord,addDnsZoneARecord:addDnsZoneARecord,addDnsZoneAliasRecord:addDnsZoneAliasRecord,addDnsZoneCaaRecord:addDnsZoneCaaRecord,addDnsZoneCnameRecord:addDnsZoneCnameRecord,addDnsZoneMxRecord:addDnsZoneMxRecord,addDnsZoneNsRecord:addDnsZoneNsRecord,addDnsZoneSrvRecord:addDnsZoneSrvRecord,addDnsZoneTxtRecord:addDnsZoneTxtRecord,addEmail:addEmail,addPartnerLink:addPartnerLink,addPayment:addPayment,addRdnsRecord:addRdnsRecord,addSite:addSite,addSiteCron:addSiteCron,addSiteEmailAlias:addSiteEmailAlias,addSiteEmailBox:addSiteEmailBox,addSiteEmailResponder:addSiteEmailResponder,addSiteFromStencil:addSiteFromStencil,addSiteNewRelicKey:addSiteNewRelicKey,addSiteSecondary:addSiteSecondary,addStencil:addStencil,addTicket:addTicket,addTicketFeedback:addTicketFeedback,apiToken:apiToken,checkoutBilling:checkoutBilling,checkoutCreateProfile:checkoutCreateProfile,checkoutPackageSelection:checkoutPackageSelection,checkoutPlanDetails:checkoutPlanDetails,checkoutServerDetails:checkoutServerDetails,cloudServerAdd:cloudServerAdd,cloudServerResize:cloudServerResize,createFtpUser:createFtpUser,creditRedeem:creditRedeem,editAddress:editAddress,editClient:editClient,editCreditCard:editCreditCard,editDefaultPayment:editDefaultPayment,editPin:editPin,enableElasticsearch:enableElasticsearch,enableSiteAdvancedAutoScale:enableSiteAdvancedAutoScale,forgotPassword:forgotPassword,generateCsr:generateCsr,generateWildcardCsr:generateWildcardCsr,importCsr:importCsr,importSsl:importSsl,installCertificate:installCertificate,login:login,migrationContact:migrationContact,migrationSite:migrationSite,orderSsl:orderSsl,partnerPaymentPayPal:partnerPaymentPayPal,partnerPaymentWireTransfer:partnerPaymentWireTransfer,planCancellation:planCancellation,planUpdateName:planUpdateName,planUpdateTerm:planUpdateTerm,planUpgrade:planUpgrade,requestHelp:requestHelp,resetPassword:resetPassword,sample:sample,signup:signup,sshKey:sshKey,storeBuilder:storeBuilder,teamAdd:teamAdd,teamMemberAdd:teamMemberAdd,teamMemberEdit:teamMemberEdit,ticketQuickReply:ticketQuickReply,twoFactor:twoFactor,updateCloudflareSettings:updateCloudflareSettings,updateFtpUser:updateFtpUser,updateReverseDns:updateReverseDns,updateSiteCronOptions:updateSiteCronOptions,updateSiteDomain:updateSiteDomain,updateSiteName:updateSiteName,userCreateOnJoin:userCreateOnJoin,userDefaultClient:userDefaultClient,userEmail:userEmail,userInfo:userInfo,userPassword:userPassword,verifyTicket:verifyTicket,wizardStoreBuilderSurvey:wizardStoreBuilderSurvey});var index = {
  forms: forms,
  rules: rules
};export{index$6 as auth,index$5 as formatters,index$3 as models,index$4 as nav,index$1 as request,index as validations};